import React, { Component } from 'react';
import { Button, Icon , Input, Steps } from 'antd';
import moment from 'moment';
import ReactGA from 'react-ga';
import PlacesAutocomplete from 'react-places-autocomplete';

import customizeCss from './customizeCss';

import StripeContainer from './StripeContainer2';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import iziToast from 'izitoast';

// HELPERS
import addAnalytics from './_helpers/addAnalytics';
import createBann from './_helpers/createBann';

// INIT
library.add(faCheck);

// HOSTS and URLS INIT
const hostReturned = returnHost();
let urlDocReturned = returnDocumentURL();

let lang = "FR"; // FR ou EN
checkLang();

// LOADED VARS
const backVars = JSON.parse(sessionStorage.getItem("backVars_" + hostReturned));
const IP_IS_ADMIN = backVars.IP_IS_ADMIN;
const IP_ADDRESS = backVars.IP_ADDRESS;
const URL_CONFIG = backVars.URL_CONFIG;
const TXTS_FILE = JSON.parse(backVars.TXTS_FILE);
cl(["TXTS_FILE", TXTS_FILE]);

const hostSelect = sessionStorage.getItem("hostSelect_test_" + hostReturned)? JSON.parse(sessionStorage.getItem("hostSelect_test_" + hostReturned)) : JSON.parse(sessionStorage.getItem("hostSelect_" + hostReturned));

// DEBUG
if (IP_IS_ADMIN && sessionStorage.getItem("gustave-mode") && sessionStorage.getItem("gustave-mode") === "debug" && hostSelect.mode !== "test") {
	hostSelect.mode = "test";
}

if (hostSelect.banniere) {
	const bannTxt = hostSelect.bannTxt? hostSelect.bannTxt[lang] : (lang === "FR"? 'Nouveau service : essayez vos articles chez vous sans avancer un euro !' : 'New service: try your items at home without advancing a euro!');
	createBann("show", bannTxt, hostReturned);
}

// APP URLS
const URL_BACK = {
	test: 'https://mercigustave-node-test.herokuapp.com',
	prod: 'https://mercigustave-node.herokuapp.com'
};

// APP INIT
const dateVersion = '11-03-20';

const Step = Steps.Step;
let lastStep = null;
let steps = [
	{ order: 0, title: 'cartTitle', content: 'First-content' },
	{ order: 1, title: 'infosTitle', content: 'Second-content' },
	{ order: 2, title: 'validTitle', content: 'Last-content' }
];
let productScrap = {name: null, id: null, image: null, color: null, size: null, quantity: 1, price: null, status: true, options: null, options2: [], url: null, info: null, date: null, classInfo: "cab-info"};
let saveInfos = {
	workflowStep: '0',
	orderStep : 0,
	familyName: null,
	firstName: null,
	email: null,
	phoneNumber: null
}
let maxProductNumberRef = 6;
let infosManquantes = false;
let cabDynInterval = null;
let btnsQuantityDisabled = false;

//let isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const iosLoad = isIos && (hostReturned==='flairisfrench.com' || hostReturned==='fr.perus.co' || hostReturned==="dianavaradi.com");
let eventOkFor = [];
let showCart = "none";
let block = "none";
let ip = null;
// DELIVERY INIT
let gustaveJson = null;
let villesOk = null;

const searchOptions = { componentRestrictions: {country: "fr" } };
let autoSuggGoogleMaps = true;
let pageProduct = false;
let commandForSc = sessionStorage.getItem("commandForSc")? JSON.parse(sessionStorage.getItem("commandForSc")) : null;
const slideView = [
	'/ SLIDE Comment ça marche',
	'/ SLIDE Cabine',
	'/ SLIDE Infos',
	'/ SLIDE Paiement'
];
const initReactGAhost = [
	{ trackingId: 'UA-133465059-37', gaOptions: { name: 'theethiquette' } },
	{ trackingId: 'UA-133465059-35', gaOptions: { name: 'lpmbparis' } },
	{ trackingId: 'UA-133465059-34', gaOptions: { name: 'salutbeaute' } },
	{ trackingId: 'UA-133465059-33', gaOptions: { name: 'bleutango' } },
	{ trackingId: 'UA-133465059-32', gaOptions: { name: 'okanstudio' } },
	{ trackingId: 'UA-133465059-31', gaOptions: { name: 'poetiqueparis' } },
	{ trackingId: 'UA-133465059-30', gaOptions: { name: '9aminparis' } },
	{ trackingId: 'UA-133465059-29', gaOptions: { name: 'lespetitesambitieuses' } },
	{ trackingId: 'UA-133465059-28', gaOptions: { name: 'nolenca' } },
	{ trackingId: 'UA-133465059-27', gaOptions: { name: 'facetofaceparis' } },
	{ trackingId: 'UA-133465059-26', gaOptions: { name: 'manoush' } },
	{ trackingId: 'UA-133465059-25', gaOptions: { name: 'adnparis' } },
	{ trackingId: 'UA-133465059-24', gaOptions: { name: 'gilis' } },
	{ trackingId: 'UA-133465059-23', gaOptions: { name: 'balsaleather' } },
	{ trackingId: 'UA-133465059-22', gaOptions: { name: 'dianavaradi' } },
	{ trackingId: 'UA-133465059-21', gaOptions: { name: 'editionsmr' } },
	{ trackingId: 'UA-133465059-20', gaOptions: { name: 'affrenchies' } },
	{ trackingId: 'UA-133465059-19', gaOptions: { name: 'lauralaval' } },
	{ trackingId: 'UA-133465059-18', gaOptions: { name: 'othparis' } },
	{ trackingId: 'UA-133465059-16', gaOptions: { name: 'aujuste' } },
	{ trackingId: 'UA-133465059-15', gaOptions: { name: 'gangofearlybirds' } },
	{ trackingId: 'UA-133465059-14', gaOptions: { name: 'karinelecchi' } },
	{ trackingId: 'UA-133465059-13', gaOptions: { name: 'perus' } },
	{ trackingId: 'UA-133465059-12', gaOptions: { name: 'communedeparis1871' } },
	{ trackingId: 'UA-133465059-11', gaOptions: { name: 'lesjuponsdelouison' } },
	{ trackingId: 'UA-133465059-10', gaOptions: { name: 'wibesstore' } },
	{ trackingId: 'UA-133465059-5', gaOptions: { name: 'fraicheparis' } },
	{ trackingId: 'UA-133465059-4', gaOptions: { name: 'camilleveganbags' } },
	{ trackingId: 'UA-133465059-6', gaOptions: { name: 'unxparis' } },
	{ trackingId: 'UA-133465059-7', gaOptions: { name: 'lesgarconsfaciles' } },
	{ trackingId: 'UA-133465059-8', gaOptions: { name: 'flairisfrench' } },
	{ trackingId: 'UA-133465059-9', gaOptions: { name: '17h10' } }
];

let domRoot = document.querySelector("body");
if(document.querySelector("#gRoot") && document.querySelector("#gRoot").shadowRoot) domRoot = document.querySelector("#gRoot").shadowRoot;
else if(document.querySelector("#gRoot")) domRoot = document.querySelector("#gRoot");

const ifIsShopify = hostSelect.shopify;
let observerJson = {};
let waitingSynchro = false;
cl("widget mode : " + hostSelect.mode + " - URL_CONFIG : " + (URL_CONFIG? URL_CONFIG : "OLD ROUTE"));

displayBlock();

function cl(view) {
	if ((hostSelect && hostSelect.mode === "test") || IP_IS_ADMIN) {
		if(Array.isArray(view)) view.forEach(el=>console.log(el));
		else console.log(view);
	}
}
function displayBlock() { // Type de display du try-btn selon host
	showCart = "block";
	if(hostReturned === 'www.manoush.com') block = "inline-block";
	else if(hostReturned === 'www.karinelecchi.com' || hostReturned === "www.lauralavalparis.com" || hostReturned === "lespetitesambitieuses.com") block = "flex";
	else if(hostReturned === "mikedev75.myshopify.com") block = "flex";
	else block = "block";
}
function returnHost() {
	if(window.location.host==="www.maisonkitsune.com") return window.location.host.replace("www.", "");
	else if(window.location.host==="www.perus.co") return window.location.host.replace("www.", "fr.");
	else if(window.location.host==="es.perus.co") return window.location.host.replace("es.", "fr.");
	else if(window.location.host==="en.gilis.com") return window.location.host.replace("en.", "fr.");
	else if(window.location.host==="the-ethiquette.com") return "www.the-ethiquette.com";
	else return window.location.host !== "widget.mercigustave.co" ? window.location.host : window.location.pathname.split("/")[1];
}
function returnDocumentURL() {
	if(window.location.host==="www.maisonkitsune.com") return document.URL.replace("www.", "");
	else if(window.location.host==="www.perus.co") return document.URL.replace("www.", "fr.");
	else if(window.location.host==="es.perus.co") return document.URL.replace("es.perus.co", "fr.perus.co");
	else if(window.location.host==="en.gilis.com") return document.URL.replace("en.", "fr.");
	else return window.location.host !== "widget.mercigustave.co" ? document.URL : document.URL.replace("widget.mercigustave.co/", "");
}
function returnHostMode(hostMode) {
		if (hostMode.indexOf("test") !== -1) return "test";
		else return "prod";
}
function urlsExcluded(host) {
	cl("urlsExcluded");
	urlDocReturned = returnDocumentURL();
	let urlExclue = false;
	if (host.excludedURLs && host.excludedURLs.indexOf(urlDocReturned)!==-1) {
		urlExclue = true;
		//cl("URL Ex : " + urlExclue);
	} else if (host && host.urlsExcludedWords) {
		host.urlsExcludedWords.forEach(value => {
			if (urlDocReturned.indexOf(value)!==-1) {
				urlExclue = true;
				//cl("WORD Ex : " + urlExclue);
			}
		});
	}
	cl(urlExclue);
	return urlExclue;
}
function formatNumAfterCom(num) {
	//cl("formatNumAfterCom => num à formater : " + num);
	let numString = "" + num; // conversion string
	if(numString.indexOf(".") !== -1 && numString.split(".")[1].length === 1) return num + "0";
	else return numString;
}
function returnNumOfArticles(cart) {
	var num = cart.reduce((total, val) => total + val.quantity, 0);
	return num;
}
function checkLang() { // Check si host en anglais
	if ( window.location.host==="www.perus.co" || window.location.host==="es.perus.co" || (hostReturned==="flairisfrench.com" && document.querySelector("#lang-switcher .dropdown-item.active .text") && document.querySelector("#lang-switcher .dropdown-item.active .text").innerText === "EN") || ((hostReturned==="www.editionsmr.fr" || hostReturned==="dianavaradi.com" || hostReturned ==="www.facetofaceparis.com" || hostReturned === "lespetitesambitieuses.com") && window.location.pathname.split('/')[1] === "en") || (hostReturned==="www.manoush.com" && window.location.pathname.split('/')[2] !== "fr") || ((hostReturned ==="balsa-leather.com" || hostReturned ==="www.adn-paris.fr" || hostReturned ==="poetique-paris.com" || hostReturned ==="okan-studio.com" || hostReturned ==="www.salut-beaute.com" || hostReturned ==="www.the-ethiquette.com") && document.querySelector(".wgcurrent.wg-li") && !document.querySelector(".wgcurrent.wg-li").classList.contains("fr")) || (hostReturned === "fr.gilis.com" && document.querySelector(".lang > .active > a").innerText !== "FR") || (hostReturned === "www.communedeparis1871.fr" && window.location.pathname.split("/")[1] !== "fr") ) {
		if (hostReturned==="www.manoush.com" && window.location.pathname.split('/')[2] === "cn") lang = "CN";
		else lang = "EN";
	} else lang = "FR";
}

////////////////////// SHOPIFY functions only ///////////////////////////////
function ifIsIndispo(hostSelect) {
	const container = document.querySelector(hostSelect.checkPageProduct)? document.querySelector(hostSelect.checkPageProduct).parentElement : null;

	if (hostReturned === "www.camilleveganbags.com") {
		if (container) {
			container.style.display = "flex";
			container.style.flexDirection = "column";
			container.style.alignItems = "flex-start";
		}

		if (document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerText === "RUPTURE") {
			return true;
		} else {
			return false;
		}

	} else if (hostReturned === "mikedev75.myshopify.com") {
		if (container) {
			container.style.display = "flex";
			container.style.flexDirection = "column";
			container.style.alignItems = "flex-start";
			container.parentElement.style.display = "flex";
			container.parentElement.style.flexDirection = "column";
			container.parentElement.style.alignItems = "flex-start";
		}

		if (document.querySelector(".selector-wrapper.js.product-form__item")) {
				document.querySelector(".selector-wrapper.js.product-form__item").style.flex = "1 1";
		}
		if (document.querySelector(".product-form__item.product-form__item--submit")) {
				document.querySelector(".product-form__item.product-form__item--submit").style.flex = "1 1";
		}

		if (document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerText === "RUPTURE") {
			return true;
		} else {
			return false;
		}

	} else {
		return false;
	}
}
function addShopifyBtnStyles(btnSelector, btnsStyles) {
	cl("addShopifyBtnStyles");
	var styleBalise = document.querySelector('head > style');
	var txtToAdd = btnSelector + " { " + btnsStyles.default + " }";

	if (btnsStyles.addwidthSelector && btnsStyles.addwidthSelector.length) {
		btnsStyles.addwidthSelector.forEach(function(line) {
			txtToAdd += " " + btnSelector + line.selectorToAdd + " { " + line.styles + " }";
		});
	}

	if (styleBalise) {
		styleBalise.innerText += txtToAdd;

	} else {
		styleBalise = document.createElement('style');
		styleBalise.innerText = txtToAdd;
		document.querySelector('head').innerHTML += styleBalise;
	}
}
function createShopifyBtns(btnToClone, btnType, container, span) {
	cl("CTB Shopify app : " + btnType);

	// texte du try btn selon host
	var btnTryText = lang === "EN"? (hostSelect.tryBtnTextEN? hostSelect.tryBtnTextEN : "Try for free") : (hostSelect.tryBtnText? hostSelect.tryBtnText : "Essayer gratuitement");
	var btnTrySubText = hostSelect.tryBtnSpan? (lang === "EN"? hostSelect.tryBtnSpanEN : hostSelect.tryBtnSpan) : null;

	// crée le btn
	var btnTry = btnType === "cart"? document.createElement("span") : document.createElement("button");

	btnTry.id = 'gustave-' + btnType;

	if (hostSelect.btnsStyles) {
		var styleBalise = document.querySelector('head > style');
		if (styleBalise && styleBalise.innerText.indexOf('#gustave-' + btnType) === -1) addShopifyBtnStyles('#gustave-' + btnType, hostSelect.btnsStyles);
		else {
			cl("shopify btns styles already added");
		}
	}

	btnTry.type = "button";
	btnTry.setAttribute("status", "waitForEvent");

	btnTry.classList.value = btnToClone.classList.value.replace("cart__submit", "").replace("cart__submit-control", "");
	btnTry.style.display = "flex";
	btnTry.style.flexFlow = "row wrap";
	btnTry.style.justifyContent = "center";
	btnTry.style.alignItems = "center";
	btnTry.style.padding = "0px 10px";
	btnTry.style.lineHeight = "14px";
	btnTry.style.height = window.getComputedStyle(btnToClone, null).getPropertyValue("height");
	btnTry.style.width = window.getComputedStyle(btnToClone, null).getPropertyValue("width");

	if (!span) {
			btnTry.innerText = btnTryText;
	} else  {
			btnTry.innerHTML = "<span>" + btnTryText + "</span>";
	}

	// try btn avec span
	if (btnTrySubText) {
			var spanBtnTry = document.createElement('span');
			spanBtnTry.id = 'txt3' + btnType;
			spanBtnTry.innerText = btnTrySubText;
			spanBtnTry.style.display = "block";
			btnTry.appendChild(spanBtnTry);
	}

	// attacher le try btn
	if (btnType === "try-btn") {
			// affiche ou masque/désactive le try btn
			if (ifIsIndispo(hostSelect)) {
					if (hostSelect.tryBtnDisabled) {
							btnTry.disabled = true;
					} else {
							btnTry.style.display = "none";
					}
			}

			// si try btn cliqué et app non chargé, affiche un cursor wait
			btnTry.onclick = function(e) {
					e.preventDefault();
					e.target.style.cursor = "wait";
			}

			// appenchild ou insertbefore document.querySelector('button[name="add"]')
			var ref = document.querySelector(hostSelect.checkPageProduct).nextElementSibling;

			btnTry.style.marginTop = "10px";
			if (ref) {
					ref.style.width = "100%";
					container.insertBefore(btnTry, ref);
			} else {
					container.appendChild(btnTry);
			}

	} else {
			// si try btn cliqué et app non chargé, affiche un cursor wait
			btnTry.onclick = function(e) {
					e.preventDefault();
					e.stopPropagation();
					e.target.style.cursor = "progress";
			}

			if (btnType === "cart") {
					container.style.display = "flex";
					container.style.flexDirection = "column";
					container.style.alignItems = "flex-end";
					btnTry.style.minWidth = "203px";
					btnToClone.style.minWidth = "203px";
					container.insertBefore(btnTry, btnToClone);
			} else {
					btnTry.style.minHeight = "43px";
					container.insertBefore(btnTry, btnToClone);
			}
			btnTry.style.marginBottom = "10px";
	}

	var tryBtnCreated = document.querySelector('#gustave-' + btnType);

	if (tryBtnCreated) { // si btn bien créé

		if (btnType === "try-btn" && btnTry.style.display !== "none") {
				// affiche le texte du service si try btn visible
				if (hostSelect.txtService || (IP_IS_ADMIN && hostSelect.textService && hostSelect.mode === "test")) {
					createShopifyTxtService(btnTry.style.display);
				}
		}
			// ajuste la hauteur et la largeur du try btn selon le bouton ajouter au panier du host
			adjustTrybtnWidthHeight();
			window.addEventListener('resize', adjustTrybtnWidthHeight);
			window.addEventListener('scroll', adjustTrybtnWidthHeight);

			function adjustTrybtnWidthHeight() {
					if (btnToClone && tryBtnCreated) {
							tryBtnCreated.style.height = window.getComputedStyle(btnToClone, null).getPropertyValue("height");
							tryBtnCreated.style.width = window.getComputedStyle(btnToClone, null).getPropertyValue("width");
					}
			}
	}
}
function createShopifyTxtService(tryBtnStatus) {
	cl(["CTS", "lang : " + lang]);
	var txtService = document.createElement('span');
	txtService.id = "gustave-txt-service";
	txtService.style.display = tryBtnStatus === "none"? "none" : "block";

	// styles
	var ref = document.querySelector(hostSelect.checkPageProduct);
	var parentRef = ref.parentElement;
	parentRef.insertBefore(txtService, ref);

	// textes
	if (document.querySelector("#gustave-txt-service")) {
		document.querySelector("#gustave-txt-service").innerHTML = '<span style="font-weight: bold;">' + hostSelect.textService[lang].split("*")[0] + '</span>' + (hostSelect.btnShowCcm? ' <span id="gustave-showCcm" status="waitForEvent" style="display: inline-block; border-radius: 50%; border: none; cursor: pointer; width: 18px; height: 18px; text-align: center; line-height: 18px; font-weight: bolder; margin-left: 8px; background:' + hostSelect.btnShowCcm.background + '; color:' + hostSelect.btnShowCcm.color + ';" title="' + hostSelect.textService[lang].split("*")[1] + '">?</span><br><br>' + hostSelect.textService[lang].split("*")[2] + '<br>' + hostSelect.textService[lang].split("*")[3] + '<br>' + hostSelect.textService[lang].split("*")[4] : '<br><br>' + hostSelect.textService[lang].split("*")[1] + '<br>' + hostSelect.textService[lang].split("*")[2] + '<br>' + hostSelect.textService[lang].split("*")[3]);
	}
}
function recreateTryBtn() {
	console.log("recreateTryBtn");
	var tryBtnContainer = document.querySelector(hostSelect.checkPageProduct).parentElement;
	var btnTry = document.createElement('button');
	btnTry.id = 'gustave-try-btn';
	btnTry.innerText = lang === "EN"? (hostSelect.tryBtnTextEN? hostSelect.tryBtnTextEN : "Try for free") : (hostSelect.tryBtnText? hostSelect.tryBtnText : "Essayer gratuitement");

	if (hostReturned === "okan-studio.com") {
		adjustPage();
		window.addEventListener('resize', adjustPage);

		function adjustPage() {
			tryBtnContainer.style.display = "flex";
			tryBtnContainer.style.flexDirection = "column";
			tryBtnContainer.style.minWidth = "265px";
			tryBtnContainer.style.width = "100%";
			tryBtnContainer.style.marginLeft = "0px";
			tryBtnContainer.style.marginTop = "10px";
			document.querySelector('form[action="/cart/add"]').style.flexDirection = "column";

			if (document.querySelector('.sticky-product-scroll > h3.subheader')) {
				document.querySelector('.sticky-product-scroll > h3.subheader').style.width = "fit-content";
				var widthToSet = window.getComputedStyle(document.querySelector('.sticky-product-scroll > h3.subheader'), null).getPropertyValue("width");
				if (document.querySelector('form[action="/cart/add"] div.purchase-details ')) document.querySelector('form[action="/cart/add"] div.purchase-details ').style.width = widthToSet;
				if (document.querySelector('form[action="/cart/add"] .selector-wrapper')) {
					document.querySelector('form[action="/cart/add"] .selector-wrapper').style.minWidth = "265px";
					document.querySelector('form[action="/cart/add"] .selector-wrapper').style.width = widthToSet;
					document.querySelector('form[action="/cart/add"] .selector-wrapper').style.paddingRight = "0px";
				}
			}
		}

		if (!document.querySelector('#gustave-try-btn')) {
			tryBtnContainer.appendChild(btnTry);
			var br = document.createElement('br');
			tryBtnContainer.appendChild(br);
		}
	}

}

function hideTryBtn() {
	if (document.querySelector("#gustave-try-btn")) {
		document.querySelector("#gustave-try-btn").style.display = "none";
		document.querySelector("#gustave-try-btn").classList.add("hide-try-btn");
	}
}

function showTryBtn() {
	if (document.querySelector("#gustave-try-btn")) {
		document.querySelector("#gustave-try-btn").classList.remove("hide-try-btn");
		document.querySelector("#gustave-try-btn").style.display = block;
	}
}
/////////////////////////////////////////////////////////////////////////////

class App extends Component {
	constructor(props) { // initialisation ID ANALYTICS
		super(props);

		const promoDetails = sessionStorage.getItem("reduc")? JSON.parse(sessionStorage.getItem("reduc")) : null;

		this.state = {
			background: 'transparent',
			showFacturationTutorial: true,
			workflowStep: '0',
			client: {
				address: {
					main: null,
					other: null,
					placeId: null,
					villeTest: false,
					villeSelect: false
				},
				infos: {
					familyName: null,
					firstName: null,
					email: null,
					phoneNumber: null
				},
				orderId: null
			},
			cart: [],
			orderStep: 0,
			prixTotalCart: 0,
			totalArticles: 0,
			orderIdSave: null,
			token: null,
			txtBtnTry: "ESSAYER GRATUITEMENT",
			txtCcmPh1: "Commandez jusqu'à*6 articles.",
			txtCcmPh2: "Livraison dans la*journée.",
			txtCcmPh3: "Retour par*coursier*depuis chez vous.",
			txtCcmPh4: "Payez*uniquement*ce que vous gardez !",
			txtCcmPh4fee: "(+ frais de livraison : *€)",
			txtCcmPh4feeCab: "Livraison : ",
			txtCcmPlaces: "Service disponible à Paris et proche banlieue.",
			txtCcmBtn: "Essayer !",
			txtCcmPh1EN: "Order up to*6 items.",
			txtCcmPh2EN: "Delivery in the*day.",
			txtCcmPh3EN: "Return by*courier*from your home.",
			txtCcmPh4EN: "*Only*Pay for what you keep.",
			txtCcmPh4feeEN: "(+*€ delivery fees)",
			txtCcmPh4feeCabEN: "Delivery: ",
			txtCcmPlacesEN: "Service available in Paris and near suburbs.",
			txtCcmBtnEN: "Let's go!",
			frais: null,
			appLang: lang,
			stripeLoading: false,
			promos: false,
			promoCode: promoDetails? promoDetails.promoCode : null,
			reduc: promoDetails? promoDetails.reduc : null,
			typeReduc: promoDetails? promoDetails.typeReduc : null,
			stripe: null,
			msgEmptyCab: false,
			msgsClosed: null,
			ftf: false,
			ftfDisplay: "none",
			cosmetsProduct: false,
			noelsProduct: false,
			optionsProduct: false,
			duplicatedCartIcon: false,
			maxProductNumber: maxProductNumberRef,
			productsNumberToAdd: 0,
			cartBadgeStyles: {
				background: '#f5222d',
				color: '#fff',
				border: '0px solid #fff',
				position: 'absolute',
				left: '-10px',
				justifyContent: 'center',
				alignItems: 'center',
				top: '-10px',
				height: '20px',
				width: '20px',
				borderRadius: '50%',
				minWidth: '20px',
				lineHeight: '20px',
				textAlign: 'center',
				fontSize: '12px',
				fontWeight: '400',
				whiteSpace: 'nowrap',
				boxShadow: '0 0 0 1px #fff'
			},
			showSteps: false,
			desactivateDelivery: false,
			desactivateMsg: {},
			reactivateDelivery: false,
			inventoryDeadline: null,
			widgetSubTitle: null
		}

		ReactGA.initialize(initReactGAhost, { debug: false, alwaysSendToDefaultTracker: false });
	}

	componentDidMount() { // initialisation scripts GOOGLE TAG MANAGER

		const that = this;

		const xhrGustaveJson = new XMLHttpRequest();
		xhrGustaveJson.onreadystatechange = function () {
			if (xhrGustaveJson.readyState === 4) {
				if (xhrGustaveJson.status === 200) {
					gustaveJson = JSON.parse(xhrGustaveJson.responseText);
					villesOk = gustaveJson.villes;
					cl(["villes :", villesOk]);
					let updateState = {};
					if (gustaveJson.desactivateDelivery && !hostSelect.reactivateDelivery) updateState.desactivateDelivery = true;
					if (gustaveJson.desactivateMsg && !hostSelect.reactivateDelivery) updateState.desactivateMsg = gustaveJson.desactivateMsg;
					if (gustaveJson.widgetSubTitle && !hostSelect.widgetSubTitle) updateState.widgetSubTitle = gustaveJson.widgetSubTitle;
					that.setState(updateState);

				} else {
					cl(["erreur gustave.json", xhrGustaveJson.responseText]);
				}
			}
		}
		xhrGustaveJson.open( 'GET', URL_CONFIG + "?type=jsons&mode=" + hostSelect.mode + "&name=gustave.json");
		xhrGustaveJson.setRequestHeader('Accept', 'text/html');
		xhrGustaveJson.send(null);

		if (domRoot.querySelector("#cartBadge") && document.querySelector("#gustave-cart") && !document.querySelector("#cartBadge")) {
			this.attachCartBadge();
		}

		that.enableTryBtnClick();

		let cart = [];

		// chargement depuis collection si besoin de cross domain
		if (hostSelect && hostSelect.saveCart && showCart !== "none") {
			if (localStorage.getItem('gustave-cart')) localStorage.removeItem('gustave-cart');
			if (localStorage.getItem('gustave-version')) localStorage.removeItem('gustave-version');
			if (sessionStorage.getItem('gustave-lang')) sessionStorage.removeItem('gustave-lang');

			let xhr1 = new XMLHttpRequest();
			xhr1.onreadystatechange = function () {
				if (xhr1.readyState === 4 && xhr1.status === 200) {
					if (this.responseText) {
						if (this.responseText.length > 2) {
							let data = JSON.parse(this.responseText)
							if (data.version === dateVersion) {
								cart = data.cart;
								if (data.lang) {
									lang = data.lang;
									that.setState({appLang: data.lang})
								}

							} else {
								that.removeCartDomain();
							}
						}

						if (cart && cart.length >= 0) {
							const cNumOfPToAdd = that.calculNumOfProductsToAdd(cart);
							const activeDynTxt = cart && cart.length > 0 && cart.length < cNumOfPToAdd.maxProductNumber;
							that.cabSubTitleDyn(activeDynTxt, cNumOfPToAdd.productsNumberToAdd);

							that.setState({
								cart: cart,
								prixTotalCart: that.calculTotalCart(cart),
								maxProductNumber: cNumOfPToAdd.maxProductNumber,
								productsNumberToAdd: cNumOfPToAdd.productsNumberToAdd,
								totalArticles: cNumOfPToAdd.totalAdded,
								msgEmptyCab: cart.length === 0? true : false,
								workflowStep: cart.length === 0? '0' : '1'
							});
						}
					}
				}
			}
			xhr1.open('GET', URL_BACK[returnHostMode(hostSelect.mode)] + '/reloadcart/' + hostReturned + '/' + IP_ADDRESS, true);
			xhr1.send(null);

		} else if (showCart !== "none") { // si pas besoin de storage cross Domain

			// vérification si dernière version du widget
			let version = localStorage.getItem('gustave-version');
			if (sessionStorage.getItem('gustave-lang')) lang = sessionStorage.getItem('gustave-lang');
			if (version && version === dateVersion) {
				if (localStorage.getItem('gustave-cart')) cart = JSON.parse(localStorage.getItem('gustave-cart'));

			} else {
				if (localStorage.getItem('gustave-cart')) localStorage.removeItem('gustave-cart');
				localStorage.setItem('gustave-version', dateVersion);
			}

			if (cart && cart.length >= 0) {
				const cNumOfPToAdd = this.calculNumOfProductsToAdd(cart);
				const activeDynTxt = cart && cart.length > 0 && cart.length < cNumOfPToAdd.maxProductNumber;
				this.cabSubTitleDyn(activeDynTxt, cNumOfPToAdd.productsNumberToAdd);

				this.setState({
					cart: cart,
					prixTotalCart: this.calculTotalCart(cart),
					maxProductNumber: cNumOfPToAdd.maxProductNumber,
					productsNumberToAdd: cNumOfPToAdd.productsNumberToAdd,
					totalArticles: cNumOfPToAdd.totalAdded,
					msgEmptyCab: cart.length === 0? true : false,
					workflowStep: cart.length === 0? '0' : '1'
				});
			}
		}

		// variables pour Google Tag Manager
		//let head = null, gtmHead = null, body = null, gtmBody = null;

		if (window.location.search.substring(1) === "widget=open") this.showOverlay(null);

		// HOSTS
		if (hostReturned === "www.the-ethiquette.com") {
			addAnalytics('GTM-K985Q6P', hostSelect.mode);
			this.initBtnsLang();

			if (document.querySelector('input[name="Size"]')) {
				const sizeBtns = Array.from(document.querySelectorAll('input[name="Size"]'));
				for (let i = 0; i < sizeBtns.length; i++) {
					if (!sizeBtns[i].classList.contains("disabled")) {
						sizeBtns[i].setAttribute("mg-init-click", true);
						sizeBtns[i].addEventListener("click", function(e) {
							scrapEthiquette(e.target.value)
						});
					} else sizeBtns[i].setAttribute("mg-init-click", false);
				}
			}

			scrapEthiquette(null);

			function searchSizeAndLengthInP() {
				let size = "not found", length = {name: "", value: ""};
				const allP = Array.from(document.querySelectorAll('div.product-single__description > p'));
				for (let i = 0; i < allP.length; i++) {
					// size
					if (allP[i].innerText.indexOf("Taille ") !== -1) {
						size = allP[i].innerText.split("Taille ")[1].split(" ")[0];
					} else if (allP[i].innerText.indexOf("Size ") !== -1) {
						size = allP[i].innerText.split("Size ")[1].split(" ")[0];
					} else if (allP[i].innerText.indexOf("One size") !== -1) {
						size = "One size";
					}

					// length
					if (allP[i].innerText.indexOf("Longueur ") !== -1) {
						length.name = allP[i].innerText.split(" : ")[0];
						length.value = allP[i].innerText.split(" : ")[1];
					} else if (allP[i].innerText.toLowerCase().indexOf("length:") !== -1) {
						length.name = allP[i].innerText.split(": ")[0];
						length.value = allP[i].innerText.split(": ")[1];
					}
				}
				console.log({size, length});
				return {size, length};
			}

			function scrapEthiquette(size) {
				setTimeout(() => {
					productScrap.options2 = [];
					const outOfStock = document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerHTML.indexOf("Épuisé") !== -1;
					if (document.querySelector(hostSelect.checkPageProduct) && !outOfStock && !urlsExcluded(hostSelect)) {
						productScrap.url = document.URL;
						productScrap.name = document.querySelector('h1.product-single__title').innerText;
						productScrap.image = document.querySelector('.product__thumb-item > .image-wrap > a.product__thumb > img') && document.querySelector('.product__thumb-item > .image-wrap > a.product__thumb > img').getAttribute('data-srcset')? "https:" + document.querySelector('.product__thumb-item > .image-wrap > a.product__thumb > img').getAttribute('data-srcset').split(",")[0] : (document.querySelector('.product-image-main > .image-wrap > img') && document.querySelector('.product-image-main > .image-wrap > img').getAttribute('data-srcset')? "https:" + document.querySelector('.product-image-main > .image-wrap > img').getAttribute('data-srcset').split(",")[0] : "https://config.mercigustave.co/assets/imgs/no-image.jpg");
						productScrap.price = +document.querySelector('span.product__price').innerText.trim().replace(",", ".").replace("€", "");
						const sizeAndLength = searchSizeAndLengthInP();
						productScrap.size = size? size : (sizeAndLength.size !== "not found"? sizeAndLength.size : null);
						if (sizeAndLength.length && sizeAndLength.length.value) {
							productScrap.options2 = [{nom: sizeAndLength.length.name, value: sizeAndLength.length.value}];
						}

						productScrap.id = productScrap.name.trim()+'-'+window.location.pathname.split("/")[2]+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;
						if (productScrap.options2.length > 0) productScrap.id += "-" + productScrap.options2[0].value;

						cl(["produit scrapé", productScrap]);
						showTryBtn();

					} else hideTryBtn();
				}, 250);
			}
		}


		if (hostReturned === "lpmb-paris.com") {
			addAnalytics('GTM-WNT54FW', hostSelect.mode);

			scrapLpmb();

			function scrapLpmb() {
				setTimeout(() => {
					if (document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {
						productScrap.url = document.URL;
						productScrap.name = document.querySelector('h1.namne_details').innerText;
						productScrap.image = document.querySelector('.product-cover > img').src;
						productScrap.price = document.querySelector('span#final_price')? +document.querySelector('span#final_price').innerText.trim().replace(",", ".").replace("€", "") : +document.querySelector('.current-price > span[itemprop="price"]').innerText.trim().replace(",", ".").replace("€", "");

						productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;

						cl(["produit scrapé", productScrap]);
						showTryBtn();

					} else hideTryBtn();
				}, 250);
			}
		}

		if (hostReturned === "www.salut-beaute.com") {
			addAnalytics('GTM-N74XDP3', hostSelect.mode);

			this.initBtnsLang();

			if (document.querySelector('div.selector-wrapper > ul.clickyboxes')) {
				const sizeBtns = Array.from(document.querySelectorAll('div.selector-wrapper > ul.clickyboxes a'))
				for (let i = 0; i < sizeBtns.length; i++) {
					sizeBtns[i].addEventListener('click', scrapBeaute);
				}
			}

			scrapBeaute();

			function scrapBeaute() {
				setTimeout(() => {
					if (document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerText !== "victime de son succès :(" && document.querySelector(hostSelect.checkPageProduct).innerText !== "victim of his success :(" && !document.querySelector(hostSelect.checkPageProduct).disabled && !urlsExcluded(hostSelect)) {
							productScrap.url = document.URL;
							productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute('content');
							productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute('content');
							productScrap.price = +document.querySelector('meta[property="og:price:amount"]').getAttribute('content').replace(",", ".");

							if (document.querySelector('div.selector-wrapper > ul.clickyboxes a.active')) {
								productScrap.size = document.querySelector('div.selector-wrapper > ul.clickyboxes a.active').innerText;
							}

							productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;

							cl(["produit scrapé", productScrap]);
							showTryBtn();

					} else {
						hideTryBtn();
						productScrap.size = document.querySelector(hostSelect.checkPageProduct) && (document.querySelector(hostSelect.checkPageProduct).innerText === "victime de son succès :(" || document.querySelector(hostSelect.checkPageProduct).disabled || (document.querySelector("h5") && document.querySelector("h5").innerText === "ce produit n'est plus disponible :("))? "off" : "notForTry";
					}
				}, 250);
			}
		}

		if (hostReturned === "bleutango.fr") {
			addAnalytics('GTM-PR6VM43', hostSelect.mode);

			function addListenerToSizeBtns() {
				console.log("addListenerToSizeBtns");
				if (document.querySelector('ul.tt-options-swatch')) {
					const sizeBtns = Array.from(document.querySelectorAll('ul.tt-options-swatch a'));
					for (let i = 0; i < sizeBtns.length; i++) {
						if (!sizeBtns[i].getAttribute("gustaveInit")) {
							sizeBtns[i].setAttribute("gustaveInit", true);
							sizeBtns[i].addEventListener('click', scrapBleu);
						}
					}
				}
			}

			addListenerToSizeBtns();
			scrapBleu();

			function scrapBleu() {
				console.log("scrapBleu");
				if (document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerText !== "ÉPUISÉ" && !urlsExcluded(hostSelect)) {
					setTimeout(() => {
						if (document.querySelector('ul.tt-options-swatch .active a') && document.querySelector('ul.tt-options-swatch .active a').innerText.toLowerCase() !== "sur-mesure") {
							productScrap.url = document.URL;
							productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute('content');
							productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute('content');
							productScrap.price = +document.querySelector('meta[property="og:price:amount"]').getAttribute('content').replace(",", ".");
	
							if (document.querySelector('ul.tt-options-swatch')) {
								productScrap.size = document.querySelector('ul.tt-options-swatch .active a').innerText;
							}
	
							productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;
	
							cl(["produit scrapé", productScrap]);
							showTryBtn();
							
						} else {
							hideTryBtn();
							productScrap.size = "notForTry";
						}
						addListenerToSizeBtns();
					}, 250);
				} else {
					hideTryBtn();
					productScrap.size = document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerText === "ÉPUISÉ"? "off" : "notForTry";
				}
			}
		}

		if (hostReturned === "okan-studio.com") {
			addAnalytics('GTM-NLC4D9Q', hostSelect.mode);

			this.initBtnsLang();

			function addListenerToSizeBtns() {
				if (document.querySelector('ul.ColorSwatchList')) {
					const sizeBtns = Array.from(document.querySelectorAll('ul.ColorSwatchList > li > label.ColorSwatch'));
					for (let i = 0; i < sizeBtns.length; i++) {
						if (!sizeBtns[i].getAttribute("gustaveInit")) {
							sizeBtns[i].setAttribute("gustaveInit", true);
							sizeBtns[i].addEventListener('click', function(e) {
								scrapOkan(e);
							});
						}
					}
				}
				if (document.querySelector('ul.SizeSwatchList')) {
					const sizeBtns = Array.from(document.querySelectorAll('ul.SizeSwatchList > li > label.SizeSwatch'));
					for (let i = 0; i < sizeBtns.length; i++) {
						if (!sizeBtns[i].getAttribute("gustaveInit")) {
							sizeBtns[i].setAttribute("gustaveInit", true);
							sizeBtns[i].addEventListener('click', function(e) {
								scrapOkan(e);
							});
						}
					}
				}
			}

			addListenerToSizeBtns();
			scrapOkan(null);

			function scrapOkan(e) {
				setTimeout(() => {
					if (document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerText !== "Épuisé" && !document.querySelector(hostSelect.checkPageProduct).disabled && !urlsExcluded(hostSelect)) {
							productScrap.url = document.URL;
							productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute('content');
							productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute('content');
							productScrap.price = +document.querySelector('.ProductMeta__PriceList > span.ProductMeta__Price').innerText.split("€")[0].trim().replace(",", ".");

							productScrap.color = document.querySelector('.ProductForm__Variants span.ProductForm__Label > span.ProductForm__SelectedValue') ? document.querySelector('.ProductForm__Variants span.ProductForm__Label > span.ProductForm__SelectedValue').innerText : null;

							if (e) {
								if (e.target.classList.contains("SizeSwatch")) productScrap.size = e.target.innerText;
							} else if (window && window.meta && window.meta.product) {
								const variants = window.meta.product.variants;
								let variant, size, selectedVariant = 0;
								if (window.location.search.indexOf("variant=") !== -1) {
									variant = +window.location.search.split("variant=")[1];
									selectedVariant = variants.findIndex(v => v.id === variant);
								}

								size = variants[selectedVariant].public_title.split(" / ")[1];
								productScrap.size = size;

							} else {
								productScrap.size = null;
							}

							productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;

							cl(["produit scrapé", productScrap]);

							if (document.querySelector("#gustave-try-btn")) showTryBtn();
							else {
								recreateTryBtn();
								showTryBtn();
							}

					} else {
						hideTryBtn();
						productScrap.size = document.querySelector(hostSelect.checkPageProduct) && (document.querySelector(hostSelect.checkPageProduct).innerText === "ÉPUISÉ" || document.querySelector(hostSelect.checkPageProduct).disabled)? "off" : "notForTry";
					}
				}, 250);
			}
		}

		if (hostReturned === "poetique-paris.com") {
			addAnalytics('GTM-WGRDCVR', hostSelect.mode);

			this.initBtnsLang();

			if (document.querySelector("#SingleOptionSelector-0")) {
				document.querySelector("#SingleOptionSelector-0").addEventListener('change', scrapPoe);
			}

			scrapPoe();

			function scrapPoe() {
				if (document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerText !== "ÉPUISÉ" && !urlsExcluded(hostSelect)) {
					setTimeout(() => {
						productScrap.url = document.URL;
						productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute('content');
						productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute('content');
						productScrap.price = +document.querySelector('meta[property="og:price:amount"]').getAttribute('content').replace(",", ".");

						if (document.querySelector("#SingleOptionSelector-0")) productScrap.size = document.querySelector("#SingleOptionSelector-0").value;
						else productScrap.size = null;

						productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;

						cl(["produit scrapé", productScrap]);
						showTryBtn();

					}, 250);
				} else {
					hideTryBtn();
					productScrap.size = document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerText === "ÉPUISÉ"? "off" : "notForTry";
				}
			}

		}

		if (hostReturned === "9aminparis.com") {
			addAnalytics('GTM-PN8J5H4', hostSelect.mode);

			if (document.querySelector("#Taille")) {
				document.querySelector("#Taille").addEventListener('change', scrap9amin);
			}

			if (document.querySelector("#Size")) {
				document.querySelector("#Size").addEventListener('change', scrap9amin);
			}

			if (document.querySelector("#Color")) {
				document.querySelector("#Color").addEventListener('change', scrap9amin);
			}

			scrap9amin();

			function scrap9amin() {
				if (document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerText !== "ÉPUISÉ" && !urlsExcluded(hostSelect)) {
					setTimeout(() => {
						productScrap.url = document.URL;
						productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute('content');
						productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute('content');
						productScrap.price = +document.querySelector('meta[property="og:price:amount"]').getAttribute('content').replace(",", ".");
						const infosNewCollection = that.returnInfosCollection(hostSelect.newCollection);
						productScrap.info = infosNewCollection.info;
						productScrap.date = infosNewCollection.date;

						if (document.querySelector("#Taille")) productScrap.size = document.querySelector("#Taille").value;
						else if (document.querySelector("#Size")) productScrap.size = document.querySelector("#Size").value;
						else productScrap.size = null;

						if (document.querySelector("#Color")) productScrap.color = document.querySelector("#Color").value;

						productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;

						cl(["produit scrapé", productScrap]);
						showTryBtn();

					}, 250);
				} else {
					hideTryBtn();
					productScrap.size = document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerText === "ÉPUISÉ"? "off" : "notForTry";
				}
			}

		}

		if (hostReturned === "lespetitesambitieuses.com") {
			addAnalytics('GTM-PVXMP3Z', hostSelect.mode);

			if (document.querySelector("li.variable-item")) {
				const optionsBtns = Array.from(document.querySelectorAll("li.variable-item"));
				for(let i = 0; i < optionsBtns.length; i++) {
					optionsBtns[i].addEventListener('click', scrapLpa);
				}
			}

			if(document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {
				scrapLpa();
			}

			function scrapLpa() {

				setTimeout(() => {
					if(document.querySelector(".single_add_to_cart_button").classList.contains("disabled") || document.querySelector(".single_add_to_cart_button").classList.contains("wc-variation-selection-needed") || document.querySelector(".single_add_to_cart_button").classList.contains("wc-variation-is-unavailable")) {

						if (document.querySelector(".single_add_to_cart_button").classList.contains("wc-variation-selection-needed")) {
							if(document.querySelector("#gustave-try-btn") && !document.querySelector("#gustave-try-btn").disabled) document.querySelector("#gustave-try-btn").disabled = true;
							if (document.querySelector("li.variable-item.button-variable-item") && !document.querySelector("li.variable-item.button-variable-item.selected")) productScrap.size = "notSelected";
							if (document.querySelector("li.variable-item.color-variable-item") && !document.querySelector("li.variable-item.color-variable-item.selected")) productScrap.color = "notSelected";
							if (document.querySelector("li.variable-item.image-variable-item") && !document.querySelector("li.variable-item.image-variable-item.selected")) {
								productScrap.options = "notSelected";
								productScrap.options2 = [];
							}

						} else if (document.querySelector(".single_add_to_cart_button").classList.contains("wc-variation-is-unavailable")) {
							hideTryBtn();
							productScrap.size = "off";
							productScrap.color = "off";
							productScrap.options = null;
							productScrap.options2 = [];

						} else if (document.querySelector(".single_add_to_cart_button").classList.contains("disabled")) {
							hideTryBtn();
							productScrap.size = "off";
							productScrap.color = "off";
							productScrap.options = null;
							productScrap.options2 = [];
						}

					} else {
						productScrap.url = document.URL;
						productScrap.name = document.querySelector('h1.product_title').innerText;
						productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute('content');
						productScrap.price = +document.querySelector('p.price span.woocommerce-Price-amount.amount').innerHTML.split("&")[0];

						if (document.querySelector("li.variable-item.color-variable-item")) productScrap.color = document.querySelector("li.variable-item.color-variable-item.selected").getAttribute("data-value");
						else productScrap.color = null;

						if (document.querySelector("li.variable-item.button-variable-item")) productScrap.size = document.querySelector("li.variable-item.button-variable-item.selected").getAttribute("data-value").toUpperCase();
						else productScrap.size = null;

						if (document.querySelector("li.variable-item.image-variable-item")) {
							if (document.querySelector("li.variable-item.image-variable-item.selected")) {
								productScrap.options = null;
								productScrap.options2 = [];
								productScrap.options2.push({nom: "Boutons", value: document.querySelector("li.variable-item.image-variable-item.selected").getAttribute("data-value")});
							} else { productScrap.options = "notSelected"; productScrap.options2 = []; }
						} else { productScrap.options = null; productScrap.options2 = []; }

						productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;
						if(productScrap.options2.length > 0) productScrap.id += "-" + productScrap.options2[0].value;

						//cl(["produit scrapé", productScrap]);

						if(document.querySelector("#gustave-try-btn")) {
							showTryBtn();
							if(document.querySelector("#gustave-try-btn").disabled) document.querySelector("#gustave-try-btn").disabled = false;

						}
					}
				}, 500);
			}

		}

		if (hostReturned === "www.nolenca.com") {
			addAnalytics('GTM-KQLPQWH', hostSelect.mode);

			const nol_observerTitle = new MutationObserver(function(mutations) {
				//cl("MO nolenca title");
				urlDocReturned = returnDocumentURL();
				if(document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {
					if (document.querySelector(".product-mark.sold-out") && document.querySelector(".product-mark.sold-out").innerText === "ÉPUISÉ") {
						if (document.querySelector("#nol-try-btn") && document.querySelector("#nol-try-btn").style.display !== "none") document.querySelector("#nol-try-btn").style.display = "none";
					} else {
						scrapNol();
						if (!document.querySelector("#nol-try-btn") && !document.querySelector("#gustave-try-btn")) {
							showNolTryBtn();
						}
						if (document.querySelector("#nol-try-btn") && document.querySelector("#nol-try-btn").style.display !== "block") document.querySelector("#nol-try-btn").style.display = "block";
					}
					scrapNol();
				}
			});
			const nol_targetTitle = document.querySelector('head > title');
			nol_observerTitle.observe(nol_targetTitle, { childList: true });

			if(document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {
				if (document.querySelector(".product-mark.sold-out") && document.querySelector(".product-mark.sold-out").innerText === "ÉPUISÉ" && document.querySelector("#nol-try-btn") && document.querySelector("#nol-try-btn").style.display !== "none") {
					document.querySelector("#nol-try-btn").style.display = "none";
				} else {
					scrapNol();
					if (document.querySelector("#nol-try-btn") && document.querySelector("#nol-try-btn").style.display !== "block") document.querySelector("#nol-try-btn").style.display = "block";
				}
			}

			function scrapNol() {
				setTimeout(() => {

					const nameOfProduct = document.querySelector('h1.ProductItem-details-title')? document.querySelector('h1.ProductItem-details-title').innerText.toLowerCase() : "";
					const optionsProduct = nameOfProduct? (nameOfProduct.indexOf("le coffret") !== -1 || nameOfProduct.indexOf("bougie de noël") !== -1 || nameOfProduct.indexOf("tasse rousquille") !== -1) : false;
					const noelsProduct = nameOfProduct? nameOfProduct.indexOf("noël") !== -1 : false;

					if (optionsProduct) productScrap.info = langSelect("txtService", that.state).split("*")[5];
					else if (noelsProduct) productScrap.info = langSelect("txtService", that.state).split("*")[3];
					else productScrap.info = langSelect("txtService", that.state).split("*")[4];

					productScrap.url = document.URL;
					productScrap.name = document.querySelector('h1.ProductItem-details-title').innerText;
					productScrap.image = document.querySelector('meta[property="og:image"]').getAttribute('content').replace("http:", "https:");
					productScrap.price = +document.querySelector('div.product-price span.sqs-money-native').innerText.replace("€", "");

					productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;

					//cl(["produit scrapé", productScrap]);
				}, 50);
			}

			function showNolTryBtn() {
				pageProduct = true;
				const btnTry = domRoot.querySelector("#nol-clone-btn").cloneNode(true);
				btnTry.id = "nol-try-btn";
				const btnAdd = document.querySelector(".sqs-add-to-cart-button");
				const tryBtnContainer = btnAdd? btnAdd.parentElement : null;
				if (btnAdd) {
					showTextService(btnAdd);
					tryBtnContainer.appendChild(btnTry);
					btnTry.style.display = "block";
					btnTry.onclick = that.btnTryHandleClick;
				}
			}

			function showTextService(btnAdd) {
				const nameOfProduct = document.querySelector('h1.ProductItem-details-title')? document.querySelector('h1.ProductItem-details-title').innerText.toLowerCase() : "";
				const optionsProduct = nameOfProduct? (nameOfProduct.indexOf("le coffret") !== -1 || nameOfProduct.indexOf("bougie de noël") !== -1 || nameOfProduct.indexOf("tasse rousquille") !== -1) : false;
				const noelsProduct = nameOfProduct? nameOfProduct.indexOf("noël") !== -1 && !optionsProduct : false;

				//cl("optionsProduct : " + optionsProduct, "noelsProduct : " + noelsProduct);

				that.setState({noelsProduct: noelsProduct, optionsProduct: optionsProduct}, () => {

					const txtService = domRoot.querySelector("#nol-clone-service").cloneNode(true);
					txtService.id = "nol-txt-service";
					if (txtService) {
						const parentRef = btnAdd.parentElement;
						if (parentRef) {
							parentRef.insertBefore(txtService, btnAdd);
							txtService.style.display = "block";
						}
					}
				});
			}
		}

		if (hostReturned === "www.facetofaceparis.com" && ( (document.querySelector('div[id*="product-"]') && document.querySelector('div[id*="product-"]').classList.contains(hostSelect.tagMG)) || window.location.pathname.indexOf("/livraison-par-coursier/") !== -1 )) {
			addAnalytics('GTM-KL7L9B7', hostSelect.mode);

			cl("produit - livraison par coursier");

			const cosmetsName = hostSelect.cosmetsName? hostSelect.cosmetsName : ["sérum", "masque", "douche", "baume", "huile", "crème", "exfoliant", "savon", "détox", "bougie", "lait", "lotion"];
			
			let observerChange = true;

			//if (window.location.pathname.indexOf("/livraison-par-coursier/") !== -1) {
				observeFtf();

				if (document.querySelector("#qlwcdc_quick_view_modal") && document.querySelector("#qlwcdc_quick_view_modal").classList.contains("open")) openedModal();
			//}

			if (document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {
				scrapFtf();

				if (document.querySelector("#taille")) document.querySelector("#taille").addEventListener('change', scrapFtf);
				else productScrap.size = null;
				if (document.querySelector("#couleur")) document.querySelector("#couleur").addEventListener('change', scrapFtf);
				else productScrap.color = null;
			}

			function scrapFtf() {
				//cl("scrapFtf");

				setTimeout(() => {
					if (document.querySelector('div.modal.open div.modal-body > div.single-product > div.product') && window.location.pathname.indexOf("livraison-par-coursier") !== -1) { // modal
						if (!document.querySelector("#qlwcdc_quick_view_modal .single_add_to_cart_button").classList.contains("wc-variation-is-unavailable")) {
							if (document.querySelector("#qlwcdc_quick_view_modal #ftf-try-btn")) document.querySelector("#qlwcdc_quick_view_modal #ftf-try-btn").disabled = false;
							productScrap.url = document.querySelector('a.visible-in-modal.modal-product-link').href;
							allScrapingVar();
						} else {
							//cl("disabled product");
							if (document.querySelector("#qlwcdc_quick_view_modal #ftf-try-btn")) document.querySelector("#qlwcdc_quick_view_modal #ftf-try-btn").disabled = true;
							if (document.querySelector("#qlwcdc_quick_view_modal #taille")) productScrap.size = "off";
							if (document.querySelector("#qlwcdc_quick_view_modal #couleur")) productScrap.color = "off";
						}
					} else if (document.querySelector('div[id*="product-"]') && document.querySelector('div[id*="product-"]').classList.contains(hostSelect.tagMG)) { // page
						if (!document.querySelector(".single_add_to_cart_button").classList.contains("wc-variation-is-unavailable")) {
							if (document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = false;
							productScrap.url = document.URL;
							allScrapingVar();
						} else {
							//cl("disabled product");
							if (document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = true;
							if (document.querySelector("#taille")) productScrap.size = "off";
							if (document.querySelector("#couleur")) productScrap.color = "off";
						}
					}

					function allScrapingVar() {
						let cosmetsProduct = false;
						const nameOfProduct = document.querySelector('h1.product_title').innerText.toLowerCase();
						const marqueOfProduct = document.querySelector('h2.product-designer-title').innerText.toLowerCase();

						if (marqueOfProduct.indexOf("cosmétique") !== -1) cosmetsProduct = true;
						else {
								cosmetsName.forEach(function(word) {
										if (nameOfProduct.indexOf(word) !== -1) cosmetsProduct = true;
								});
						}

						if (cosmetsProduct) productScrap.info = langSelect("txtService", that.state).split("*")[3];

						productScrap.name = document.querySelector('h1.product_title').innerText;
						productScrap.image = document.querySelector('div.woocommerce-product-gallery__image > a > img').src;
						productScrap.price = +document.querySelector('p.price > span.woocommerce-Price-amount.amount').innerText.replace("€", "").replace(",", ".");

						if (document.querySelector("#taille")) {
							if (document.querySelector("#taille").value) productScrap.size = document.querySelector("#taille").value;
							else productScrap.size = "notSelected";
						}

						if (document.querySelector("#couleur")) {
							if (document.querySelector("#couleur").value) productScrap.color = document.querySelector("#couleur").value;
							else productScrap.color = "notSelected";
						}

						productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;
						//cl(["produit scrapé", productScrap]);
					}

				}, 100);
			}

			function observeFtf() {
				//cl("observer");
				if (document.querySelector("#qlwcdc_quick_view_modal")) {
					//cl("modal");

					let observerQuickModal = new MutationObserver(function (mutations) {
						openedModal();
					});

					let targetQuickModal = document.querySelector("#qlwcdc_quick_view_modal");
					observerQuickModal.observe(targetQuickModal, { attributes : true, attributeFilter : ['class'] });
				}
			}

			function openedModal() {
				if (observerChange) {
					observerChange = false;
					setTimeout(() => {
						const modalIsOpen = document.querySelector("#qlwcdc_quick_view_modal").classList.contains("open") && window.location.pathname.indexOf("/livraison-par-coursier/") !== -1;
						//cl("class change => open : " + modalIsOpen);

						if (modalIsOpen && !document.querySelector("#qlwcdc_quick_view_modal #ftf-try-btn")) {
							//cl("open");
							let ftfTryBtn, tryBtnContainer;

							let waitForFtfTryBtn = setInterval(function () {
								//cl("waitForFtfTryBtn");
								ftfTryBtn = document.querySelector("#qlwcdc_quick_view_modal #ftf-try-btn");
								if (ftfTryBtn && document.querySelector("#qlwcdc_quick_view_modal").classList.contains("open")) {
									clearInterval(waitForFtfTryBtn);
									//cl("ftfTryBtn ok");
									scrapFtf();

									showTextService(document.querySelector("#qlwcdc_quick_view_modal .single_add_to_cart_button"));

									if (document.querySelector("#taille")) document.querySelector("#taille").addEventListener('change', scrapFtf);
									else productScrap.size = null;
									if (document.querySelector("#couleur")) document.querySelector("#couleur").addEventListener('change', scrapFtf);
									else productScrap.color = null;
									ftfTryBtn.onclick = that.btnTryHandleClick;

									observerChange = true;
								} else if (!document.querySelector("#qlwcdc_quick_view_modal").classList.contains("open")) {
									clearInterval(waitForFtfTryBtn);
								}
							}, 50);

							let waitForContainer = setInterval(function () {
								//cl("waitForContainer");
								tryBtnContainer = document.querySelector("#qlwcdc_quick_view_modal .single_add_to_cart_button").parentElement;

								if (tryBtnContainer && document.querySelector("#qlwcdc_quick_view_modal").classList.contains("open")) {
									clearInterval(waitForContainer);
									//cl("container ok");
									showTftTryBtn(tryBtnContainer);
								} else if (!document.querySelector("#qlwcdc_quick_view_modal").classList.contains("open")) {
									clearInterval(waitForContainer);
								}
							}, 50);
						} else {
							//cl("close or not in event's page");
							observerChange = true;
						}
					}, 100);
				}
			}

			function showTftTryBtn(tryBtnContainer) {
				pageProduct = true;
				const btnTry = domRoot.querySelector("#ftf-clone-btn").cloneNode(true);
				btnTry.id = "ftf-try-btn";
				if (document.querySelector("#qlwcdc_quick_view_modal .single_add_to_cart_button").classList.contains("wc-variation-is-unavailable")) btnTry.disabled = true;
				const btnAdd = document.querySelector("#qlwcdc_quick_view_modal .single_add_to_cart_button");
				if (btnAdd) {
					const ref = document.querySelector('#qlwcdc_quick_view_modal button.qlwcdc_quick_purchase');
					tryBtnContainer.style.display = "flex";
					tryBtnContainer.style.flexDirection = "column";
					tryBtnContainer.insertBefore(btnTry, ref);

					btnTry.style.height = window.getComputedStyle(btnAdd, null).getPropertyValue("height");
					btnTry.style.display = "block";

					window.addEventListener('resize', function() {
							if (btnTry) {
								btnTry.style.height = window.getComputedStyle(btnAdd, null).getPropertyValue("height");
							}
					});
					window.addEventListener('scroll', function() {
							if (btnTry) {
								btnTry.style.height = window.getComputedStyle(btnAdd, null).getPropertyValue("height");
							}
					});

					document.querySelector("#qlwcdc_quick_view_modal .single_add_to_cart_button").style.marginTop = "10px";
					document.querySelector("#qlwcdc_quick_view_modal .single_add_to_cart_button").style.width = "100%";
					document.querySelector('#qlwcdc_quick_view_modal button.qlwcdc_quick_purchase').style.width = "100%";

				}
			}

			function showTextService(btnAdd) {
				let cosmetsProduct = false;
				const nameOfProduct = document.querySelector('h1.product_title').innerText.toLowerCase();
				const marqueOfProduct = document.querySelector('h2.product-designer-title').innerText.toLowerCase();

				if (marqueOfProduct.indexOf("cosmétique") !== -1) cosmetsProduct = true;
				else {
						cosmetsName.forEach(function(word) {
								if (nameOfProduct.indexOf(word) !== -1) cosmetsProduct = true;
						});
				}
				that.setState({cosmetsProduct: cosmetsProduct}, () => {

					const txtService = domRoot.querySelector("#ftf-clone-service").cloneNode(true);
					txtService.id = "ftf-txt-service";
					if (txtService) {
						const parentRef = btnAdd.parentElement;
						parentRef.insertBefore(txtService, btnAdd);
						txtService.style.display = "block";
					}
				});
			}
		}

		if (hostReturned === "www.adn-paris.fr") {
			addAnalytics('GTM-NQZBFMP', hostSelect.mode);

			this.initBtnsLang();

			if(document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {
				scrapAdn();

				if(document.querySelector('.SizeSwatchList.HorizontalList .HorizontalList__Item input[type="radio"]')) {
					let sizeBtns = Array.from(document.querySelectorAll('.SizeSwatchList.HorizontalList .HorizontalList__Item input[type="radio"]'));

					for(let i = 0; i < sizeBtns.length; i++) {
						sizeBtns[i].addEventListener('click', scrapAdn);
					}
				}

				function returnSize() {
					if(document.querySelector('.SizeSwatchList.HorizontalList .HorizontalList__Item')) {
						const inputSelect = document.querySelector('.SizeSwatchList.HorizontalList .HorizontalList__Item input[type="radio"]:checked');
						if(inputSelect) return inputSelect.value;
						else return "notSelected";
					} else return null;
				}

				function returnGenre() {
					if(document.querySelector('.ProductForm__Option.ProductForm__Option--labelled > .ProductForm__Label') && document.querySelector('.ProductForm__OptionName > .ProductForm__SelectedValue')) {
						const name = document.querySelector('.ProductForm__Option.ProductForm__Option--labelled > .ProductForm__Label').innerText.replace(":", "");
						const value = document.querySelector('.ProductForm__OptionName > .ProductForm__SelectedValue').innerText;
						return [{nom: name, value: value}];
					} else return [];

				}

				function scrapAdn() {
					setTimeout(() => {
						productScrap.url = document.URL;
						productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute('content');
						productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute('content');
						productScrap.price = +document.querySelector('meta[property="product:price:amount"]').getAttribute('content').replace(",", ".");
						productScrap.size = returnSize();
						productScrap.options2 = returnGenre();
						//productScrap.color = returnColor();

						productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;

						if(productScrap.options2.length > 0) productScrap.id += productScrap.options2[0].nom + "-" + productScrap.options2[0].value;

						//cl(["produit scrapé", productScrap]);

						if(document.querySelector("#gustave-try-btn")) {
							if( (productScrap.size && productScrap.size !== "notSelected") || (document.querySelector(hostSelect.checkPageProduct) && !document.querySelector('.SizeSwatchList.HorizontalList .HorizontalList__Item')) ) showTryBtn();
							else hideTryBtn();
						}

					}, 50);
				}
			}

		}

		if (hostReturned === "fr.gilis.com") {
			addAnalytics('GTM-NZ5XJPN', hostSelect.mode);

			if(document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {
				scrapGilis();

				if(document.querySelector('.variations_form.cart .variations input[type="radio"]')) {
					let sizeBtns = Array.from(document.querySelectorAll('.variations_form.cart .variations input[type="radio"]'));

					for(let i = 0; i < sizeBtns.length; i++) {
						sizeBtns[i].addEventListener('click', scrapGilis);
					}
				}

				function returnSize() {
					if(document.querySelector('.variations_form.cart .variations')) {
						const inputSelect = document.querySelector('.variations_form.cart .variations input[type="radio"]:checked');
						if(inputSelect) {
							productScrap.price = +document.querySelector('.variations_form.cart .variations input[type="radio"]:checked').getAttribute("data-price");
							return inputSelect.value;
						}
						else return "notSelected";
					} else return null;
				}

				function scrapGilis() {
					setTimeout(() => {
						productScrap.url = document.URL;
						productScrap.name = document.querySelector("h1").innerHTML.replace("<span>", " ").replace("</span>","");
						productScrap.image = document.querySelector('.img.img-product-large img').src;
						productScrap.size = returnSize();
						//productScrap.color = returnColor();

						productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;

						//cl(["produit scrapé", productScrap]);

						if(document.querySelector("#gustave-try-btn")) {
							if( (productScrap.size && productScrap.size !== "notSelected") || (document.querySelector(hostSelect.checkPageProduct) && !document.querySelector('.variations_form.cart .variations')) ) document.querySelector("#gustave-try-btn").disabled = false;
							else document.querySelector("#gustave-try-btn").disabled = true
						}

					}, 50);
				}
			}
		}

		if (hostReturned === "balsa-leather.com") {
			addAnalytics('GTM-MQPNZ59', hostSelect.mode);

			this.initBtnsLang();

			if(document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {

				if(document.querySelector('#AddToCart--product-template span').innerText === "Précommandez !") {

					productScrap.size = "notForTry";
					hideTryBtn();

				} else {
					productScrap.url = document.URL;
					productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute('content');
					productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute('content');
					productScrap.price = +document.querySelector('meta[property="og:price:amount"]').getAttribute('content');
					productScrap.size = null;

					productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;

					//cl(["produit scrapé", productScrap]);
					showTryBtn();
				}
			}
		}

		if (hostReturned === "www.editionsmr.fr") {
			addAnalytics('GTM-PPL4JG9', hostSelect.mode);

			if(document.querySelector(".langmoilemenu")) document.querySelector(".langmoilemenu").addEventListener("click", changeLang);

			if(document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {

				if(document.querySelector("#attributes")) {
					let labelSize = Array.from(document.querySelectorAll("#attributes label.radio"));

					for(let i = 0; i < labelSize.length; i++) {
						labelSize[i].addEventListener("click", scrapEmr);
					}
				}
				/* if(document.querySelector(".fastmagreturn > p > .fastmag_stock") && document.querySelector(".fastmagreturn > p > .fastmag_stock").querySelectorAll(".instock"))  */scrapEmr();
			}

			if(document.querySelector("#gustave-try-btn") && document.querySelector("#txt1")) {
				let btnTry = document.querySelector("#gustave-try-btn");
				let spanTxt = document.querySelector("#txt1");

				btnTry.addEventListener("mouseenter", ()=>{
					if(!document.querySelector("#attributes .checked")) spanTxt.innerText = langSelect("tryBtnTxtHoverEmr", this.state);
				});
				btnTry.addEventListener("mouseleave", ()=>{
					if(spanTxt.innerText === langSelect("tryBtnTxtHoverEmr", this.state)) {
						if(window.innerWidth > 1023) spanTxt.innerText = langSelect("tryBtn", this.state);
						else spanTxt.innerText = langSelect("tryBtn", this.state).indexOf("> ") !== -1? langSelect("tryBtn", this.state).replace("> ", "") : langSelect("tryBtn", this.state);
					}
				});
			}

			function returnColor() {
				let colorSelect = null;

				const partsOfURL = document.URL.split("/");
				partsOfURL.forEach(part => {
					if (part.indexOf("color") !== -1) {
						colorSelect = part.split("color-")[1];
					}
				});

				return colorSelect;
			}

			function returnSize() {
				let sizeSelect = null;

				if(document.querySelector("#attributes .checked")) sizeSelect = sizeForLabel(document.querySelector("#attributes .selected"));
				else if(document.querySelector('.attribute_list > ul > li > label.selected')) sizeSelect = sizeForLabel(document.querySelector('.attribute_list > ul > li > label.selected'));
				else sizeSelect = "notSelected";

				return sizeSelect;
			}

			function sizeForLabel(labelElement){
				if(labelElement.classList.contains("outofinstock")) return "off";
				else return labelElement.innerText;
			}

			function scrapEmr() {

				setTimeout(()=> {

					let spanTxt = document.querySelector("#txt1");
					if(spanTxt.innerText.indexOf(langSelect("tryBtnTxtHoverEmr", that.state)) !== -1) {
						if(window.innerWidth > 1023) spanTxt.innerText = langSelect("tryBtn", that.state);
						else spanTxt.innerText = langSelect("tryBtn", that.state).indexOf("> ") !== -1? langSelect("tryBtn", that.state).replace("> ", "") : langSelect("tryBtn", that.state);
					}
					let testSize = returnSize();
					let testStore = testSize === "notSelected"? [] : inStockAtStore();
					let testDispo = testStore && testStore.length > 0? testStore.indexOf(testSize) !== -1 : false;
					//cl("size : " + testSize + " - Dispos : " + testStore.toString() + " => " + testDispo);

					if(document.querySelector(hostSelect.checkPageProduct) && !document.querySelector(hostSelect.checkPageProduct).classList.contains("outofstock") && testDispo) {
						productScrap.url = document.URL;
						productScrap.name = document.querySelector('[property="og:title"]').getAttribute("content").replace(" - Editions M.R", "");
						productScrap.image = document.querySelector('[property="og:image"]').getAttribute("content");
						if(document.querySelector('[property="og:price:amount"]')) productScrap.price = +document.querySelector('[property="og:price:amount"]').getAttribute("content").replace(",", ".");
						else if(document.querySelector('[property="product:price:amount"]')) productScrap.price = +document.querySelector('[property="product:price:amount"]').getAttribute("content").replace(",", ".");

						productScrap.size = returnSize();
						productScrap.color = returnColor();

						if(productScrap.size && productScrap.size !== "off" && productScrap.size !== "notSelected") {
							productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;
							//cl(["productScrap ->", productScrap]);
						}
						showTryBtn();

					} else if(testSize === "notSelected") {
						productScrap.size = returnSize();
						showTryBtn();

					} else if(document.querySelector(hostSelect.checkPageProduct)) {
						productScrap.size = "off";
						hideTryBtn();
					}
				}, 500);
			}

			function inStockAtStore() {
				let sizeDispo = [];
				let allSizeInStock = null;
				if(document.querySelector(".fastmagreturn > p > .fastmag_stock") && document.querySelector(".fastmagreturn > p > .fastmag_stock").querySelectorAll(".instock")) allSizeInStock = Array.from(document.querySelector(".fastmagreturn > p > .fastmag_stock").querySelectorAll(".instock"));

				if(allSizeInStock) {
					for(let i = 0; i < allSizeInStock.length; i++) {
						sizeDispo.push(allSizeInStock[i].innerText.trim());
					}
				}

				//cl(sizeDispo);
				return sizeDispo;
			}

			function changeLang() {
				setTimeout(() => {
					if(window.location.pathname.split('/')[1] === "en" && lang === "FR") {
						lang = "EN";
						that.setState({appLang: "EN"});
					} else if(window.location.pathname.split('/')[1] === "fr" && lang === "EN") {
						lang = "FR";
						that.setState({appLang: "FR"});
					}
				}, 250);
			}
		}

		if (hostReturned === "dianavaradi.com") {
			addAnalytics('GTM-KG337D5', hostSelect.mode);

			if(document.querySelector(hostSelect.checkPageProduct)) scrapDv();

			if(document.querySelector("#taille")) document.querySelector("#taille").addEventListener("change",scrapDv);
			if(document.querySelector("#size")) document.querySelector("#size").addEventListener("change",scrapDv);

			function scrapDv() {
				setTimeout(()=> {
					if(document.querySelector(hostSelect.checkPageProduct).disabled) {
						if(document.querySelector("#taille")) {
							if(!document.querySelector("#taille").value) productScrap.size = "notSelected";
							else productScrap.size = "off";
						}
						if(document.querySelector("#size")) {
							if(!document.querySelector("#size").value) productScrap.size = "notSelected";
							else productScrap.size = "off";
						}
						showTryBtn();
						document.querySelector("#gustave-try-btn").disabled = true;

					} else {
						showTryBtn();
						if(document.querySelector("#gustave-try-btn") && document.querySelector("#gustave-try-btn").disabled) document.querySelector("#gustave-try-btn").disabled = false;

						productScrap.url = document.URL;
						productScrap.name = document.querySelector('h1.entry-title').innerText;
						productScrap.image = document.querySelector('meta[property="og:image"]').getAttribute("content");
						if(document.querySelector('meta[itemprop="price"]')) productScrap.price = +document.querySelector('meta[itemprop="price"]').getAttribute("content").replace(",", ".");

						if(document.querySelector("#taille")) productScrap.size = document.querySelector("#taille").value;
						else if(document.querySelector("#size")) productScrap.size = document.querySelector("#size").value;

						if(productScrap.size && productScrap.size !== "off" && productScrap.size !== "notSelected") {
							productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price
							//cl(["productScrap ->", productScrap]);
						}
					}
				}, 200);
			}
		}

		if (hostReturned === "affrenchies.com") {
			addAnalytics('GTM-TDWFK2T', hostSelect.mode);

			scrapAff();

			if(document.querySelector("#single-option-selector-0")) document.querySelector("#single-option-selector-0").addEventListener("change", scrapAff);
			if(document.querySelector("#single-option-selector-1")) document.querySelector("#single-option-selector-1").addEventListener("change", scrapAff);

			function scrapAff() {
				if(document.querySelector(hostSelect.checkPageProduct) && document.querySelector(hostSelect.checkPageProduct).innerText !== "EN RUPTURE") {
					productScrap.url = document.URL;
					productScrap.name = document.querySelector('[property="og:title"]').getAttribute("content");
					productScrap.image = document.querySelector('[property="og:image:secure_url"]').getAttribute("content");
					productScrap.price = +document.querySelector('[property="og:price:amount"]').getAttribute("content").replace(",", ".");
					if(document.querySelector("#single-option-selector-0")) productScrap.size = document.querySelector("#single-option-selector-0").value;

					if(document.querySelector("#single-option-selector-1")) productScrap.color = document.querySelector("#single-option-selector-1").value

					productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price
					//cl(["productScrap ->", productScrap]);
					showTryBtn();

				} else if(document.querySelector(hostSelect.checkPageProduct)) {
					productScrap.size = "off";
					hideTryBtn();
				}
			}

		}

		if (hostReturned === "oth-paris.com") {
			addAnalytics('GTM-PSFD4SC', hostSelect.mode);

			this.initBtnsLang();

			function scrapOth(e) {
				let delayTimeout = 50;
				if(e) {
					//cl(e.target.id)
					delayTimeout = 100;
				}

				setTimeout(function(){
					//cl("scrapOth timeout!!!")
					let btnAddToCartDisplay = !document.querySelector(hostSelect.checkPageProduct).disabled;
					//cl("btnAddToCartDisplay : " + btnAddToCartDisplay);
					if(btnAddToCartDisplay && document.querySelector('.product__title') && document.querySelector('.product__title').innerText.toLowerCase().indexOf("précommande") === -1) {
						productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute("content");
						productScrap.url = document.URL;
						productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute("content");
						productScrap.price = +document.querySelector('meta[property="og:price:amount"]').getAttribute("content").replace(',','.');
						productScrap.size = document.querySelector("#Taille").value;
						productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price
						//cl(["productScrap ->", productScrap]);
						showTryBtn();

					} else {
						hideTryBtn();
						if (document.querySelector('.product__title') && document.querySelector('.product__title').innerText.toLowerCase().indexOf("précommande") === -1) {
							//cl("rupture de stock !");
							productScrap.size = "off";
						} else {
							//cl("précommande !");
							productScrap.size = "notForTry";
						}
					}
				}, delayTimeout);
			}

			if(document.querySelector(hostSelect.checkPageProduct)) {
				scrapOth(false);
				if(document.querySelector("#Taille")) document.querySelector("#Taille").addEventListener("change", scrapOth);
			}
		}

		if (hostReturned === "www.aujuste.fr") {
			addAnalytics('GTM-NGX56VX', hostSelect.mode);

			function scrapAuJuste(e) {

				setTimeout(function(){
					//cl("scrapAuJuste !!!")
					//if(e) //cl(e.target.id)
					if(!document.querySelector(".single_add_to_cart_button").classList.contains("disabled") && document.querySelector(".single_add_to_cart_button").innerText !== "PRÉCOMMANDER") {
						if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = false;
						//cl("no disabled !!!")
						if(document.querySelector("#pa_couleur")) {
							///cl("scrapcolor !!!", document.querySelector("#pa_couleur").value)
							if(document.querySelector("#pa_couleur").selectedIndex !== 0) {
								let value = document.querySelector("#pa_couleur").value;
								productScrap.color = document.querySelector('#pa_couleur option[value="' + value + '"]').innerText;
							} else productScrap.color = "notSelected";
						} else if(document.querySelector("#couleur")) {
							//cl("scrapcolor !!!", document.querySelector("#couleur").value)
							if(document.querySelector("#couleur").selectedIndex !== 0) {
								let value = document.querySelector("#couleur").value;
								productScrap.color = document.querySelector('#couleur option[value="' + value + '"]').innerText;
							} else productScrap.color = "notSelected";
						} else productScrap.color = null;

						if(document.querySelector("#pa_taille")) {
							//cl("scrapsize !!!", document.querySelector("#pa_taille").value)
							if(document.querySelector("#pa_taille").selectedIndex !== 0) {
								let value = document.querySelector("#pa_taille").value;
								productScrap.size = document.querySelector('#pa_taille option[value="' + value + '"]').innerText;
							} else productScrap.size = "notSelected";
						}

						if(productScrap.size !== "notSelected" && productScrap.color !== "notSelected") {
							//cl("not notselected !!!")
							let priceValue = 0;
							productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute("content")
							productScrap.url = document.querySelector('meta[property="og:url"]').getAttribute("content")
							productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute("content")
							if(document.querySelector('.product-page-price ins .woocommerce-Price-amount')) priceValue = +document.querySelector('.product-page-price ins .woocommerce-Price-amount').innerText.replace("€","");
							else if(document.querySelector('.product-page-price .woocommerce-Price-amount')) priceValue = +document.querySelector('.product-page-price .woocommerce-Price-amount').innerText.replace("€","");
							productScrap.price = priceValue;
							productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price
							//cl("productScrap ->", productScrap)

						} else {
							//cl("notselected !!!", productScrap.size, productScrap.color)
							if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = true;
						}
					} else {
						//cl("off !!!", productScrap.size, productScrap.color)
						if((e && e.target.id === "pa_couleur") || !e) productScrap.color = "off";
						if((e && e.target.id === "pa_taille") || !e) productScrap.size = "off";
						if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = true;
					}
				}, 100);
			}

			if(document.querySelector(hostSelect.checkPageProduct)) {
				scrapAuJuste(false);
				if(document.querySelector("#pa_couleur")) document.querySelector("#pa_couleur").addEventListener("change", scrapAuJuste);
				if(document.querySelector("#pa_taille")) document.querySelector("#pa_taille").addEventListener("change", scrapAuJuste);
			}
		}

		if (hostReturned === "www.gangofearlybirds.com") {
			addAnalytics('GTM-K74BMWF', hostSelect.mode);

			//this.initBtnsLang();

			if(document.querySelector("button.add-to-cart")) {
				productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute("content")
				productScrap.url = document.querySelector('meta[property="og:url"]').getAttribute("content")
				productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute("content")
				productScrap.price = +document.querySelector('.product-item__price.product-item__price--new').innerText.split(" ")[0].replace(",", ".")
				if(document.querySelector(".product__variant-color.active")) productScrap.color = document.querySelector(".product__variant-color.active").getAttribute("data-color")
				if(document.querySelector(".product__variants-size .custom-select__current")) {
					scrapGoeb();

					var observerTailleGoeb = new MutationObserver(function(mutations) {
						// scrap
						setTimeout(function() {
							scrapGoeb();
						},250)
					});
					var targetGoeb = document.querySelector(".product__variants-size .custom-select__current")
					observerTailleGoeb.observe(targetGoeb, { childList: true });
				}

			}
			function scrapGoeb() {
				let diffMoment = moment().diff("2019-06-26T00:00:00", "seconds");
				//if(diffMoment < 0) cl("J" + diffMoment + " secondes");

				let soldedProduct = document.querySelector('.product-item__price--old').innerText;

				if(!soldedProduct || (soldedProduct && diffMoment >= 0)) {

					let nbrArtSold = 0;
					if(that.state.cart.length > 0) nbrArtSold = that.state.cart.filter(product=>product.sold).length
					else if(cart.length > 0) nbrArtSold = cart.filter(product=>product.sold).length
					//cl("nbrArtSold : " + nbrArtSold)

					if(document.querySelector(".product__variants-size .custom-select__current").innerText.indexOf("Épuisé") !== -1) {
						productScrap.size = "off"
						hideTryBtn();

					} else {
						if(soldedProduct && nbrArtSold >= 3) productScrap.size = "soldmax";
						else productScrap.size = document.querySelector(".product__variants-size .custom-select__current").innerText;

						if(soldedProduct && diffMoment >= 0) {
							productScrap.info = langSelect("artsale", that.state);
							productScrap.sold = true;
							//cl(productScrap)
						}
						showTryBtn();
					}

				} else {
					productScrap.size = "notForTry"
					hideTryBtn();
				}
				productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price
				//cl("productScrap ->", productScrap)
			}
		}

		if (hostReturned === "www.karinelecchi.com") {
			addAnalytics('GTM-556NRFF', hostSelect.mode);

			const excludedProduct = urlsExcluded(hostSelect);
			//cl("excludedProduct " + excludedProduct);

			if(excludedProduct) {
				hideTryBtn();
				productScrap.size = "notForTry";
			} else {

				if(document.querySelector('button.ProductForm__AddToCart')) {

					var observerTailleKL = new MutationObserver(function(mutations) {
						// change color btn
						if(document.querySelector("#gustave-try-btn") && !document.querySelector("#gustave-try-btn").classList.contains("changeColor")) {
							document.querySelector("#gustave-try-btn").classList.add("changeColor");
							document.querySelector("#gustave-try-btn").style.height = window.getComputedStyle(document.querySelector('button.ProductForm__AddToCart'), null).getPropertyValue("height");
						}
						if(domRoot.querySelector("#gustave-cart") && !domRoot.querySelector("#gustave-cart").classList.contains("changeColor")) {
							domRoot.querySelector("#gustave-cart").classList.add("changeColor");
						}

						scrapKL();

					});
					var targetKL = document.querySelector('.ProductForm__OptionName span')
					observerTailleKL.observe(targetKL, { childList: true });
				}

				scrapKL();
			}

			// scrap
			function scrapKL() {
				setTimeout(function() {
					if(document.querySelector('button[data-action="add-to-cart"]')) {
						productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute("content");
						productScrap.url = document.querySelector('meta[property="og:url"]').getAttribute("content");
						productScrap.image = document.querySelector('meta[property="og:image:secure_url"]').getAttribute("content");
						productScrap.price = +document.querySelector('meta[property="og:price:amount"]').getAttribute("content");
						productScrap.size = document.querySelector('.ProductForm__OptionName span').innerText;
						productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;
						showTryBtn();

					} else {
						hideTryBtn();
						productScrap.size = "off";
					}
				},250);
			}

		}

		if (hostReturned === "fr.perus.co") {
			addAnalytics('GTM-5CDGWSX', hostSelect.mode);

			if (document.querySelector("#ProductSelect-option-0")) document.querySelector("#ProductSelect-option-0").addEventListener("click", function() {
				hideTryBtn();

				setTimeout(function(){
					const sizes = Array.from(document.querySelectorAll(".single-option-radio input[type='radio']"));
					const scrapSize = document.querySelector(".single-option-radio input[type='radio']:checked");
					cl("setTimeout => size : " + scrapSize.value);
					if (document.querySelector(hostSelect.checkPageProduct) && (document.querySelector(hostSelect.checkPageProduct).innerText === "UNAVAILABLE" || document.querySelector(hostSelect.checkPageProduct).classList.contains("spo-hidden"))) {
						hideTryBtn();
						productScrap.size = "off";

					} else if (sizes.length > 1) {
						that.testRuptureCsv(hostSelect.productsOff)
						.then(rupture => {
							if (!rupture) perusScrap();
							else {
								cl("en rupture dans fichier csv");
								hideTryBtn();
							}
						})
						.catch(error => {/* console.log("testRuptureCsv error :\n", error) */});
					} else perusScrap();

				}, 100);

			});

			if (document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {

				setTimeout(function(){
					const sizes = Array.from(document.querySelectorAll(".single-option-radio input[type='radio']"));
					const scrapSize = document.querySelector(".single-option-radio input[type='radio']:checked");
					cl("setTimeout => size : " + scrapSize.value);
					if (document.querySelector(hostSelect.checkPageProduct) && (document.querySelector(hostSelect.checkPageProduct).innerText === "UNAVAILABLE" || document.querySelector(hostSelect.checkPageProduct).classList.contains("spo-hidden"))) {
						hideTryBtn();
						productScrap.size = "off";

					} else if (sizes.length > 1) {
						that.testRuptureCsv(hostSelect.productsOff)
						.then(rupture => {
							if (!rupture) perusScrap();
							else {
								cl("en rupture dans fichier csv");
								hideTryBtn();
								productScrap.size = "off";
							}
						})
						.catch(error => {/* console.log("testRuptureCsv error :\n", error) */});
					} else perusScrap();

				}, 100);

			} else cl("page non produit ou exclue");

			function perusScrap() {
				if (document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect) && document.querySelector(hostSelect.checkPageProduct).innerText !== "UNAVAILABLE" && !document.querySelector(hostSelect.checkPageProduct).classList.contains("spo-hidden")) {
					cl("perusScrap");
					const sizes = Array.from(document.querySelectorAll(".single-option-radio input[type='radio']"));
					const scrapSize = document.querySelector(".single-option-radio input[type='radio']:checked");

					if ((scrapSize && scrapSize.value !== "Default Title") || sizes.length === 1) {
						const scrapScriptTxt = document.querySelector(".main-content .wrapper script:nth-of-type(2)") && document.querySelector(".main-content .wrapper script:nth-of-type(2)").innerText && document.querySelector(".main-content .wrapper script:nth-of-type(2)").innerText.indexOf(',"variants":') !== -1? JSON.parse(document.querySelector(".main-content .wrapper script:nth-of-type(2)").innerText.split(',"variants":')[1].split(',"images":')[0]) : null;

						const infos = scrapScriptTxt? scrapScriptTxt.filter(value=>value.title===scrapSize.value)[0] : null;

						if (infos && infos.inventory_quantity > 0) {
							productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute("content");
							productScrap.url = document.querySelector('meta[property="og:url"]').getAttribute("content");
							productScrap.image = "https:" + document.querySelector('#ProductPhotoImg').getAttribute("src").replace("https:","");
							productScrap.price = +document.querySelector('meta[property="og:price:amount"]').getAttribute("content");
							if (document.querySelector(".single-product_color-active") && document.querySelector(".single-product_color-active").getAttribute("style")) productScrap.color = document.querySelector(".single-product_color-active").getAttribute("style").split("background-color: ")[1].split(";")[0];
							productScrap.size = sizes.length > 1? scrapSize.value : null;

							productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;
							cl(["productScrap ->", productScrap]);

							showTryBtn();

						} else {
							hideTryBtn();
							productScrap.size = "off";
							cl("bad info stock");
						}
					}
				} else {
					if (document.querySelector(hostSelect.checkPageProduct) && (document.querySelector(hostSelect.checkPageProduct).innerText === "UNAVAILABLE" || document.querySelector(hostSelect.checkPageProduct).classList.contains("spo-hidden"))) {
						hideTryBtn();
						productScrap.size = "off";
					}
				}
			}
		}

		if (hostReturned === 'www.communedeparis1871.fr') {
			addAnalytics('GTM-NMDWZVH', hostSelect.mode);

			if(document.querySelector(".js-add_to_cart")) {
				if(document.querySelector(".size-options-wrapper").innerText.indexOf("Epuisé") !== -1) {
					hideTryBtn();
					productScrap.size = "off";
				} else if (!document.querySelector('body a[href="/fr/lines/new-arrivals"]') && !document.querySelector('body a[href="/fr/lines/classiques"]')) {
					hideTryBtn();
					productScrap.size = "notForTry";
				} else {
					productScrap.name = document.querySelector("h1").innerText;
					productScrap.price = +(document.querySelector("#item_price").getAttribute("value"));
					productScrap.image = document.querySelector(".img-responsive").getAttribute("src");
					productScrap.url = document.URL;

					if(document.querySelector(".js-size-selector")) {
						productScrap.size = document.querySelector(".js-size-selector > .selected").innerText;

						document.querySelector(".js-size-selector").addEventListener("click", () => {
							productScrap.size = document.querySelector(".js-size-selector > .selected").innerText;
							if(document.querySelector(".js-list-color")) productScrap.color = document.querySelector(".js-list-color > li").innerText;
							productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;
						});
					}

					if(document.querySelector(".js-list-color")) productScrap.color = document.querySelector(".js-list-color > li").innerText;

					productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;
					showTryBtn();
				}
			}
		}

		if (hostReturned === 'www.fraiche-paris.fr') {
			addAnalytics('GTM-PBPPPK6', hostSelect.mode);

			function clickVariations(){
				//cl("clickVariations")
				setTimeout(function(){
					if (document.querySelector('.variable-items-wrapper li.selected')) {
						if (document.querySelector('.stock.in-stock')) {
							productScrap.size = document.querySelector('.variable-items-wrapper li.selected').getAttribute('data-value').toUpperCase()
							productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price
							//cl(productScrap);
						} else {
							productScrap.size = "off"
						}
					} else {
						productScrap.size = "notSelected"
					}
				},100)
			}
			function changeVariations(){
				//cl("changeVariations")
				setTimeout(function(){
					if(document.querySelector('#taille')) {
						if(document.querySelector('#taille').value==="") productScrap.size = "notSelected"
						else productScrap.size = document.querySelector('#taille').value
					}

					if(document.querySelector('#couleur')) {
						if(document.querySelector('#couleur').value==="") productScrap.color = "notSelected"
						else productScrap.color = document.querySelector('#couleur').value
					} else productScrap.color = null

					if(productScrap.size || productScrap.color) {
						productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price
						//cl(productScrap);
					}

					if(!document.querySelector('.stock.in-stock') && productScrap.size && productScrap.size !== "notSelected" && !(productScrap.color && productScrap.color === "notSelected")) productScrap.size = "off"

					if(!document.querySelector('.stock.in-stock') && productScrap.color && productScrap.color !== "notSelected" && !(productScrap.size && productScrap.size === "notSelected")) productScrap.color = "off"

				},100)
			}

			if(document.querySelector('.single_add_to_cart_button')){
				productScrap.price = +(document.querySelector('form.variations_form').getAttribute('data-product_variations').split('display_price')[1].split('"')[1].replace(':', '').split(',')[0])
				productScrap.image = document.querySelector('[data-elementor-type="product"] .elementor-image img').getAttribute("src")
				productScrap.name = document.querySelector('.elementor-widget-container h1').innerText

				if(document.querySelector('.variable-items-wrapper li')) {
					if(document.querySelector('.variable-items-wrapper li.selected')){
						productScrap.size = document.querySelector('.variable-items-wrapper li.selected').getAttribute('data-value').toUpperCase()
					} else  productScrap.size = "notSelected"
				}

				if(document.querySelector('#taille')) {
					if(document.querySelector('#taille').value==="") productScrap.size = "notSelected"
					else productScrap.size = document.querySelector('#taille').value
				}

				if(document.querySelector('#couleur')) {
					if(document.querySelector('#couleur').value==="") productScrap.color = "notSelected"
					else productScrap.color = document.querySelector('#couleur').value
				} else productScrap.color = null

				productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price

				if(!document.querySelector('.stock.in-stock') && productScrap.size && productScrap.size !== "notSelected" && !(productScrap.color && productScrap.color === "notSelected")) productScrap.size = "off"

				if(!document.querySelector('.stock.in-stock') && productScrap.color && productScrap.color !== "notSelected" && !(productScrap.size && productScrap.size === "notSelected")) productScrap.color = "off"

				// création des eventlisteners selon selecteurs de la page
				if(document.querySelector('.variations') && !document.querySelector('#taille') && !document.querySelector('#couleur')){
					document.querySelector('.variations').addEventListener('click', clickVariations)
				} else {
					document.querySelector('.variations').removeEventListener("click", clickVariations)
					if(document.querySelector('#taille')) {
						document.querySelector('#taille').addEventListener("change", changeVariations)
					}
					if(document.querySelector('#couleur')) {
						document.querySelector('#couleur').addEventListener("change", changeVariations)
					}
				}
				//cl(productScrap)
			}


		}

    	if (hostReturned === 'www.camilleveganbags.com' && !ifIsShopify) {
			addAnalytics('GTM-TK6BLVP', hostSelect.mode);

			this.initBtnsLang();

			if (document.querySelector(".ProductForm__AddToCart")) {
				if (document.querySelector(".ProductForm__AddToCart").innerText !== "RUPTURE") {
					productScrap.name = document.querySelector("h1").innerText
					productScrap.price = +(document.querySelector(".ProductMeta__Price").innerText.replace("€", ""))
					productScrap.image = "https:" + document.querySelector(".Image__Loader + noscript").innerText.split('src="')[1].split('" alt=')[0]
					productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price;
					showTryBtn();
					
				} else hideTryBtn();
			}
		}

		if (hostReturned === 'www.unx-paris.com') {
			addAnalytics('GTM-PGQL5TH', hostSelect.mode);

			this.initBtnsLang();

			if (document.querySelector(".AddtoCart")) {
				productScrap.price = +(document.querySelector('.money').innerText.split('€')[0].replace(',', '.'))
				productScrap.name = document.querySelector('meta[itemprop="name"]').getAttribute('content')
				productScrap.image = document.querySelector('meta[itemprop="image"]').getAttribute('content')

				if(document.querySelector('input[name="taille"]:checked')) {
					if (document.querySelector('input[name="taille"]:checked').parentElement.classList.contains("soldout")) {
						productScrap.size = "off";
						if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = true
					} else {
						productScrap.size = document.querySelector('input[name="taille"]:checked').value;
						if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = false
					}
				}

				productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price

				document.querySelector('.swatch.clearfix').addEventListener("click", function () {
					setTimeout(function () {
						if (document.querySelector('input[name="taille"]:checked').parentElement.classList.contains("soldout")) {
							productScrap.size = "off";
							if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = true
						} else {
							productScrap.size = document.querySelector('input[name="taille"]:checked').value;
							if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = false
						}
						productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price
					}, 100);
				})
			}
		}

		if (hostReturned === 'lesgarconsfaciles.com') {
			addAnalytics('GTM-W27QNZH', hostSelect.mode);

			if (document.querySelector('#add_to_cart')) {
				var observer = new MutationObserver(function (mutations) {
					if (mutations[0].target.attributes[2].nodeValue.split(": ").length === 2 && mutations[0].target.attributes[2].nodeValue.split(": ")[0] === "display") {
						var display = mutations[0].target.attributes[2].nodeValue.split(": ")[1].replace(";", "");
						cl(["MutationObserver => display : " + display, "target => display : " + target.style.display]);
						if (display !== undefined && document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").style.display = display;
					}
				});
				var target = document.querySelector('#add_to_cart');
				observer.observe(target, { attributes : true, attributeFilter : ['style'] });

				if (document.querySelector('#color_to_pick_list')) {
					var colorBtns = Array.from(document.querySelectorAll('#color_to_pick_list a.color_pick'));
					for (let i = 0; i < colorBtns.length; i++) {
						colorBtns[i].addEventListener('click', scrapLgf);
					}
				}

				if (document.querySelector('.select-selected')) {
					var sizeBtns = Array.from(document.querySelectorAll('.select-items > div'));
					for (let i = 0; i < sizeBtns.length; i++) {
						sizeBtns[i].addEventListener('click', scrapLgf);
					}
				}

				scrapLgf();
			}

			function scrapLgf() {
				setTimeout(function () {
					if (document.querySelector('#add_to_cart').style.display !== "none" && !urlsExcluded(hostSelect)) {
						productScrap.price = +(document.querySelector("#our_price_display").getAttribute('content'));
						productScrap.name = document.querySelector('meta[property="og:title"]').getAttribute('content');

						if (document.querySelector("#thumbs_list")) {
							productScrap.image = document.querySelector('#thumbs_list li[style="display: list-item;"] > a').href;
						} else productScrap.image = document.querySelector('meta[property="og:image"]').getAttribute('content');

						if (document.querySelector("#color_to_pick_list li.selected")) {
							productScrap.color = document.querySelector("#color_to_pick_list li.selected > a").getAttribute('name');
							productScrap.color = productScrap.color.indexOf('- ') !== -1? productScrap.color.split('- ')[1] : productScrap.color;
						}

						if (document.querySelector('.select-selected')) productScrap.size = document.querySelector('.select-selected').innerText;

						productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price;

						showTryBtn();

					} else {
						hideTryBtn();

						if (urlsExcluded(hostSelect)) {
							productScrap.color = null;
							productScrap.size = "notfortry";

						} else {
							productScrap.color = "off";
							productScrap.size = "off";
						}
					}
				}, 100);
			}
		}

		if (hostReturned === 'flairisfrench.com') {
			addAnalytics('GTM-M7VXXSK', hostSelect.mode);

			this.initBtnsLang();

			if(document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {

				if(document.querySelectorAll('input[name="option-0"]')) {
					let sizeOption = Array.from(document.querySelectorAll('input[name="option-0"]'));

					for(let i = 0; i < sizeOption.length; i++) {
						sizeOption[i].addEventListener("click", scrapFlair);
					}
				}
				if(document.querySelectorAll('input[name="option-1"]')) {
					let colorOption = Array.from(document.querySelectorAll('input[name="option-1"]'));

					for(let i = 0; i < colorOption.length; i++) {
						colorOption[i].addEventListener("click", scrapFlair);
					}
				}

				if (hostSelect.productsOn) {
					this.testDispoCsv(hostSelect.productsOn)
					.then(dispo => {
						if (dispo) scrapFlair();
						else {
							//cl("pas dans fichier csv");
							hideTryBtn();
							productScrap.size = "notForTry";
						}
					})
					.catch(error => {/* console.log("testDispoCsv error :\n", error) */});

				} else scrapFlair();

				function returnSize() {
					let sizeSelect = null;
					if(document.querySelector('input[name="option-0"]')) {
						let sizeOption = Array.from(document.querySelectorAll('input[name="option-0"]'));

						for(let i = 0; i < sizeOption.length; i++) {
							let size = sizeOption[i];
							let sizeDispo = sizeOption[i].parentElement;
							if(size.checked) {
								if(!sizeDispo.classList.contains("soldout")) sizeSelect = size.value;
								else sizeSelect = "off";
							}
						}
					}
					return sizeSelect;
				}
				function returnColor() {
					let colorSelect = null;
					if(document.querySelector('input[name="option-1"]')) {
						let colorOption = Array.from(document.querySelectorAll('input[name="option-1"]'));

						for(let i = 0; i < colorOption.length; i++) {
							let color = colorOption[i];
							let colorDispo = colorOption[i].parentElement;
							if(color.checked) {
								if(!colorDispo.classList.contains("soldout")) colorSelect = color.value;
								else colorSelect = "off";
							}
						}
					}
					return colorSelect;
				}
				function scrapFlair() {
					setTimeout(()=> {
						if(document.querySelector(hostSelect.checkPageProduct).disabled) {
							hideTryBtn();
							productScrap.size = "off";
						} else {
							if (that.isOneOfProductsOn(hostSelect)) {
								let nameForId = document.querySelector('head > meta[name="twitter:title"]').getAttribute("content").trim().replace("|", "");
								if(nameForId) nameForId = nameForId.trim();
								productScrap.name = that.state.appLang === "FR"? document.querySelector('h1.product-title > span.lang1').innerText : document.querySelector('h1.product-title > span.lang2').innerText;
								productScrap.price = +(document.querySelector('head > meta[name="twitter:data1"]').getAttribute('content').split("€")[0]);
								productScrap.image = "https:" + document.querySelector(".thumb.slick-slide.slick-current.slick-active > a > img").getAttribute("src");

								productScrap.size = returnSize();
								productScrap.color = returnColor();

								if(productScrap.size && productScrap.size !== "off" && productScrap.color !== "off") {
									productScrap.id = nameForId+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;
									//cl(productScrap);
								}
								showTryBtn();

							} else {
								//cl("pas dans fichier csv");
								hideTryBtn();
								productScrap.size = "notForTry";
							}
						}

					}, 250);
				}
			}
		}

		if (hostReturned === '17h10.com') {
			addAnalytics('GTM-5C8HQKV', hostSelect.mode);

			this.initBtnsLang();

			let selectsInPage = 0;

			if(document.querySelector(".add_to_cart") && !urlsExcluded(hostSelect)) {
				scrap17h10();
			} else if (document.querySelector("#gustave-try-btn")) {
				document.querySelector("#gustave-try-btn").classList.add("hide-try-btn");
			}

			if(document.querySelector('input[name="option-0"]')) {
				selectsInPage++;
				document.querySelector('[data-option-index="0"]').addEventListener("click", scrap17h10);
				document.querySelector('[data-option-index="0"]').setAttribute("mg-init", true);
			}
			if(document.querySelector('input[name="option-1"]')) {
				selectsInPage++;
				document.querySelector('[data-option-index="1"]').addEventListener("click", scrap17h10);
				document.querySelector('[data-option-index="1"]').setAttribute("mg-init", true);
			}
			if(document.querySelector('input[name="option-2"]')) {
				selectsInPage++;
				document.querySelector('[data-option-index="2"]').addEventListener("click", scrap17h10);
				document.querySelector('[data-option-index="2"]').setAttribute("mg-init", true);
			}

			function scrap17h10() {
				setTimeout(function(){
					if(document.querySelector(".add_to_cart").classList.contains("disabled") || document.querySelector(".add_to_cart span").innerText === "ÉPUISÉ" || urlsExcluded(hostSelect)) { // si rupture
						hideTryBtn();

						if(document.querySelector('input[name="option-0"]')) {
							if(document.querySelector('input[name="option-0"]:checked + div').classList.contains("soldout")) productScrap.color = "off";
						}
						if(document.querySelector('input[name="option-1"]')) {
							if(document.querySelector('input[name="option-1"]:checked + div').classList.contains("soldout")) productScrap.size = "off";
						}
						if(document.querySelector('input[name="option-2"]')) {
							if(document.querySelector('input[name="option-2"]:checked + div').classList.contains("soldout")) productScrap.size = "off";
						}

					} else { // si dispo
						if (document.querySelector('.option_title')) selectsInPage = document.querySelectorAll('.option_title').length;
						else selectsInPage = -1;

						if(document.querySelector('input[name="option-0"]')) {
							if(document.querySelector('input[name="option-0"]:checked')) setValueAndLabel(document.querySelector('input[name="option-0"]:checked'));
						}
						if(document.querySelector('input[name="option-1"]')) {
							if(document.querySelector('input[name="option-1"]:checked')) setValueAndLabel(document.querySelector('input[name="option-1"]:checked'));
						}
						if(document.querySelector('input[name="option-2"]')) {
							if(document.querySelector('input[name="option-2"]:checked')) setValueAndLabel(document.querySelector('input[name="option-2"]:checked'));
						}
						showTryBtn();
					}
				}, 200);
			}

			function setValueAndLabel(el) {
				setTimeout(() => {
					const label = el.parentElement.firstChild.nextElementSibling.textContent;
					const value = el.value;

					cl(["setValueAndLabel => label : " + label, "value : " + value]);

					if(label === "Taille" || label === "Tailles") productScrap.size = value;
					else if(label === "Color" || label === "Couleur") productScrap.color = value;
					else {
						if(el.getAttribute('name') === "option-1") productScrap.size = langSelect(label, that.state) + value;
						else if(el.getAttribute('name') === "option-2") productScrap.size += ", " + langSelect(label, that.state) + value;
					}

					if ( !selectsInPage || (selectsInPage === 3 && productScrap.color && productScrap.size && productScrap.size.indexOf(",") !== -1) || (selectsInPage === 2 && productScrap.color && productScrap.size) || (selectsInPage === 1 && (productScrap.color || productScrap.size)) ) {
						productScrap.name = document.querySelector("h1.product_name").innerText;
						productScrap.price = document.querySelector('span[itemprop="price"]')? +document.querySelector('span[itemprop="price"]').getAttribute("content") : 0;
						if (document.querySelector(".product_gallery_nav > .gallery-cell > img")) productScrap.image = "https:" + document.querySelector(".product_gallery_nav > .gallery-cell > img").getAttribute("src");
						else if (document.querySelector(".flickity-slider > .gallery-cell > a")) productScrap.image = "https:" + document.querySelector(".flickity-slider > .gallery-cell > a").getAttribute("href");

						productScrap.id = productScrap.name+'-'+productScrap.color+'-'+productScrap.size+'-'+productScrap.price;

						//cl(["productScrap", productScrap]);
					}
				}, 200);
			}

			if (!domRoot.querySelector("#stripe-js")) {
				let scriptStripeJs = document.createElement('script');
				scriptStripeJs.id = "stripe-js";
				scriptStripeJs.type = 'text/javascript';
				scriptStripeJs.async = true;
				scriptStripeJs.src= "https://js.stripe.com/v3/";
				domRoot.appendChild(scriptStripeJs);
			}
		}

		if (hostReturned === 'www.manoush.com') {
			addAnalytics('GTM-NTHP234', hostSelect.mode);

			if (document.querySelector("#btnSubmit") && !urlsExcluded(hostSelect)){
				if(document.querySelector('.product__price span[itemprop="price"]')) productScrap.price = +(document.querySelector('.product__price span[itemprop="price"]').innerText.split('€')[0].replace(',', '.'))
				if(document.querySelector('.product__aside h3[itemprop="name"]')) productScrap.name = document.querySelector('.product__aside h3[itemprop="name"]').innerText
				if(document.querySelector('.swiper-wrapper img')) productScrap.image = document.querySelector('.swiper-wrapper img').getAttribute('src')
				if(document.querySelector('.color-selector span[class="selected"]')) productScrap.color = document.querySelector('.color-selector span[class="selected"]').getAttribute('title');

				if (window.innerWidth >= 991){
					if (!document.querySelector('div[class="product__size__list"] div span.selected')) {
						productScrap.size = "notSelected";
						//document.querySelector("#gustave-try-btn").disabled = true
					} else if (document.querySelector('div[class="product__size__list"] div span[class="Sizemob 0 indispo selected"]') || document.querySelector('div[class="product__size__list"] div span[class="Sizemob 0 indispo   selected"]')) {
						productScrap.size = "off"
						if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = true
					} else {
						productScrap.size = document.querySelector('div[class="product__size__list"] div span.selected').innerText;
						if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = false
					}

					if (document.querySelector('.product__size__list')) document.querySelector('.product__size__list').addEventListener("click", function () {
						setTimeout(function () {
							if (!document.querySelector('div[class="product__size__list"] div span.selected')) {
								productScrap.size = "notSelected";
								//document.querySelector("#gustave-try-btn").disabled = true
							} else if (document.querySelector('div[class="product__size__list"] div span[class="Sizemob 0 indispo selected"]') || document.querySelector('div[class="product__size__list"] div span[class="Sizemob 0 indispo   selected"]')) {
								productScrap.size = "off"
								if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = true
							} else {
								productScrap.size = document.querySelector('div[class="product__size__list"] div span.selected').innerText;
								if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = false
								productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price

							}
						}, 500);
					})
					productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price;

				} else {
					const newBanner = document.createElement('div');
					newBanner.className = 'product__size size-selector js-select Select-to-buy';

					const titleSpan = document.createElement('span');
					titleSpan.innerText = 'Sélectionnez la taille';
					titleSpan.classList = 'product__attributes__title';

					const closeEl = document.createElement('i');
					closeEl.classList = 'product__size__hide icon icon-arrow-bottom';
					closeEl.addEventListener('click', function () {
						document.querySelector("#add_to_cart").classList.remove("inactive");
						document.querySelector('#newBanner').classList.remove("active");
						document.querySelector('#newBanner').classList.remove("product__size--active");
					});
					titleSpan.appendChild(closeEl);

					const tailleListDiv = document.createElement('div');
					tailleListDiv.className = 'product__size__list';

					const oldTailleBanner = Array.from(document.querySelectorAll('.product__size__list > div'));
					oldTailleBanner.forEach(divSize => {
							const divCloned = divSize.cloneNode(true);
							const allChild = Array.from(divCloned.querySelectorAll("span, button"));
							for(let i = 0; i < allChild.length; i++) {
								allChild[i].style.pointerEvents = "none";
							}
							divCloned.style.cursor = "pointer";
							divCloned.addEventListener('click', function (e) {
								if (!e.target.classList.contains('disabled')) {
									document.querySelector('.selected').classList.remove('selected');
									e.target.classList.add('selected');
									productScrap.size = e.target.children[0].innerText;
									productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price;
									that.addToCabine(e, "add", "click sur div size manoush");
								}
							});
							tailleListDiv.appendChild(divCloned);
					});
					newBanner.appendChild(titleSpan)
					newBanner.appendChild(tailleListDiv)
					newBanner.appendChild(document.querySelector('.product__btn-guide'))
					newBanner.setAttribute('id','newBanner')
					document.querySelector('#attributes').appendChild(newBanner)
				}
			}
		}

		if (hostReturned === 'wibes-store.com') {
			addAnalytics('GTM-PVLH8HG', hostSelect.mode);

			if (document.querySelector('#pa_taille')) {
				document.querySelector('#pa_taille').addEventListener("change", function () {
					setTimeout(() => {
						if (document.querySelector('div.woocommerce-variation-availability p.out-of-stock') || that.isOneOfProductsOff(hostSelect)) {
							productScrap.size = "off";
							if (document.querySelector("#gustave-try-btn") && !document.querySelector("#gustave-try-btn").disabled) document.querySelector("#gustave-try-btn").disabled = true;

						} else if (document.querySelector('#pa_taille') && !document.querySelector('#pa_taille').value) {
							productScrap.size = "notSelected";
							if (document.querySelector("#gustave-try-btn") && document.querySelector("#gustave-try-btn").disabled) document.querySelector("#gustave-try-btn").disabled = false;

						} else {
							if (that.isOneOfProductsOn(hostSelect)) scrapWibes();
							else {
								//cl("pas dans fichier csv");
								if (document.querySelector("#gustave-try-btn") && !document.querySelector("#gustave-try-btn").disabled) document.querySelector("#gustave-try-btn").disabled = true;
								productScrap.size = "notForTry";
							}
						}
					}, 100);
				});
			}

			if (document.querySelector('.reset_variations')) {
				document.querySelector('.reset_variations').addEventListener("click", () => {
					productScrap.size = "notSelected";
					if (document.querySelector("#gustave-try-btn") && !document.querySelector("#gustave-try-btn").disabled) document.querySelector("#gustave-try-btn").disabled = true;
				});
			}

			if (document.querySelector(hostSelect.checkPageProduct) && !urlsExcluded(hostSelect)) {
				if (document.querySelector('div.woocommerce-variation-availability p.out-of-stock')) {
					productScrap.size = "off";
					if (document.querySelector("#gustave-try-btn") && !document.querySelector("#gustave-try-btn").disabled) document.querySelector("#gustave-try-btn").disabled = true;

				} else if (document.querySelector('#pa_taille') && !document.querySelector('#pa_taille').value) {
					productScrap.size = "notSelected";
					if (document.querySelector("#gustave-try-btn") && document.querySelector("#gustave-try-btn").disabled) document.querySelector("#gustave-try-btn").disabled = false;

				} else {
					if (hostSelect.productsOn) {
						this.testDispoCsv(hostSelect.productsOn)
						.then(dispo => {
							if (dispo) scrapWibes();
							else {
								//cl("pas dans fichier csv");
								if (document.querySelector("#gustave-try-btn") && !document.querySelector("#gustave-try-btn").disabled) document.querySelector("#gustave-try-btn").disabled = true;
								productScrap.size = "notForTry";
							}
						})
						.catch(error => {/* console.log("testDispoCsv error :\n", error) */});

					} else scrapWibes();
				}
			}

			function scrapWibes() {
				//cl("scrapWibes");
				setTimeout(() => {
					productScrap.name = document.querySelector(".titre").innerText;
					productScrap.price = +(document.querySelector('ins span.woocommerce-Price-amount').innerText.replace(",", ".").replace("€", ""));
					productScrap.image = document.querySelector(".wp-post-image").getAttribute("src");
					productScrap.size = document.querySelector('#pa_taille').value;

					productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price;
					//cl("productScrap ->", productScrap);

					if(document.querySelector("#gustave-try-btn") && document.querySelector("#gustave-try-btn").disabled) document.querySelector("#gustave-try-btn").disabled = false;
				}, 100);
			}
		}

		if (hostReturned === 'maisonkitsune.com') {
			if (document.querySelector('#product-addtocart-button')){

				productScrap.price = +(document.querySelector(".price-container meta:first-of-type[itemprop='price']").getAttribute("content"))
				productScrap.name = document.querySelector(".page-title > .base[itemprop='name']").innerText
				productScrap.color = document.querySelector("div[itemprop='sku']").innerText.split("-")[1] ;
				productScrap.image = document.querySelector('meta[property="og:image"]').getAttribute('content')

				if (!document.querySelector(".swatch-option.text.selected")) {
					productScrap.size = "notSelected";
					//document.querySelector("#gustave-try-btn").disabled = true
				} else if (document.querySelector(".swatch-option.text.disabled.surrounded") && document.querySelector('#gustave-try-btn')) {
					productScrap.size = "off";
					document.querySelector('#gustave-try-btn').classList.remove('gustave-try-btn-class1')
					document.querySelector('#gustave-try-btn').classList.add('gustave-try-btn-class2')
					//document.querySelector("#gustave-try-btn").disabled = false
				} else {
					if(document.querySelector("#gustave-try-btn")) document.querySelector('#gustave-try-btn').classList.remove('gustave-try-btn-class2')
					if(document.querySelector("#gustave-try-btn")) document.querySelector('#gustave-try-btn').classList.add('gustave-try-btn-class1')
					productScrap.size = document.querySelector(".swatch-option.text.selected").getAttribute("option-tooltip-value");
					if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = false
				}

				document.querySelector(".swatch-attribute-options.clearfix").addEventListener("click", function () {
					setTimeout(function () {
						if (!document.querySelector(".swatch-option.text.selected")) {
							productScrap.size = "notSelected";
							//document.querySelector("#gustave-try-btn").disabled = true
						} else if (document.querySelector(".swatch-option.text.disabled.surrounded")){
							document.querySelector('#gustave-try-btn').classList.add('gustave-try-btn-class2')
							productScrap.size = "off";
							if(document.querySelector("#gustave-try-btn")) document.querySelector('#gustave-try-btn').classList.remove('gustave-try-btn-class1')
							if(document.querySelector("#gustave-try-btn")) document.querySelector('#gustave-try-btn').classList.add('gustave-try-btn-class2')
							//document.querySelector("#gustave-try-btn").disabled = false
						}else{
							if(document.querySelector("#gustave-try-btn")) document.querySelector('#gustave-try-btn').classList.remove('gustave-try-btn-class2')
							if(document.querySelector("#gustave-try-btn")) document.querySelector('#gustave-try-btn').classList.add('gustave-try-btn-class1')
							productScrap.size = document.querySelector(".swatch-option.text.selected").getAttribute("option-tooltip-value");
							if(document.querySelector("#gustave-try-btn")) document.querySelector("#gustave-try-btn").disabled = false
							productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price
						}

					}, 100);
				})
				productScrap.id = productScrap.name + '-' + productScrap.color + '-' + productScrap.size + '-' + productScrap.price
			}
		}

		if (iosLoad) { // ajout des onTouchEnd

			if(domRoot.querySelector("#gustave-cart")) domRoot.querySelector("#gustave-cart").addEventListener("touchend", function(e){
				if(e.cancelable) e.preventDefault()
				e.stopPropagation()
				that.btnCartHandleClick(e)
			});

			if(domRoot.querySelector("#overlay")) domRoot.querySelector("#overlay").addEventListener("touchend", function(e){
				if(e.cancelable) e.preventDefault()
				e.stopPropagation()
				that.handleCloseClick(e)
			});
			if(domRoot.querySelector("#btn-close")) domRoot.querySelector("#btn-close").addEventListener("touchend", function(e){
				if(e.cancelable) e.preventDefault()
				e.stopPropagation()
				that.btnCloseWidgetHandleClick(e)
			});
			if(domRoot.querySelector("#FR")) domRoot.querySelector("#FR").addEventListener("touchend", function(e){
				if(e.cancelable) e.preventDefault()
				e.stopPropagation()
				that.btnsLangHandleClick(e)
			});
			if(domRoot.querySelector("#EN")) domRoot.querySelector("#EN").addEventListener("touchend", function(e){
				if(e.cancelable) e.preventDefault()
				e.stopPropagation()
				that.btnsLangHandleClick(e)
			});
		}

		if (hostSelect) {
			if(hostSelect.maxProducts) maxProductNumberRef = +hostSelect.maxProducts;
			if(hostSelect.indispos && (hostSelect.indispos.start || hostSelect.indispos.end)) that.showClosedInCab(hostSelect.indispos);

			let updateState = {};
			if (hostSelect.frais) updateState.frais = hostSelect.frais;
			if (hostSelect.maxProducts) maxProductNumberRef = +hostSelect.maxProducts;
			// FR
			if (hostSelect.txtCcmPh1) updateState.txtCcmPh1 = hostSelect.txtCcmPh1;
			if (hostSelect.txtCcmPh2) updateState.txtCcmPh2 = hostSelect.txtCcmPh2;
			if (hostSelect.txtCcmPh3) updateState.txtCcmPh3 = hostSelect.txtCcmPh3;
			if (hostSelect.txtCcmPh4) updateState.txtCcmPh4 = hostSelect.txtCcmPh4;
			if (hostSelect.txtCcmPh4fee) updateState.txtCcmPh4fee = hostSelect.txtCcmPh4fee;
			if (hostSelect.txtCcmPh4feeCab) updateState.txtCcmPh4feeCab = hostSelect.txtCcmPh4feeCab;
			if (hostSelect.txtCcmPlaces) updateState.txtCcmPlaces = hostSelect.txtCcmPlaces;
			if (hostSelect.txtCcmBtn) updateState.txtCcmBtn = hostSelect.txtCcmBtn;
			//EN
			if (hostSelect.txtCcmPh1EN) updateState.txtCcmPh1EN = hostSelect.txtCcmPh1EN;
			if (hostSelect.txtCcmPh2EN) updateState.txtCcmPh2EN = hostSelect.txtCcmPh2EN;
			if (hostSelect.txtCcmPh3EN) updateState.txtCcmPh3EN = hostSelect.txtCcmPh3EN;
			if (hostSelect.txtCcmPh4EN) updateState.txtCcmPh4EN = hostSelect.txtCcmPh4EN;
			if (hostSelect.txtCcmPh4feeEN) updateState.txtCcmPh4feeEN = hostSelect.txtCcmPh4feeEN;
			if (hostSelect.txtCcmPh4feeCabEN) updateState.txtCcmPh4feeCabEN = hostSelect.txtCcmPh4feeCabEN;
			if (hostSelect.txtCcmPlacesEN) updateState.txtCcmPlacesEN = hostSelect.txtCcmPlacesEN;
			if (hostSelect.txtCcmBtnEN) updateState.txtCcmBtnEN = hostSelect.txtCcmBtnEN;
			if (hostSelect.widgetSubTitle) updateState.widgetSubTitle = hostSelect.widgetSubTitle;

			if (sessionStorage.getItem('gustave-client')) updateState.client = JSON.parse(sessionStorage.getItem('gustave-client'));

			if (updateState) that.setState(updateState);

			if (hostSelect.indispos && (hostSelect.indispos.start || hostSelect.indispos.end)) that.showClosedInCab(hostSelect.indispos);
		}

		//afficher le widget si le client il vient d'un rediriction à partir d'un mail de relance
		let testOpenWidget = sessionStorage.getItem('testOpenWidget');
		if (!testOpenWidget && showCart !== "none") {
			let xhr2 = new XMLHttpRequest();
			xhr2.onreadystatechange = function () {
				if (xhr2.readyState === 4 && xhr2.status === 200) {
					sessionStorage.setItem('testOpenWidget', "true");
					if (xhr2.responseText) {
						let retour = JSON.parse(xhr2.responseText);
						if (retour.result.orderId !== "pub") { // mail de relance
							if (retour.result.host && that.state.cart.length > 0) { // panier récupéré du local storage
								that.setState({ workflowStep:'1' }, () => that.showOverlay(null));

							} else if ( retour.result.host && that.state.cart.length === 0 ) { // panier récupéré depuis la commande
								const cart = retour.command.data;
								const cNumOfPToAdd = that.calculNumOfProductsToAdd(cart);
								const activeDynTxt = cart && cart.length > 0 && cart.length < cNumOfPToAdd.maxProductNumber;
								that.cabSubTitleDyn(activeDynTxt, cNumOfPToAdd.productsNumberToAdd);

								that.setState({
									workflowStep:'1',
									cart: cart,
									prixTotalCart: that.calculTotalCart(cart),
									maxProductNumber: cNumOfPToAdd.maxProductNumber,
									productsNumberToAdd: cNumOfPToAdd.productsNumberToAdd,
									totalArticles: cNumOfPToAdd.totalAdded,
									msgEmptyCab: cart.length === 0? true : false
								}, () => that.showOverlay(null));
								if (!hostSelect.saveCart) localStorage.setItem('gustave-cart', JSON.stringify(cart));
							}

						} else if (retour.result.orderId === "pub") { // pub
							that.setState({workflowStep: '0'}, () => that.showOverlay(null));
						}
					}
				}
			}
			xhr2.open('GET', URL_BACK[returnHostMode(hostSelect.mode)] + '/openwidget/' + hostReturned + '/' + IP_ADDRESS +'/widget' , true);
			xhr2.send(null);
		}

		checkLang();
		if (ifIsShopify && sessionStorage.getItem('orderId') && sessionStorage.getItem('lang')) this.modifyPage();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const that = this;

		if (this.state.appLang !== prevState.appLang) {
			this.setState({appLang: this.state.appLang});
			lang = this.state.appLang;
			sessionStorage.setItem('gustave-lang', this.state.appLang);
			langSelect("steps", this.state);

			if(hostSelect.saveCart && this.state.cart.length>0) this.saveCartDomain(this.state.cart);
		}

		if (this.state.reduc !== prevState.reduc) {
			this.setState({
				reduc: this.state.reduc,
				prixTotalCart: this.calculTotalCart(this.state.cart)});
		}

		if (this.state.cart !== prevState.cart) {
			cl("componentDidUpdate cart update");
			const cNumOfPToAdd = this.calculNumOfProductsToAdd(this.state.cart);

			this.setState({
				cart: this.state.cart,
				prixTotalCart: this.calculTotalCart(this.state.cart),
				maxProductNumber: cNumOfPToAdd.maxProductNumber,
				productsNumberToAdd: cNumOfPToAdd.productsNumberToAdd,
				totalArticles: cNumOfPToAdd.totalAdded,
				msgEmptyCab: this.state.cart.length === 0? true : false,
				workflowStep: '1',
				orderStep: !this.state.client.orderId? 0 : 2,
				showSteps: this.state.cart.length === 0? false : this.state.showSteps
			});

			if (hostSelect.saveCart) {
				if (this.state.cart.length > 0) this.saveCartDomain(this.state.cart)
				else this.removeCartDomain()
			}
		}

		if (this.state.prixTotalCart !== prevState.prixTotalCart) {
			this.setState({prixTotalCart: this.state.prixTotalCart});
		}

		if (this.state.maxProductNumber !== prevState.maxProductNumber) {
			this.setState({maxProductNumber: this.state.maxProductNumber});
		}

		if (this.state.productsNumberToAdd !== prevState.productsNumberToAdd) {
			this.setState({productsNumberToAdd: this.state.productsNumberToAdd});
		}

		if (this.state.workflowStep !== prevState.workflowStep) this.setState({workflowStep: this.state.workflowStep});
		if (this.state.orderStep !== prevState.orderStep) this.setState({orderStep: this.state.orderStep});
		if (this.state.client !== prevState.client) {
			this.setState({client: this.state.client}); sessionStorage.setItem('gustave-client', JSON.stringify(this.state.client));
		}
		if (this.state.orderIdSave !== prevState.orderIdSave) this.setState({orderIdSave: this.state.orderIdSave});

		if (this.state.txtBtnTry !== prevState.txtBtnTry) this.setState({txtBtnTry: this.state.txtBtnTry});
		if (this.state.txtCcmPh1 !== prevState.txtCcmPh1) this.setState({txtCcmPh1: this.state.txtCcmPh1});
		if (this.state.txtCcmPh2 !== prevState.txtCcmPh2) this.setState({txtCcmPh2: this.state.txtCcmPh2});
		if (this.state.txtCcmPh3 !== prevState.txtCcmPh3) this.setState({txtCcmPh3: this.state.txtCcmPh3});
		if (this.state.txtCcmPh4 !== prevState.txtCcmPh4) this.setState({txtCcmPh4: this.state.txtCcmPh4});
		if (this.state.txtCcmPh4fee !== prevState.txtCcmPh4fee) this.setState({txtCcmPh4fee: this.state.txtCcmPh4fee});

		if (this.state.token !== prevState.token) this.setState({token: this.state.token});
		if (this.state.stripeLoading !== prevState.stripeLoading) this.setState({stripeLoading: this.state.stripeLoading});

		if (iosLoad) { // ajout des TouchEnd si ios et éléments présents

			if (domRoot.querySelector(".btn-delete")) this.activeTouchEndBtnDelete();

			if (domRoot.querySelector(".autocomplete-dropdown-container") && !that.state.loading) {
				var dropdownTarget = domRoot.querySelector(".autocomplete-dropdown-container")
				var dropdownObserver = new MutationObserver(function (mutations) {
					that.activeTouchEndSugg()
				});
				dropdownObserver.observe(dropdownTarget, { childList: true });
			}

			let onTouchEnd = [
				{id:"#btn-arrow", event:that.btnArrowLeftHandleClick},
				{id:"#btnAide", event:that.btnAideHandleClick},
				{id:"#btnMail", event:that.btnMailHandleClick},
				{id:"#btnPlan", event:that.btnPlanHandleClick},
				{id:"#ftfTsLink", event:that.ftfTsHandleClick},
				{id:"#btn-essayer", event:that.btnCcmEssayerHandleClick},
				{id:"#cab-btnPlanifier", event:that.btnCabPlanMonEssHandleClick},
				{id:"#checkPromo", event:that.promoValHandleClick},
				{id:".ccm-txt", event:that.btnCabCcmHandleClick},
				{id:".promo-txt", event:that.btnPromoCancelHandleClick},
				{id:"#btn-order0", event:that.btnStepHandleClick},
				{id:"#btn-order1", event:that.btnStepHandleClick},
				{id:"#btn-precInf", event:that.infPrecedentHandleClick},
				{id:"#btn-suivInf", event:that.infSuivantHandleClick},
				{id:"#adressInput", event:''},
				{id:"#otherAdressInput", event:''},
				{id:"#prenomInput", event:''},
				{id:"#nomInput", event:''},
				{id:"#emailInput", event:''},
				{id:"#telInput", event:''},
				{id:"#promoCode", event:''},
				{id:"#inputPromo", event:''}
			];

			onTouchEnd.forEach((value, index)=>{
				if(domRoot.querySelector(value.id) && eventOkFor.indexOf(value.id)===-1) { // si flair ios, élément présent et touchend non ajouté

					//cl("AJOUT de l'event pour : " + value.id)
					domRoot.querySelector(value.id).addEventListener("touchend", function(e){
						if(e.cancelable) e.preventDefault()
						e.stopPropagation()

						if(value.event==="") {
							e.target.focus();
						} else if(value.id==="#btn-suivInf") {
							that.infSuivantHandleClick(e, 'clic Suivant sur le SLIDE Infos', 'SUIVANT');
						} else if(value.id==="#btn-precInf") {
							that.infPrecedentHandleClick(e, 'clic Précédent sur le SLIDE Infos', 'SUIVANT');
						} else {
							onTouchEnd[index].event(e)
						}
					})

					eventOkFor.push(value.id)

				} else if(!domRoot.querySelector(value.id) && eventOkFor.indexOf(value.id)!==-1){ // si élément non présent et touchend déjà ajouté
					eventOkFor = eventOkFor.filter(val=>val!==value.id)
				}
			})

		}

		if (hostSelect.customStyle) {
			//cl("customize " + hostReturned);
			customizeCss(hostReturned, domRoot);
			window.addEventListener('resize', customizeCss(hostReturned, domRoot));
		}

		if (!ifIsShopify && domRoot.querySelector("#cartBadge") && document.querySelector("#gustave-cart") && !document.querySelector("#cartBadge")) {
			this.attachCartBadge();
		}

		const activeDynTxt = this.state.workflowStep === '1' && this.state.orderStep === 0 && this.state.cart && this.state.cart.length > 0 && this.state.productsNumberToAdd > 0;
		this.cabSubTitleDyn(activeDynTxt, this.state.productsNumberToAdd);


		if (domRoot.querySelector("#btnMail") && domRoot.querySelector("#btnMail:not([clickEvent])")) {
			domRoot.querySelector("#btnMail").setAttribute("clickEvent", "true");
			domRoot.querySelector("#btnMail").onclick = this.btnMailHandleClick;
		}

		if (domRoot.querySelector("#btnFaq") && domRoot.querySelector("#btnFaq:not([clickEvent])")) {
			domRoot.querySelector("#btnFaq").setAttribute("clickEvent", "true");
			domRoot.querySelector("#btnFaq").onclick = this.btnFaqHandleClick;
		}
	}

	attachCartBadge = () => {
		const divCart = document.querySelector("#gustave-cart").parentElement;
		const badge = domRoot.querySelector("#cartBadge");

		divCart.appendChild(badge);
	}

	initBtnsLang = () => {

		if (document.querySelector("#gustave-try-btn")) {
			const txt1 = document.querySelector("#gustave-try-btn").querySelector("#txt1");
			const txt2 = document.querySelector("#gustave-try-btn").querySelector("#txt2");
			const txt3 = document.querySelector("#gustave-try-btn").querySelector("#txt3");
			const span = document.querySelector("#gustave-try-btn").innerHTML && document.querySelector("#gustave-try-btn").innerHTML.indexOf("<span>") !== -1;

			cl("txt1 : " + (txt1? "find" : "notFind") + " - txt2 : " + (txt2? "find" : "notFind") + " - txt3 : " + (txt3? "find" : "notFind"));

			if (!txt1 && !txt2){
				document.querySelector("#gustave-try-btn").innerHTML = span? "<span>" + langSelect("tryBtn", this.state) + "</span>" : (langSelect("tryBtn", this.state) + (txt3? '<span id="txt3" style="pointer-events: none;">' + langSelect("tryBtnSpan", this.state) + '</span>' : ''));

			} else {
				if (txt1) txt1.innerText = langSelect("tryBtn", this.state);
				if (txt2) txt2.innerText = langSelect("tryBtn", this.state);
			}
		}

		if (document.querySelector('li.wg-li.fr')) document.querySelector('li.wg-li.fr').addEventListener('click', () => {
			lang = "FR";
			this.setState({appLang: "FR"}, () => {
				this.initBtnsLang();
			});
		});

		if (document.querySelector('li.wg-li.en')) document.querySelector('li.wg-li.en').addEventListener('click', () => {
			lang = "EN";
			this.setState({appLang: "EN"}, () => {
				this.initBtnsLang();
			});
		});

		if (document.querySelector('li.wg-li.de')) document.querySelector('li.wg-li.de').addEventListener('click', () => {
			lang = "EN";
			this.setState({appLang: "EN"}, () => {
				this.initBtnsLang();
			});
		});

		if (document.querySelector('li.wg-li.es')) document.querySelector('li.wg-li.es').addEventListener('click', () => {
			lang = "EN";
			this.setState({appLang: "EN"}, () => {
				this.initBtnsLang();
			});
		});

		if (document.querySelector('li.wg-li.it')) document.querySelector('li.wg-li.it').addEventListener('click', () => {
			lang = "EN";
			this.setState({appLang: "EN"}, () => {
				this.initBtnsLang();
			});
		});

		if (document.querySelector('li.wg-li.ja')) document.querySelector('li.wg-li.ja').addEventListener('click', () => {
			lang = "EN";
			this.setState({appLang: "EN"}, () => {
				this.initBtnsLang();
			});
		});

		if (document.querySelector('li.wg-li.pt')) document.querySelector('li.wg-li.pt').addEventListener('click', () => {
			lang = "EN";
			this.setState({appLang: "EN"}, () => {
				this.initBtnsLang();
			});
		});

		if (document.querySelector('li.wg-li.zh')) document.querySelector('li.wg-li.zh').addEventListener('click', () => {
			lang = "EN";
			this.setState({appLang: "EN"}, () => {
				this.initBtnsLang();
			});
		});

		if (hostReturned === "okan-studio.com") {
			if (document.querySelector('.sticky-product-scroll > h3.subheader')) {
					document.querySelector('.sticky-product-scroll > h3.subheader').style.width = "fit-content";
					var widthToSet = window.getComputedStyle(document.querySelector('.sticky-product-scroll > h3.subheader'), null).getPropertyValue("width");
					if (document.querySelector('form[action="/cart/add"] div.purchase-details ')) document.querySelector('form[action="/cart/add"] div.purchase-details ').style.width = widthToSet;
					if (document.querySelector('form[action="/cart/add"] .selector-wrapper')) document.querySelector('form[action="/cart/add"] .selector-wrapper').style.width = widthToSet;
			}
		}
	}

	returnInfosCollection = (collection) => {
		urlDocReturned = returnDocumentURL();
		let info = null;
		let date = null;
		if (!collection) return {info: null, date: null};
		else {
			collection.forEach(collect => {
				collect.words.forEach(word => {
					if (urlDocReturned.indexOf(word) !== -1) {
						const now = moment().format("YYYY-MM-DD");
						const dateNow = moment(now);
						const dateTry = moment(collect.date);
						const delay = dateTry.diff(dateNow, "days");
						cl(["dateNow : " + dateNow.format(), "dateTry : " + dateTry.format(), "délai : " + delay]);
						if (delay > 0) {
							info = collect.msg;
							date = collect.date;
						}
					}
				});
			});
			return {info: info, date: date};
		}
	}

	testRuptureCsv(file) {
		cl("testRuptureCsv");
		const that = this;

		return new Promise((resolve, reject) => {
			const xhrCsv = new XMLHttpRequest();
			xhrCsv.onreadystatechange = function () {
				if (xhrCsv.readyState === 4) {
					if (xhrCsv.status === 200) {
						cl(["testRuptureCsv response", xhrCsv.responseText]);
						resolve(that.isOneOfProductsOff(hostSelect, xhrCsv.responseText));
					} else {
						cl(["erreur fichier csv", xhrCsv.responseText]);
						reject(this.responseText);
					}
				}
			}
			xhrCsv.open( 'GET', URL_CONFIG + "?type=csvs&name=" + file);
			xhrCsv.send(null);
		});

	}

	isOneOfProductsOff(hostSelect, productsOff) {
		cl("isOneOfProductsOff : " + hostSelect.host);
		let rupture = false;
		//let productsOff = productsOff;
		if (productsOff) {
			productsOff = productsOff.replace(/ /g, "").split(/\n/);
			cl("productsOff : " + productsOff.length);

			if (hostSelect.scrapSize && document.querySelector(hostSelect.scrapSize)) {
				let productSize = null;
				if (hostReturned === "fr.perus.co") productSize = document.querySelector(hostSelect.scrapSize).value;

				productsOff.forEach(value => {
					if (document.URL.indexOf(value.split(";")[0]) !== -1 && productSize === value.split(";")[1]) {
						cl(["find in csv, rupture", value, "size : " + productSize]);
						rupture = true;
					}
				});
			}
		} else cl("fichier csv vide");

		return rupture;
	}

	testDispoCsv(file) {
		//cl("testDispoCsv");
		const that = this;

		return new Promise((resolve, reject) => {
			const xhrCsv = new XMLHttpRequest();
			xhrCsv.onreadystatechange = function () {
				if (xhrCsv.readyState === 4) {
					if (xhrCsv.status === 200) {
						sessionStorage.setItem("productsOn" + hostReturned, this.responseText);
						resolve(that.isOneOfProductsOn(hostSelect));
					} else {
						//cl(["erreur fichier csv", this.responseText]);
						reject(this.responseText);
					}
				}
			}
			xhrCsv.open( 'GET', URL_CONFIG + "/widget/" + file);
			xhrCsv.send(null);
		});
	}

	isOneOfProductsOn(hostSelect) {
		//cl("isOneOfProductsOn : " + hostSelect.host);
		let dispo = false;
		let productsOn = sessionStorage.getItem("productsOn" + hostReturned)? sessionStorage.getItem("productsOn" + hostReturned) : "";
		if (productsOn) {
			productsOn = productsOn.replace(/ /g, "").split(/\n/);
			//cl(["productsOn : " + productsOn.length, productsOn]);
			let productSize = null;
			let flairVariant = null;
			let wibesH1 = null;

			if (hostReturned === "flairisfrench.com") {
				if (window.location.search.indexOf("variant=") !== -1) flairVariant = "" + window.location.search.split("variant=")[1];
				else flairVariant = "" + window.meta.product.variants[0].id;

			} else if (hostReturned === "wibes-store.com") {
				wibesH1 = document.querySelector("h1").innerText.toLowerCase();
				productSize = document.querySelector('#pa_taille').value;
			}

			productsOn.forEach(value => {
				if (flairVariant && flairVariant === "" + value) {
					//cl("find in csv, dispo");
					dispo = true; return dispo;

				} else if (wibesH1 && productSize) {
					const title = value.split(";")[0].toLowerCase();
					const size = value.split(";")[1];
					if(title === wibesH1 && size === productSize) {/* cl("find in csv, dispo");  */dispo = true; return dispo;}
				}
			});
		} else {
			//cl("fichier csv vide");
			dispo = true;
		}

		return dispo;
	}

	convertDateForMoment(date) {
		const formatedDate = date.split("-")[2] + "-" + date.split("-")[1] + "-" + date.split("-")[0];
		return formatedDate;
	}

	showClosedInCab(indispos) {
		//cl(indispos);
		const jour = moment().format("YYYY-MM-DD").split("T")[0];
		const start = indispos.start? moment(this.convertDateForMoment(indispos.start)) : null;
		const end = indispos.end? moment(this.convertDateForMoment(indispos.end)) : null;

		//cl(["jour : " + jour, "start : " + start.format("YYYY-MM-DD").split("T")[0], "end : " + end.format("YYYY-MM-DD").split("T")[0]]);

		let delayStart = null, delayEnd = null;
		if(start) delayStart = moment(jour).diff(start.format(), "days");
		if(end) delayEnd = moment(jour).diff(end.format(), "days");

		//cl(["delayStart : " + delayStart, "delayEnd : " + delayEnd]);

		if(delayEnd && delayEnd < 0) {
			let firstTryEN = moment(end.format());
			firstTryEN.locale('en');
			firstTryEN = firstTryEN.add(1, "days").format("LL");
			firstTryEN = firstTryEN.substr(0, firstTryEN.length-6);


			let firstTry = end.add(1, "days").format("LL");
			firstTry = firstTry.substr(0, firstTry.length-5);
			if(delayStart && delayStart >= 0) {

				//cl(["firstTry : " + firstTry, "firstTryEN : " + firstTryEN]);

				const msgsClosed = {
					FR: "Exceptionnellement votre essayage ne pourra pas être planifié*avant le " + firstTry + ".",
					EN: "Exceptionally your fitting can not be planned*before " + firstTryEN + "."
				}

				this.setState({
					msgsClosed: msgsClosed
				});
			}
		}
	}

	handleStripeJs(stripeInit) {
		this.setState({stripe: stripeInit});
	}

	calculTotalCart = (cart) => {
		let total = cart.reduce((total, val) => total + val.price, 0);
		//cl("total cart : " + total);

		//cl("reduction : " + this.state.reduc);
		if(this.state.reduc) {
			//cl("reduction : " + this.state.reduc);
			if(this.state.reduc.indexOf("%") !== -1) { // si reduc en pourcentage
				let reduc = +this.state.reduc.replace(/ /g, "").split("%")[0];
				total = total - ((total * reduc) / 100);

			} else { // si reduc en euros
				let reduc = +this.state.reduc.replace(/ /g, "").split("€")[0];
				total = total - reduc;
			}
			//cl("total après réduction : " + total);
		}

		return total;
	}

	calculNumOfProductsToAdd = (cart) => {
		//cl("calculNumOfProductsToAdd => nombre d'articles : " + cart.length);

		let modifMaxProductNumber = maxProductNumberRef;

		if(hostReturned === "17h10.com") {
			cart.forEach(product => {
				if(product.name.indexOf(" ") !== -1 && product.name.split(" ")[0].toLowerCase() === "tailleur") modifMaxProductNumber -= 1;
			});
		}

		let productsNumberToAdd = 0;
		let productNumber = 0;

		if (cart && cart.length > 0) {
			productNumber = cart.reduce((total, nbr) => total + (nbr.quantity > 0? +nbr.quantity : 1), 0);
			productsNumberToAdd = modifMaxProductNumber - productNumber;
		}

		return {
			productsNumberToAdd: productsNumberToAdd,
			maxProductNumber: modifMaxProductNumber,
			totalAdded: productNumber
		};
	}

	enableTryBtnClick = () => {
		if (ifIsShopify) {
			this.initBtnsShopify(true);
			this.initObservers();
			this.updateCabWithShopifyCart();

		} else if (hostSelect && !urlsExcluded(hostSelect) && document.querySelector(hostSelect.checkPageProduct)) {
			pageProduct = true;
			if(document.querySelector("#gustave-try-btn") && showCart!=="none") {

				if(hostReturned === 'www.manoush.com' && window.innerWidth < 991){
					document.querySelector('#gustave-try-btn').onclick = this.ManouchBtnTryHandleClick;
					if (document.querySelector("#gustave-try-btn").style.cursor === "wait") this.ManouchBtnTryHandleClick();
				} else {
					document.querySelector("#gustave-try-btn").onclick = this.btnTryHandleClick;
					if (document.querySelector("#gustave-try-btn").style.cursor === "wait") this.btnTryHandleClick();
				}
				showTryBtn();
				document.querySelector("#gustave-try-btn").style.cursor = "pointer";
			}
		} else pageProduct = false;

		if (!ifIsShopify && document.querySelector("#gustave-cart")) {
			if (document.querySelector("#loading-cart")) {
				document.querySelector("#gustave-cart").innerHTML = '<svg style="pointer-events: none; width: 27px !important;" width="27px" height="100%" viewBox="0 0 90 64" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><title>Merci Gustave</title><desc>Service d\'essayage</desc><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="noun_hanger_2323549" transform="translate(-1.000000, 0.000000)"><g id="Group"><path d="M85.903,55.424 L47.734,32.403 L6.067,55.44 C4.863,56.135 4.681,57.353 4.923,58.255 C5.165,59.157 5.93,60.122 7.356,60.122 L84.644,60.122 C86.069,60.122 86.835,59.158 87.076,58.255 C87.318,57.353 87.137,56.135 85.903,55.424 Z" id="Path"></path><path d="M87.848,52.125 L49.69,29.11 L49.69,23.977 C49.69,23.287 50.164,22.638 50.929,22.283 C55.021,20.372 57.664,16.221 57.664,11.709 C57.664,5.278 52.431,0.047 45.998,0.047 C39.568,0.047 34.336,5.278 34.336,11.709 C34.336,12.766 35.193,13.624 36.251,13.624 C37.308,13.624 38.166,12.767 38.166,11.709 C38.166,7.39 41.68,3.877 45.998,3.877 C50.319,3.877 53.834,7.391 53.834,11.709 C53.834,14.74 52.058,17.528 49.311,18.811 C47.182,19.801 45.86,21.781 45.86,23.977 L45.86,29.062 L4.184,52.106 C1.66,53.562 0.47,56.431 1.223,59.246 C1.977,62.061 4.441,63.953 7.356,63.953 L84.644,63.953 C87.558,63.953 90.022,62.061 90.776,59.247 C91.529,56.431 90.34,53.562 87.848,52.125 Z M87.077,58.256 C86.835,59.159 86.07,60.123 84.645,60.123 L7.356,60.123 C5.931,60.123 5.165,59.158 4.923,58.256 C4.681,57.354 4.863,56.135 6.067,55.441 L47.733,32.404 L85.902,55.425 C87.137,56.135 87.318,57.353 87.077,58.256 Z" id="Shape" fill="#FFFFFF" fill-rule="nonzero"></path></g></g></g></svg>';
			}
			document.querySelector("#gustave-cart").onclick = this.showOverlay;
			if (document.querySelector("#gustave-cart").style.cursor === "wait") {
				document.querySelector("#gustave-cart").style.cursor = "pointer";
				this.showOverlay(null);
			}
		}
	}

	////////////////////// SHOPIFY functions only ///////////////////////////////
	verifyBtnCloned() {
		cl("verifyBtnCloned");

		hostSelect.btns.forEach(function(btn) {
			const idBtn = '#gustave-' + btn.type;
			if (document.querySelector(btn.selector) && !document.querySelector(idBtn)) {
				cl("verifyBtnCloned => recreate " + idBtn);
				hostSelect.seeCartBtn = document.querySelector(btn.selector);
				createShopifyBtns(hostSelect.seeCartBtn, btn.type, hostSelect.seeCartBtn.parentElement, btn.span);
			}
		});

		this.initBtnsShopify(false);
	}

	initBtnsShopify(initObserver) {
		cl("initBtnsShopify => initObserver : " + initObserver);
		//const that = this;

		const btnSeeCart = document.querySelector("#gustave-seeCart");
		const btnSeeCartStatus = btnSeeCart? btnSeeCart.getAttribute("status") : "";
		if (btnSeeCart && btnSeeCartStatus === "waitForEvent") {
			cl("initBtnsShopify => btnSeeCart");
			btnSeeCart.setAttribute("status", "eventInitied");
			btnSeeCart.onclick = this.showOverlay;
			if (btnSeeCart.style.cursor === "progress") this.showOverlay({target: btnSeeCart});
			btnSeeCart.style.cursor = "pointer";
		}

		const btnGustaveCart = document.querySelector("#gustave-cart");
		const btnGustaveCartStatus = btnGustaveCart? btnGustaveCart.getAttribute("status") : "";
		if (btnGustaveCart && btnGustaveCartStatus === "waitForEvent") {
			cl("initBtnsShopify => btnGustaveCart");
			btnGustaveCart.setAttribute("status", "eventInitied");
			btnGustaveCart.onclick = this.showOverlay;
			if (btnGustaveCart.style.cursor === "progress") this.showOverlay({target: btnGustaveCart});
			btnGustaveCart.style.cursor = "pointer";
		}

		const btnGustaveTryBtn = document.querySelector("#gustave-try-btn");
		const btnGustaveTryBtnStatus = btnGustaveTryBtn? btnGustaveTryBtn.getAttribute("status") : "";
		if (btnGustaveTryBtn) {
			if (ifIsIndispo(hostSelect)) btnGustaveTryBtn.style.display = "none";
			else btnGustaveTryBtn.style.display = "flex";

			if (btnGustaveTryBtnStatus === "waitForEvent") {
				cl("initBtnsShopify => btnGustaveTryBtn");
				btnGustaveTryBtn.setAttribute("status", "eventInitied");
				btnGustaveTryBtn.onclick = this.submitCartForm;
				if (btnGustaveTryBtn.style.cursor === "wait") this.submitCartForm({target: btnGustaveTryBtn});
				btnGustaveTryBtn.style.cursor = "pointer";
			}
		}

		const btnShowCcm = document.querySelector("#gustave-showCcm");
		const btnShowCcmStatus = btnShowCcm? btnShowCcm.getAttribute("status") : "";
		if (btnShowCcm && btnShowCcmStatus === "waitForEvent") {
			cl("initBtnsShopify => btnShowCcm");
			btnShowCcm.setAttribute("status", "eventInitied");
			btnShowCcm.onclick = this.showOverlay;
			if (btnShowCcm.style.cursor === "progress") this.showOverlay({target: btnShowCcm});
			btnShowCcm.style.cursor = "pointer";
		}

		const btnCheckPageProduct = document.querySelector(hostSelect.checkPageProduct);
		const btnCheckPageProductStatus = btnCheckPageProduct? btnCheckPageProduct.getAttribute("status") : "";
		if (btnCheckPageProduct && (!btnCheckPageProductStatus || btnCheckPageProductStatus !== "eventInitied")) {
			cl("initBtnsShopify => btnCheckPageProduct");
			btnCheckPageProduct.setAttribute("status", "eventInitied");
			btnCheckPageProduct.addEventListener('click', () => {
				setTimeout(() => {
					this.updateCabWithShopifyCart();
				}, 1000);
			});
		}

		if (hostSelect.elForEventListenerClick && hostSelect.elForEventListenerClick.length) {
			cl("initBtnsShopify => elForEventListenerClick : " + hostSelect.elForEventListenerClick.length);
			hostSelect.elForEventListenerClick.forEach(elSelector => {
				cl("initBtnsShopify => elSelector : " + elSelector);
				const elements = Array.from(document.querySelectorAll(elSelector));
				for (let i = 0; i < elements.length; i++) {
					const el = elements[i];
					const elStatus = el? el.getAttribute("status") : "";
					if (el && (!elStatus || elStatus !== "eventInitied")) {
						el.setAttribute("status", "eventInitied");
						el.addEventListener('click', () => {
							cl("elForEventListenerClick => cliqué");
							setTimeout(() => {
								this.getCartFromShopify(false);
							}, 500);
						});
					}
				}
			});
		}

		if (hostSelect.elForEventListenerChange && hostSelect.elForEventListenerChange.length) {
			cl("initBtnsShopify => elForEventListenerChange : " + hostSelect.elForEventListenerChange.length);
			hostSelect.elForEventListenerChange.forEach(elSelector => {
				cl("elForEventListenerChange => elSelector : " + elSelector);
				const elements = Array.from(document.querySelectorAll(elSelector));
				for (let i = 0; i < elements.length; i++) {
					const el = elements[i];
					const elStatus = el? el.getAttribute("status") : "";
					if (el && (!elStatus || elStatus !== "eventInitied")) {
						el.setAttribute("status", "eventInitied");
						el.addEventListener('change', () => {
							cl("elForEventListenerChange => newValue");
							setTimeout(() => {
								this.getCartFromShopify(false);
							}, 500);
						});
					}
				}
			});
		}

		if (hostReturned === "www.camilleveganbags.com") {
			const elsForCloseSideCart = Array.from(document.querySelectorAll("div.PageOverlay, button.Drawer__Close"));
			for (let i = 0; i < elsForCloseSideCart.length; i++) {
				elsForCloseSideCart[i].addEventListener("click", function() {
					cl("close sideCart");
					const pageOverlay = document.querySelector("div.PageOverlay");
					if (pageOverlay) {
						if (document.querySelector("html").classList.contains("no-scroll")) document.querySelector("html").classList.remove("no-scroll");
						if (document.querySelector("div.PageOverlay").classList.contains("is-visible")) document.querySelector("div.PageOverlay").classList.remove("is-visible");
						document.querySelector("#sidebar-cart").setAttribute("aria-hidden", "true");
						document.querySelector("#sidebar-cart").removeAttribute("tabindex");
					}
				});
			}
		}

		this.initObservers();
	}

	initObservers() {
		cl("initObservers");
		const that = this;

		if (hostSelect.cartToObserve) {
			hostSelect.cartToObserve.forEach(elSelector => {
				const cartToObserve = document.querySelector(elSelector);
				if (cartToObserve) {
					observerJson[elSelector] = new MutationObserver(function(mutations) {
						cl("MO " + elSelector + " change");
						if (!waitingSynchro) {
							waitingSynchro = true;
							//that.verifyBtnCloned();
							const linesToSynchro = document.querySelector(elSelector).querySelectorAll(hostSelect.cartLine);
							that.synchronizeCabWithCart(linesToSynchro);
						}
					});
					observerJson[elSelector].observe(cartToObserve, { childList: true, subtree: true });
				}
			})
		}

		//this.updateCabWithShopifyCart();
	}

	getCartFromShopify(updateWithXhr) {
		cl("getCartFromShopify");
		const cartElement = document.querySelector(hostSelect.cartElement);
		const sideCartElement = document.querySelector(hostSelect.sideCartElement);

		let addCartQuery = "";
		if (cartElement && hostSelect.cartQuery) addCartQuery = hostSelect.cartQuery;
		if (sideCartElement && hostSelect.sideCartQuery) addCartQuery = hostSelect.sideCartQuery;

		const xhr = new XMLHttpRequest();
		xhr.onreadystatechange = () => {
			if (xhr.status === 200 && xhr.readyState === 4) {
				cl("getCartFromShopify => ok");
				const xhrField = domRoot.querySelector('#xhrResponse');
				xhrField.innerHTML = xhr.responseText.indexOf('<body') !== -1? '<body class' + xhr.responseText.split('<body class')[1] : xhr.responseText;

				if(updateWithXhr) this.updateXhrBody(xhrField);
				else {
					const xhrLineItems = xhrField.querySelectorAll(hostSelect.cartLine);
					// synchro cab avec cart
					if (xhrLineItems) this.synchronizeCabWithCart(xhrLineItems);
					else {
						cl("getCartFromShopify => pas de line dans le cart");
						this.setState({cart: []});
						localStorage.setItem('gustave-cart', JSON.stringify([]));
					}
				}
			}
		}
		xhr.open('GET', 'https://' + hostReturned + '/cart' + addCartQuery);
		xhr.send(null);
	}

	updateCabWithShopifyCart() {
		cl("updateCabWithShopifyCart");
		const that = this;

		const cartElement = document.querySelector(hostSelect.cartElement);
		const sideCartElement = document.querySelector(hostSelect.sideCartElement);

		if (cartElement || sideCartElement) { // Si cart dans la page
			if (cartElement) {
				const cartLineContainer = cartElement.querySelector(hostSelect.cartLineContainer);
				const cartLine = cartLineContainer? cartLineContainer.querySelectorAll(hostSelect.cartLine) : null;
				updateCab(cartLineContainer, cartLine, "cart");
			} else if (sideCartElement) {
				const sideCartLineContainer = sideCartElement.querySelector(hostSelect.sideCartLineContainer);
				const sideCartLine = sideCartLineContainer? sideCartLineContainer.querySelectorAll(hostSelect.sideCartLine) : null;
				updateCab(sideCartLineContainer, sideCartLine, "sideCart");
			}

			function updateCab(selectedLineContainer, selectedLine, name) {
				if (selectedLineContainer && selectedLine) {
					cl("updateCabWithShopifyCart => " + name);
					that.synchronizeCabWithCart(selectedLine);
				} else {
					cl("updateCabWithShopifyCart => pas de lineContainer");
					that.setState({cart: []});
					localStorage.setItem('gustave-cart', JSON.stringify([]));
				}
			}

		} else { // Si pas de cart ou de sideCart dans la page
			const xhr = new XMLHttpRequest();
			xhr.onload = () => {
				cl("updateCabWithShopifyCart => xhr.responseText");
				domRoot.querySelector('#xhrResponse').innerHTML = xhr.responseText.indexOf('<body') !== -1? '<body class' + xhr.responseText.split('<body class')[1] : xhr.responseText;
				that.updateXhrBody(domRoot.querySelector('#xhrResponse'));
			}
			xhr.open('GET', 'https://' + hostReturned + '/cart' + (sideCartElement && hostSelect.sideCartQuery? hostSelect.sideCartQuery : ''));
			xhr.send(null);
		}

	}

	synchronizeCabWithCart = async (linesEl) => { // update/verify quantity in cart for each lines
		cl(["synchronizeCabWithCart => lineEl num : " + linesEl.length + " - éléments :", linesEl]);
		let cart = [];
		const allLines = Array.from(linesEl);

		const cartCount = document.querySelector(hostSelect.cartCount); // cartCount
		const cartDot = document.querySelector(hostSelect.cartDot); // cartDot

		if (allLines.length) {
			if (cartDot && !cartDot.classList.contains(hostSelect.cartDotVisibleClass)) cartDot.classList.add(hostSelect.cartDotVisibleClass);

			for (let [index, line] of allLines.entries()) {
				if (line.querySelector(hostSelect.cartLineQuantity)) {
					line.querySelector(hostSelect.cartLineQuantity).addEventListener('change', () => {
						/* setTimeout(() => {
							this.updateCabWithShopifyCart();
						}, 500); */
					});

					const quantity = +line.querySelector(hostSelect.cartLineQuantity).value;

					if (quantity > 0) {
						const url = "https" + hostReturned + line.querySelector(hostSelect.cartLineLink).href;
						const indexLine = index + 1;
						let variantId = +line.querySelector(hostSelect.cartLineLink).href.split("variant=")[1];
						cl("indexLine : " + indexLine + " - variantId : " + variantId + " - quantity : " + quantity);

						const productToAdd = await this.returnProductInfos(variantId, quantity, indexLine, url);
						cl("productToAdd : indexLine : " + indexLine + " - nom : " + productToAdd.name + " - quantité : " + productToAdd.quantity);
						cart.push(productToAdd);
					}
				}

				if (line.querySelector(hostSelect.cartLineBtnDel)) line.querySelector(hostSelect.cartLineBtnDel).addEventListener('click', () => {
					/* setTimeout(() => {
						this.updateCabWithShopifyCart();
					}, 500); */
				});
			}
		} else {
			if (cartDot && cartDot.classList.contains(hostSelect.cartDotVisibleClass)) cartDot.classList.remove(hostSelect.cartDotVisibleClass);
		}

		if (cartCount) cartCount.innerText = returnNumOfArticles(cart);

		if (cart.length !== this.state.cart.length || (cart.length && this.state.cart.length && JSON.stringify(cart) !== JSON.stringify(this.state.cart))) {
			this.verifyBtnCloned();
			this.setState({cart: [...cart]}, () => {
				cl(["cart updated :\n", this.state.cart]);
				waitingSynchro = false;
			});
			localStorage.setItem('gustave-cart', JSON.stringify([...cart]));
		} else {
			waitingSynchro = false;
			this.verifyBtnCloned();
		}

	}

	updatePageView() {
		cl("updatePageView");
		if (!domRoot.querySelector('#overlay').style.display || domRoot.querySelector('#overlay').style.display === 'none') {
			if (hostReturned === "www.camilleveganbags.com") {
				const sideCartElement = document.querySelector(hostSelect.sideCartElement);
				if (sideCartElement) {
					document.querySelector("html").classList.add("no-scroll");
					if (!document.querySelector("div.PageOverlay").classList.contains("is-visible")) document.querySelector("div.PageOverlay").classList.add("is-visible");
					document.querySelector("#sidebar-cart").setAttribute("aria-hidden", "false");
					document.querySelector("#sidebar-cart").setAttribute("tabindex", "-1");
					document.querySelector("#sidebar-cart").setAttribute("style", "max-height: 977px;");
				}
			}
		}
	}

	returnProductInfos = async (variantId, quantity, indexLine, url) => {
		const PRODUCT_URL = `${URL_BACK[returnHostMode(hostSelect.mode)]}/getProductVariant/${hostSelect.shop}/${variantId}`;

		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.onreadystatechange = function () {
				if (xhr.readyState === 4 && xhr.status === 200) {
					const productInfos = xhr.responseText? JSON.parse(xhr.responseText) : null;
					const productVariant = productInfos.variants.find(variant => variant.id === variantId);
					const imageId = productVariant && productVariant.image_id? productVariant.image_id : productInfos.image.id;

					let productToAdd = {
						variantId: variantId,
						name: productInfos.title,
						priceProduct: +productVariant.price,
						image: productInfos.images.find(allImages => allImages.id === imageId).src,
						grams: productVariant.grams,
						inventory_item_id: productVariant.inventory_item_id,
						inventory_quantity: productVariant.inventory_quantity,
						status: true
					};

					if (productVariant.option1 && productVariant.option1 !== "Default Title") {
						productToAdd.options2 = [{nom: "options", value: productVariant.option1}];
					}

					if (productVariant.option2 && productVariant.option2 !== "Default Title") {
						if (productToAdd.options2 && productToAdd.options2[0]) productToAdd.options2[0].value += ", " + productVariant.option2;
						else productToAdd.options2 = [{nom: "options", value: productVariant.option2}];
					}

					if (productVariant.option3 && productVariant.option3 !== "Default Title") {
						if (productToAdd.options2 && productToAdd.options2[0]) productToAdd.options2[0].value += ", " + productVariant.option3;
						else productToAdd.options2 = [{nom: "options", value: productVariant.option3}];
					}

					if (quantity) productToAdd.quantity = quantity;
					else productToAdd.quantity = 1;
					productToAdd.price = +productVariant.price * quantity;

					if (indexLine) productToAdd.indexLine = indexLine;
					if (url) productToAdd.url = url;

					productToAdd.id = variantId + "*" + productToAdd.name + "*" + productToAdd.size;
					if (productToAdd.options2 && productToAdd.options2.length) productToAdd.id += "*" + productToAdd.options2[0].value;
					productToAdd.id += "*" + productToAdd.priceProduct;
					resolve(productToAdd);
				}
			}
			xhr.open('GET', PRODUCT_URL);
			xhr.send(null);
		});
	}
	/////////////////////////////////////////////////////////////////////////////

	saveCartDomain = (cart) => {
		let datas = {
			host: hostReturned,
			ip: ip,
			cart: cart,
			version: dateVersion,
			lang: lang ==="CN"? "EN" : lang
		}
		//cl("saveCartDomain", datas)
		let xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4 && xhr.status === 200) {
				//cl("saveCartDomain response", this.responseText)
			}
		}
		xhr.open('POST', URL_BACK[returnHostMode(hostSelect.mode)] + '/savecart', true);
		xhr.setRequestHeader("Content-Type", "application/json");
		xhr.send(JSON.stringify(datas));
	}

	removeCartDomain = () => {
		//cl("removeCartDomain")
		let xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4 && xhr.status === 200) {
				//cl("removeCartDomain response", this.responseText)
			}
		}
		xhr.open('GET', URL_BACK[returnHostMode(hostSelect.mode)] + '/deletecart/' + hostReturned + '/' + ip, true);
		xhr.send(null);
	}

	pagesVues = (slide, order) => {
		if(order === undefined) order = 0;
		let tracker = hostReturned.split(".")[hostReturned.split(".").length - 2].replace(/-/g,"");
		if(hostSelect.mode === "prod" && !IP_IS_ADMIN) ReactGA.ga(tracker+'.send', 'pageview', 'Gustave ' + slideView[+slide + order]);
	}

	eventWidget = (actionSend, labelSend) => {
		if(labelSend==="FERMER WIDGET" || labelSend==="CLIC ORDERSTEP") actionSend += " " + slideView[+this.state.workflowStep + this.state.orderStep]
		let tracker = hostReturned.split(".")[hostReturned.split(".").length - 2].replace(/-/g,"");
		if(hostSelect.mode === "prod" && !IP_IS_ADMIN) ReactGA.ga(tracker+'.send', {hitType: "event", eventCategory: "Widget Gustave", eventAction: actionSend, eventLabel: labelSend})
	}

	activeTouchEndBtnDelete = () => {
		//cl("activeTouchEndBtnDelete")
		const that =this
		if(iosLoad && domRoot.querySelector(".btn-delete")) {

			let btnsDelete = Array.from(domRoot.querySelectorAll(".btn-delete"));

			for(var i = 0; i < btnsDelete.length; i++) {
				btnsDelete[i].addEventListener("touchend", function(e){
					if(e.cancelable) e.preventDefault()
					e.stopPropagation()
					//cl(["activeTouchEndBtnDelete => btn delete click : ", e.target]);
					that.btnCabDelArtHandleClick(e)
				});
			}
			/* const initBtnsForDelete = btnsDelete.length
			cl("btns delete présents : " + this.state.cart.length + " - btns initialisés : " + initBtnsForDelete); */
		}
	}

	activeTouchEndSugg = () => {
		const that = this;

		if(iosLoad && domRoot.querySelector(".autocomplete-dropdown-container")) {
			const client = this.state.client;
			const suggAdresse = Array.from(domRoot.querySelectorAll(".autocomplete-dropdown-container span"));

			function attachTouchEnd(el) {
				el.addEventListener("touchend", function(e){
					if(e.cancelable) e.preventDefault()
					e.stopPropagation()
					autoSuggGoogleMaps = false;
					const testAdresse = that.valideAdresse(e.target.innerText);
					that.setState({client: {...client, address: {...client.address, main: e.target.innerText, villeTest: testAdresse.villeTest, villeSelect: testAdresse.villeSelect}}});
				});
			}

			for(let j = 0; j < suggAdresse.length; j++) {
				attachTouchEnd(suggAdresse[j]);
			}
		}
	}

	valideAdresse = (adresseComplete) => {
		let villeTest = false;
		let villeSelect = false;
		//cl("valideAdresse => adresseComplete : " + adresseComplete);
		let codePostal = 0;
		if (adresseComplete.indexOf(", ") !== -1 && adresseComplete.split(", ").length >= 3) { // utilise google maps
			const villeAdresse = adresseComplete.split(", ")[adresseComplete.split(", ").length-2];
			//cl("google maps => villeAdresse : " + villeAdresse);

			if (villeAdresse.indexOf(" ") !== -1 && villeAdresse.split(" ").length >= 2 && villeAdresse.split(" ")[0].match(/([0-9]{5})/g)) { // si code postal
				codePostal = +villeAdresse.split(" ")[0];
				//cl("google maps => code postal : " + codePostal);
				if (codePostal >= 75000 && codePostal < 76000) villeSelect = true; // si code postal Paris
				else villeSelect = villesOk.findIndex(value => value.cp === codePostal) !== -1; // si autre code postal

			} else villeSelect = villesOk.findIndex(value => value.nom.toLowerCase() === villeAdresse.toLowerCase()) !== -1; // si ville
			villeTest = true;

		} else if (adresseComplete.indexOf(" ") !== -1 && adresseComplete.split(" ").length >= 2) { // saisie manuelle (avec code postal ou ville)
			const adresseBlocks = adresseComplete.split(" ");
			//cl("saisie manuelle => nombre d'élément : " + adresseBlocks.length);
			for (let data of adresseBlocks) {
				if (data.match(/([0-9]{5})/g)) {
					codePostal = +data;
					//cl("saisie manuelle => code postal : " + codePostal);
					if (codePostal >= 75000 && codePostal < 76000) villeSelect = true; // si code postal Paris
					else villeSelect = villesOk.findIndex(value => value.cp === +data) !== -1; // si autre code postal

				} else if (data.length > 2) villeSelect = villesOk.findIndex(ville => ville.nom.toLowerCase() === data.toLowerCase()) !== -1; // si ville

				if (villeSelect) break;
			}
			villeTest = true;

		} else {
			villeTest = false;
			villeSelect = false;
		}
		//cl("villeTest : " + villeTest + ", villeSelect : " + villeSelect);
		return {villeTest: villeTest, villeSelect: villeSelect};
	}

	validateEmail= (email) => {
		if(email !== "" && email !== null && email !== undefined) {
			var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		}
	}

	isTelephoneValide = (numero) => {
		if(numero !== "" && numero !== null && numero !== undefined) {
			var reg_telephone = '^(01|02|03|04|05|06|07|08|09)[0-9]{8}$';
			if(numero.replace(/ /g,"").match(reg_telephone)) return true;
		}
	}

	hideOverlay = () => {//
		if (hostReturned === 'www.camilleveganbags.com') { //
			if (document.querySelector("#shopify-section-header")) document.querySelector("#shopify-section-header").style.zIndex = 5;

			if (document.querySelector("div.PageOverlay")) {
				const poAtrr = document.querySelector("div.PageOverlay").getAttribute("mg-close");
				if (poAtrr && poAtrr === "true") {
					if (!document.querySelector("html").classList.contains("no-scroll")) document.querySelector("html").classList.add("no-scroll");
					if (!document.querySelector("div.PageOverlay").classList.contains("is-visible")) {
						document.querySelector("div.PageOverlay").classList.add("is-visible");
						document.querySelector("div.PageOverlay").removeAttribute("mg-close");
						document.querySelector("#sidebar-cart").setAttribute("aria-hidden", "false");
						document.querySelector("#sidebar-cart").setAttribute("tabindex", "-1");
					}
				}
			}
		}

		if(domRoot.querySelector('#overlay')) {
			domRoot.querySelector('#overlay').style.display='none';
			document.body.style.overflow='auto';
			if (this.state.showCab) this.setState({showCab: false});
		}


		if (ifIsShopify && sessionStorage.getItem('orderId') && sessionStorage.getItem('lang')) this.modifyPage();
	}

	showOverlay = (e) => {

		if(domRoot.querySelector('#overlay')) {

			if(ifIsShopify && e && e.target && (e.target.id === "gustave-seeCart" || e.target.id === "gustave-cart") && this.state.cart.length > 0) {
				const cart = this.state.cart;
				const productNumber = cart.reduce((total, nbr) => total + (nbr.quantity > 0? +nbr.quantity : 1), 0);
				let showSteps = false;

				if (productNumber > 0 && productNumber <= maxProductNumberRef) {
					saveInfos.workflowStep = '1'; saveInfos.orderStep = 1;
					showSteps = true;

				} else saveInfos.workflowStep = '1'; saveInfos.orderStep = 0;

				this.setState({ workflowStep: saveInfos.workflowStep, orderStep: saveInfos.orderStep, showSteps: showSteps }, () => openOverLay());

			} else if(e && e.target && e.target.id === "gustave-showCcm") {
				saveInfos.workflowStep = '0'; saveInfos.orderStep = 0;
				this.setState({ workflowStep: saveInfos.workflowStep, orderStep: saveInfos.orderStep }, () => openOverLay());

			} else openOverLay();
		}

		function openOverLay() {
			if (hostReturned==='www.camilleveganbags.com') {
				if (document.querySelector("#shopify-section-header")) document.querySelector("#shopify-section-header").style.zIndex = 1;

				if (document.querySelector("div.PageOverlay").classList.contains("is-visible")) {
					if (document.querySelector("html").classList.contains("no-scroll")) document.querySelector("html").classList.remove("no-scroll");
					document.querySelector("div.PageOverlay").classList.remove("is-visible");
					document.querySelector("div.PageOverlay").setAttribute("mg-close", "true");
					document.querySelector("#sidebar-cart").setAttribute("aria-hidden", "true");
					document.querySelector("#sidebar-cart").removeAttribute("tabindex");
				}
			}
			domRoot.querySelector('#overlay').style.display='flex';
			document.body.style.overflow='hidden';
			if (document.querySelector('.product__aside')) document.querySelector('.product__aside').style.zIndex=1;
		}
	}

	handleSaveCommand = () => {
		cl("handleSaveCommand");
		const {client, cart, promoCode, reduc, typeReduc} = this.state;

		commandForSc = {
			host: hostReturned,
			mode: hostSelect.mode,
			orderInfos: {
				hostName: hostSelect.name,
				email: hostSelect.stores && hostSelect.stores[0]? hostSelect.stores[0].email : "hello@mercigustave.co",
				address: hostSelect.stores && hostSelect.stores[0] && hostSelect.stores[0].address? hostSelect.stores[0].address : "",
				comment: hostSelect.stores && hostSelect.stores[0] && hostSelect.stores[0].comment? hostSelect.stores[0].comment : "",
				email2: hostSelect.stores && hostSelect.stores[0] && hostSelect.stores[0].email2? hostSelect.stores[0].email2 : null,
				assets: hostSelect.assets? {logo: hostSelect.assets.logo, img: hostSelect.assets.img} : {logo: false, img: false}
			},
			shopify: hostSelect.shopify,
			shop: hostSelect.shop,
			adresse: client.address.main,
			placeId: client.address.placeId,
			first_name: client.infos.firstName,
			last_name: client.infos.familyName,
			email: client.infos.email.toLowerCase().replace(/ /g, ""),
			data: cart,
			reduc: reduc,
			promoCode: promoCode,
			typeReduc: typeReduc,
			lang: lang !== "FR"? "EN" : lang
		};
		if(client.infos.phoneNumber && commandForSc) commandForSc.phonenum = client.infos.phoneNumber.replace(/ /g, "");
		cl(commandForSc);
		sessionStorage.setItem("commandForSc", JSON.stringify(commandForSc));

		fetch(URL_BACK[returnHostMode(hostSelect.mode)] + '/saveCommand', {
			method: 'POST',
			headers: {
				'Accept': 'application/json, text/plain, */*',
				'Content-Type': 'application/json',
				'widget': 'true'
			},
			body: JSON.stringify({
				command: commandForSc/* ,
				marque: hostSelect */
			})
		})
		.then(response=> {
			response.json()

			.then(data=>{
				cl(['/saveCommand', data.orderId]);
				if(data.orderId) {
					commandForSc = {...commandForSc, ...data};
					sessionStorage.setItem("commandForSc", JSON.stringify(commandForSc));
					this.setState({orderIdSave: data.orderId});
				}
			})
			.catch(error=>{
				//cl(error)
			})
		})
		.catch( error=> {
			//cl(error)
		})
	}

	createPM = (card) => {
		cl("createPM");
		this.setState({stripeLoading: true});
		const {client, cart, promoCode, reduc, typeReduc, orderIdSave} = this.state;

		commandForSc = sessionStorage.getItem("commandForSc")? JSON.parse(sessionStorage.getItem("commandForSc")) : {
			orderId: orderIdSave,
			host: hostReturned,
			mode: hostSelect.mode,
			shopify:hostSelect.shopify,
			adresse: client.address.main,
			placeId: client.address.placeId,
			first_name: client.infos.firstName,
			last_name: client.infos.familyName,
			email: client.infos.email.toLowerCase().replace(/ /g, ""),
			data: cart,
			reduc: reduc,
			promoCode: promoCode,
			typeReduc: typeReduc,
			lang: lang ==="CN"? "EN" : lang
		};
		if (client.infos.phoneNumber && commandForSc) commandForSc.phonenum = client.infos.phoneNumber.replace(/ /g, "");

		cl(["commandForSc", commandForSc]);
		sessionStorage.setItem("commandForSc", JSON.stringify(commandForSc));

		fetch(URL_BACK[returnHostMode(hostSelect.mode)] + '/createPayMet' ,{
			method: 'POST',
			headers: {
				'Accept': 'application/json, text/plain, */*',
				'Content-Type': 'application/json',
				'widget': 'true'
			},
			body:JSON.stringify({
        //amount: commandForSc.email.indexOf("mikedev75") !== -1? 100 : this.state.prixTotalCart * 100 + (hostSelect.frais? hostSelect.frais * 100 : 0),
        amount: 100, // empreinte d'1 euro pour tester la validité de la carte
				card: card,
				command: commandForSc
			})
		})
		.then(response=> {
			response.json()
			.then(data => {
				//cl(["createPayMet response =>", data]);
				if(data && data.customerId) commandForSc.customerId = data.customerId;
				if(data && data.paymentIntent && data.paymentIntent.client_secret) {
					commandForSc.secure3dCard = data.paymentIntent.status === "requires_action"? true : false;
					sessionStorage.setItem("commandForSc", JSON.stringify(commandForSc));
					this.handleCPM(data.paymentIntent.client_secret);
				} else {
					cl(["createPayMet => error", data]);
					alert(langSelect("msgnonplan", this.state));
					this.setState({stripeLoading: false});
        }
			})
			.catch(error=>{
				cl(["createPayMet responseJSON => error", error]);
        alert(langSelect("msgnonplan", this.state));
				this.setState({stripeLoading: false});
			})
		})
		.catch(error=> {
			//cl(["handleSubmit fetch => error", error]);
      alert(langSelect("msgnonplan", this.state));
			this.setState({stripeLoading: false});
    });
	}

	handleCPM = (PIsecret) => {
		cl("handleCPM");
		this.state.stripe.handleCardPayment(PIsecret)
		.then(result => {
				if(result.error) {
					cl(["handleCardPayment error =>", result.error]);
					alert(langSelect("msgnonplan", this.state));
					this.setState({stripeLoading: false});
					this.handleErrorForCM(result.error.code, result.error.message);
				} else {
					//cl(["handleCardPayment success =>", result.paymentIntent]);
					this.handleSaveOrder(result.paymentIntent.id);
				}
		})
		.catch(error => {
			cl(["handleCPM error", error]);
		});
	}

	handleErrorForCM = (code, msg) => {
		cl("handleErrorForCM");

		fetch(URL_BACK[returnHostMode(hostSelect.mode)] + '/mailStripeError' ,{
			method: 'POST',
			headers: {
				'Accept': 'application/json, text/plain, */*',
				'Content-Type': 'application/json',
				'widget': 'true'
			},
			body:JSON.stringify({
				code: code,
				msg: msg,
				command: commandForSc
			})
		})
		.then(response=> {
			response.json()

			.then(data=>{
				//cl(["handleErrorForCM => data", data]);
			})
			.catch(error=>{
				//cl(["handleErrorForCM responseJSON => error", error]);
			})
		})
		.catch(error=> {
			//cl(["handleErrorForCM fetch => error", error]);
		});
	}

	handleSaveOrder = (payIntId) => {
		const that = this;
		const {client, cart, reduc, promoCode, typeReduc, token} = this.state;

		let command = {
			...commandForSc,
			mode: hostSelect.mode,
			orderInfos: {
				hostName: hostSelect.name,
				email: hostSelect.stores && hostSelect.stores[0]? hostSelect.stores[0].email : "hello@mercigustave.co",
				address: hostSelect.stores && hostSelect.stores[0] && hostSelect.stores[0].address? hostSelect.stores[0].address : "",
				addressKind: hostSelect.stores && hostSelect.stores[0] && hostSelect.stores[0].kind? hostSelect.stores[0].kind : "",
				comment: hostSelect.stores && hostSelect.stores[0] && hostSelect.stores[0].comment? hostSelect.stores[0].comment : "",
				email2: hostSelect.stores && hostSelect.stores[0] && hostSelect.stores[0].email2? hostSelect.stores[0].email2 : null,
				contact: {
                    firstname: hostSelect.stores && hostSelect.stores[0]? hostSelect.stores[0].firstname : "Clara",
                    lastname: hostSelect.stores && hostSelect.stores[0]? hostSelect.stores[0].lastname : "Foache",
                    email: hostSelect.stores && hostSelect.stores[0]? hostSelect.stores[0].email : "hello@mercigustave.co",
                    phone: hostSelect.stores && hostSelect.stores[0]? hostSelect.stores[0].phone : "+33674694896",
					kind: hostSelect.stores && hostSelect.stores[0]? hostSelect.stores[0].kind : "home",
					company: hostSelect.stores && hostSelect.stores[0]? hostSelect.stores[0].company : "Merci Gustave"
				},
				assets: hostSelect.assets? {logo: hostSelect.assets.logo, img: hostSelect.assets.img} : {logo: false, img: false},
				openHours: hostSelect.openHours,
				closed: hostSelect.closed,
				cancel_frais_montant: hostSelect.cancel_frais_montant? hostSelect.cancel_frais_montant : null,
				cancel_frais_quantity: hostSelect.cancel_frais_quantity? hostSelect.cancel_frais_quantity : null,
				returnDelayDaysToAdd: hostSelect.returnDelayDaysToAdd? hostSelect.returnDelayDaysToAdd : 0
			},
			host: hostReturned,
			adresse: client.address.main,
			placeId: client.address.placeId,
			first_name: client.infos.firstName,
			last_name: client.infos.familyName,
			phonenum: client.infos.phoneNumber.replace(/ /g, ""),
			email: client.infos.email.toLowerCase().replace(/ /g, ""),
			data: cart,
			reduc: reduc,
			typeReduc: typeReduc,
			promoCode: promoCode,
			lang: lang !== "FR"? "EN" : lang,
			token: token,
			frais: hostSelect.frais? hostSelect.frais : null,
			planned: 0,
			payIntId: payIntId
		};

		fetch(URL_BACK[returnHostMode(hostSelect.mode)] + '/commandRequest', {
			method: 'POST',
			headers: {
				'Accept': 'application/json, text/plain, */*',
				'Content-Type': 'application/json',
				'widget': 'true'
			},
			body:JSON.stringify({ command: command, marque: hostSelect })
		})
		.then(response => {
			response.json()
			.then(data => {
				if (data.orderId) {

					const inventoryDeadline = lang === "FR"? moment(data.orderInfos.inventoryDeadline).format('DD/MM/YYYY[, à ]H[h]') : moment(data.orderInfos.inventoryDeadline).format('DD/MM/YYYY[, at ]ha');

					if (ifIsShopify) {
						sessionStorage.setItem('orderId', data.orderId);
						sessionStorage.setItem('lang', data.lang);
						sessionStorage.setItem('inventoryDeadline', inventoryDeadline);
						//sessionStorage.setItem('mgcart', JSON.stringify(data.data));

						this.cleanCart(data.data)
						.then(() => {
							cl("cart cleaned");
							// mise à jour et masquage du cartCount si besoin
							const cartCount = document.querySelector('div#CartCount > span[data-cart-count]');
							if (cartCount) {
								if (+cartCount.innerHTML !== 0) cartCount.innerHTML = 0;
								if(!cartCount.parentElement.classList.contains("hide")) cartCount.parentElement.classList.add("hide");
							}

							if (window.location.pathname === "/cart") { // si page cart, visible derrière le widget
								const orderId = sessionStorage.getItem('orderId');
								const lang = sessionStorage.getItem('lang');

								// modification du h1
								if (document.querySelector('h1')) {
									const allH1 = Array.from(document.querySelectorAll('h1'));
									for (let i = 0; i < allH1.length; i++) {
										allH1[i].innerText = "Votre demande d'essayage n° " + orderId + " a bien été enregistrée !";
									}
								}
								// modification div if no empty
								if (document.querySelector('div.cart-header')) {
									document.querySelector('div.cart-header').classList.add("empty-page-content", "text-center");
									document.querySelector('div.cart-header').classList.remove("cart-header");
								}
								// masquage du cart si présent
								if (document.querySelector(hostSelect.cartElement) && !document.querySelector(hostSelect.cartElement).style.display !== "none") document.querySelector(hostSelect.cartElement).style.display = "none";
								// supression du bouton passage à la caisse
								if (document.querySelector(hostSelect.checkoutBtn) && document.querySelector(hostSelect.checkoutBtn).style.display !== "none") document.querySelector(hostSelect.checkoutBtn).style.display = "none";
								// suppression bouton poursuivre vos achats
								if (document.querySelector(hostSelect.cartContinueBtn) && document.querySelector(hostSelect.cartContinueBtn).style.display !== "none") document.querySelector(hostSelect.cartContinueBtn).style.display = "none";
								// création paragraphe infos supp
								const para = document.createElement('p');
								para.innerHTML = '<span id="subH1"><span class="ph-confirm">Une question ? Contactez-nous par email </span><a class="text-link text-link--accent" href="mailto:contact@mercigustave.co">contact@mercigustave.co</a><span class="ph-confirm"> ou par téléphone au </span><a class="text-link text-link--accent" href="tel:+33674694896">06 74 69 48 96</a><span class="ph-confirm">.</span></span>';

								let refEl = null;
								// modifications pour lien plannification essayage
								if (document.querySelector('.cart-header a[href="/collections/all"]')) {
									const link = document.querySelector('.cart-header a[href="/collections/all"]');
									link.innerText = "Planifier mon essayage";
									link.href = "https://mercigustave-delivery.netlify.app?orderId=" + orderId + "&lang=" + lang;
									refEl = document.querySelector('.cart-header a[href="/collections/all"]');
								}
								if (document.querySelector('p.cart--empty-message')) {
									document.querySelector('p.cart--empty-message').innerHTML = '<a class="text-link text-link--accent" href="https://mercigustave-delivery.netlify.app?orderId=' + orderId + '&lang=' + lang + '" target="_blank" title="Planifier mon essayage">Planifier mon essayage</a>';
									refEl = document.querySelector('p.cart--empty-message');
								}
								// ajout du paragraphe créé à la page
								if (refEl) refEl.parentElement.insertBefore(para, refEl);
								else if (document.querySelector('h1')) document.querySelector('h1').parentElement.appendChild(para);
							}
						})
						.catch(error => cl(["cart not cleaned", error]));
					}

					this.setState({client:{...client, orderId: data.orderId}, inventoryDeadline: inventoryDeadline, cart: [], stripeLoading: false}, () => {
						if (hostSelect.saveCart) this.removeCartDomain();
						else {
							localStorage.removeItem('gustave-cart');
							sessionStorage.removeItem('gustave-client');
						}
					});

				} else {
					that.setState({stripeLoading: false});
					alert(langSelect("msgnonplan", that.state));
				}
			})
			.catch(error=>{
				//cl("catch error data", error)
				that.setState({stripeLoading: false});
				alert(langSelect("msgnonplan", that.state));
			})
		})
		.catch( error=> {
			//cl("catch error response", error)
			that.setState({stripeLoading: false});
			alert(langSelect("msgnonplan", that.state));
		});
	}

	handleKeyDown = (event) => {
		//cl("handleKeDown : Touche " + event.key + " - code : " + event.keyCode);
		if (hostReturned==='www.fraiche-paris.fr' && (event.key===" " || event.keyCode===32 || event.which===32)) { // gestion bug fraiche
			event.preventDefault();
			event.target.value += event.key;
		}

		if (this.state.workflowStep === '1' && (event.keyCode===13 || event.which===13)) {
			const {orderStep, client} = this.state;

			if (orderStep === 1 && client.infos.firstName && client.infos.familyName && client.infos.email && client.infos.email.indexOf('@')!==-1 && client.infos.email.indexOf('.')!==-1 && client.infos.phoneNumber && this.isTelephoneValide(client.infos.phoneNumber) && client.address.main && client.infos.villeSelect) { // si slide infos
				//cl("handleKeDown : Touche " + event.key + " - code : " + event.keyCode);
				this.inputsInfosTest(null);
				this.infSuivantHandleClick(event, 'touche Entrée sur le SLIDE infos', 'SUIVANT')
			} else if (orderStep === 1) {
				this.inputsInfosTest(null);
			}
		}

		//if (this.state.workflowStep === '1' && this.state.orderStep === 0) toucheHandleKeyDown = event.which;
	}

	formatAutoSpace = (value) => {
		let numFormate = "";
		let numero = value.replace(/ /g,"").split("");
		for(let [index, num] of numero.entries()) {
			if(index === 2 || index === 4 || index === 6 || index === 8) numFormate += " ";
			if(+num >= 0 && +num < 10) numFormate += num;
		}
			return numFormate;
	}

	// add
	addToCabineWaitForImage = (e, saveOrigine) => {
		const that = this
		//cl("addToCabineWaitForImage")
		const origine = saveOrigine
		const waitImage = setInterval(function(){
			if(productScrap.image) {
				//cl("image ok")
				clearInterval(waitImage);
				that.addToCabine(e, "add", origine)
			}
		}, 500);
	}

	addToCabineWaitForPrice = (e, saveOrigine) => {
		const that = this
		//cl("addToCabineWaitForPrice")
		const origine = saveOrigine
		const waitPrice = setInterval(function(){
			if(productScrap.price && productScrap.price >= 0) {
				//cl("price ok")
				clearInterval(waitPrice);
				that.addToCabine(e, "add", origine)
			}
		}, 500);
	}

	async searchInfoByUrl(urlInfos) {
		return new Promise(resolve => {			
			for (let value of urlInfos) {
				console.log("infosProductByUrl => value", value);
				const foundInUrl = value.urlWord && value.urlWord.find(word => urlDocReturned.indexOf(word) !== -1);
				if (foundInUrl) {
					productScrap = {...productScrap, info: value.info, classInfo: "cab-info " + value.class};
				}
			}
			resolve(productScrap);
		});
	}

	addToCabine = async (event, action, origine) => {
		const that = this;

		if (pageProduct && !urlsExcluded(hostSelect)) {

			//cl([productScrap, event]);
			let cart = this.state.cart;

			if(action==="add"){
				if(productScrap.size === "off" || productScrap.color === "off" || productScrap.options === "off" || productScrap.size === "notSelected" || productScrap.color === "notSelected" || productScrap.options === "notSelected" || productScrap.size === "notForTry" || productScrap.size === "soldmax" || (productScrap.size && productScrap.size.indexOf("notOption")!==-1) || !(productScrap.price && productScrap.price >= 0) || !productScrap.image){ // si problème de taille et/ou couleur ou prix ou image
					if(productScrap.size === "notForTry") alert(langSelect("alnonprod", this.state));
					else if(productScrap.size === "off" && productScrap.color === "off") alert(langSelect("alcomb", this.state));
					else if(productScrap.size === "off") alert(langSelect("alsiz", this.state));
					else if(productScrap.options === "off") alert(langSelect("alopt", this.state));
					else if(productScrap.size === "soldmax") alert("Vous ne pouvez pas ajouter plus de 3 articles soldés à votre essayage ;)");
					else if(productScrap.color === "off") alert(langSelect("alcol", this.state));
					else if(productScrap.size && productScrap.size.indexOf("notOption")!==-1 && productScrap.size !== "notSelected" && productScrap.color !== "notSelected") alert(langSelect("aloptopt", this.state).split("*")[0] + " " + productScrap.size.split("notOption-")[1] + " " + langSelect("aloptopt", this.state).split("*")[1]);
					else if(productScrap.size === "notSelected" && productScrap.color === "notSelected") alert(langSelect("alopts", this.state));
					else if(productScrap.size === "notSelected") {
						if (hostReturned === "www.manoush.com" && window.innerWidth >= 991){
							let cnLang = document.querySelector(".header__lang > .custom-select-container > .custom-select-opener > span") && document.querySelector(".header__lang > .custom-select-container > .custom-select-opener > span").innerText.toUpperCase() === "CN";
							iziToast.error({
								title: cnLang? '出错' : 'Erreur',
								message: cnLang? '请为在家试穿尺寸' : langSelect("aloptsize", this.state),
							});
						} else if (hostReturned !== "www.manoush.com"){
							let cnLang = document.querySelector(".header__lang > .custom-select-container > .custom-select-opener > span") && document.querySelector(".header__lang > .custom-select-container > .custom-select-opener > span").innerText.toUpperCase() === "CN";
							alert(cnLang? '请为在家试穿尺寸' : langSelect("aloptsize", this.state))
						}
					} else if(productScrap.color === "notSelected") alert(langSelect("aloptcol", this.state));
					else if(productScrap.options === "notSelected") alert(langSelect("aloptsel", this.state));
					else if(productScrap.name && productScrap.id && productScrap.price && !productScrap.image) this.addToCabineWaitForImage(event, origine);
					else if(productScrap.name && productScrap.id && !productScrap.price) this.addToCabineWaitForPrice(event, origine);

					this.hideOverlay();

				} else { // si aucun problème taille et/ou couleur ou prix ou image
					const productToAddIndex = cart.findIndex(product => product.id === productScrap.id);

					if (productToAddIndex === -1) { // si produit non présent dans la cabine, on l'ajoute
						//cl("add one");
						if (origine !== '') this.eventWidget(origine + ' / article ajouté', 'ARTICLE AJOUTÉ');
						saveInfos.workflowStep = '1'; saveInfos.orderStep = 0;
						this.pagesVues(saveInfos.workflowStep, saveInfos.orderStep);						

						if (hostSelect.addInfosProductByUrl && hostSelect.addInfosProductByUrl.length) {
							productScrap = await that.searchInfoByUrl(hostSelect.addInfosProductByUrl);
						}

						if (!productScrap.classInfo) productScrap.classInfo = "cab-info";

						cart = [{...productScrap}, ...cart];
						if (!hostSelect.saveCart) localStorage.setItem('gustave-cart', JSON.stringify([...cart]));

						that.setState({workflowStep: saveInfos.workflowStep, orderStep: saveInfos.orderStep, cart: [...cart]}, function() {
							if (event && event.target && event.target.id.indexOf("try-btn") !== -1) {
								that.showOverlay(event);
							}
						});

					} else { // si produit déjà présent, on affiche la cabine
						if(origine !== '') this.eventWidget(origine + ' / article non ajouté', 'ARTICLE NON AJOUTÉ');

						if (this.state.workflowStep !== '1' || this.state.orderStep !== 0) {
							saveInfos.workflowStep = '1'; saveInfos.orderStep = 0;
							this.setState({workflowStep: saveInfos.workflowStep, orderStep: saveInfos.orderStep}, () => this.showOverlay(null));

						} else this.showOverlay(null);
					}
				}
			}
		}
	}

	promoValHandleClick = (e) => {//
		if(e.cancelable) e.preventDefault();

		let testPromoCode = {
			host: hostReturned,
			code: this.state.promoCode
		}

		fetch(URL_BACK[returnHostMode(hostSelect.mode)] + '/getpromo' ,{
			method: 'POST',
			headers: {
				'Accept': 'application/json, text/plain, */*',
				'Content-Type': 'application/json',
				'widget': 'true'
			},
			body: JSON.stringify(testPromoCode)
		})
		.then(response=> {
			response.json()

			.then(data=>{
				//cl('/getpromo', data);
				if(data.reduc) {
					this.setState({reduc: data.reduc, typeReduc: data.typeReduc}, () => {
						sessionStorage.setItem("reduc", JSON.stringify({reduc: this.state.reduc, promoCode: this.state.promoCode, typeReduc: this.state.typeReduc}));
					}); // applique la promo
				} else alert(langSelect("resultPromo", this.state));
			})
			.catch(error=>{
				//cl(error);
			})
		})
		.catch( error=> {
			//cl(error);
		})
	}

	////////////////////// SHOPIFY functions only ///////////////////////////////

	updateXhrBody = (xhrBody) => {
		cl(/* [ */"updateXhrBody"/* , xhrBody] */);
		const that = this;

		// cartCount
		const cartCount = document.querySelector(hostSelect.cartCount);
		const xhrCartCount = xhrBody.querySelector(hostSelect.cartCount);
		if (cartCount && xhrCartCount) {
			cl("Mise à jour du cartCount");
			cartCount.innerHTML = xhrCartCount.innerHTML;

			if (+cartCount.innerHTML <= 0) {
				if (+cartCount.innerHTML < 0) cartCount.innerHTML = 0;
				if (!cartCount.parentElement.classList.contains("hide")) cartCount.parentElement.classList.add("hide");
				if (document.querySelector(hostSelect.checkoutBtn)) document.querySelector(hostSelect.checkoutBtn).style.display = "none";
			} else {
				if (cartCount.parentElement.classList.contains("hide")) cartCount.parentElement.classList.remove("hide");
				if (document.querySelector(hostSelect.checkoutBtn) && document.querySelector(hostSelect.checkoutBtn).style.display === "none") document.querySelector(hostSelect.checkoutBtn).style.display = "block";
			}

		} else cl("pas de cartCount" + (!cartCount? ' dans la page' : '') + (!xhrCartCount? ' dans le xhrBody' : ''));

		// cartDot
		const cartDot = document.querySelector(hostSelect.cartDot);
		const xhrCartDot = xhrBody.querySelector(hostSelect.cartDot);
		if (cartDot && xhrCartDot) {
			cl("Mise à jour du cartDot");
			if (!cartDot.classList.contains(hostSelect.cartDotVisibleClass) && xhrCartDot.classList.contains(hostSelect.cartDotVisibleClass)) cartDot.classList.add(hostSelect.cartDotVisibleClass);
			else if (cartDot.classList.contains(hostSelect.cartDotVisibleClass) && !xhrCartDot.classList.contains(hostSelect.cartDotVisibleClass)) cartDot.classList.remove(hostSelect.cartDotVisibleClass);

		} else cl("pas de cartDot" + (!cartDot? ' dans la page' : '') + (!xhrCartDot? ' dans le xhrBody' : ''));

		// subtotal__price
		const subtotal__price = document.querySelector(hostSelect.cartSubtotalPrice);
		const xhrSubtotal__price = xhrBody.querySelector(hostSelect.cartSubtotalPrice);
		if (subtotal__price && xhrSubtotal__price) {
			cl("Mise à jour du subtotal__price");
			subtotal__price.innerHTML = xhrSubtotal__price.innerHTML;

		} else cl("pas de subtotal" + (!subtotal__price? ' dans la page' : '') + (!xhrSubtotal__price? ' dans le xhrBody' : ''));

		// sideCartButton
		const sideCartButton = document.querySelector(hostSelect.sideCartButton);
		const xhrSideCartButton = xhrBody.querySelector(hostSelect.sideCartButton);
		if (sideCartButton && xhrSideCartButton) {
			cl("Mise à jour du sideCartButton");
			sideCartButton.innerHTML = xhrSideCartButton.innerHTML;

		} else cl("pas de sideCartButton" + (!sideCartButton? ' dans la page' : '') + (!xhrSideCartButton? ' dans le xhrBody' : ''));

		// cart page
		const cartElement = document.querySelector(hostSelect.cartElement);
		const cartLineContainer = document.querySelector(hostSelect.cartLineContainer);
		const xhrCartLineContainer = xhrBody.querySelector(hostSelect.cartLineContainer);
		if (cartLineContainer && xhrCartLineContainer) {
			cl("Mise à jour du cart");
			cartLineContainer.innerHTML = xhrCartLineContainer.innerHTML;
			updateCabLines();

		} else cl("pas de cart" + (!cartLineContainer? ' dans la page' : '') + (!xhrCartLineContainer? ' dans le xhrBody' : ''));

		// sideCart
		const sideCartElement = document.querySelector(hostSelect.sideCartElement);
		const xhrSideCartElement = xhrBody.querySelector(hostSelect.sideCartElement);
		const sideCartLineContainer = document.querySelector(hostSelect.sideCartLineContainer);
		const xhrSideCartLineContainer = xhrBody.querySelector(hostSelect.sideCartLineContainer);
		const xhrLineItems = xhrBody.querySelectorAll(hostSelect.cartLine);
		//const xhrLineItemsToAdd = Array.from(xhrLineItems);

		if (hostSelect.sideCartElement && sideCartElement) {
			if (sideCartLineContainer && xhrSideCartLineContainer) {
				cl("Mise à jour du sideCart depuis xhrSideCartLineContainer");
				sideCartLineContainer.innerHTML = xhrSideCartLineContainer.innerHTML;
				this.updatePageView();
				updateCabLines();

			} else if (sideCartElement && xhrSideCartElement) {
				cl("Mise à jour du sideCart depuis xhrSideCartElement");
				sideCartElement.innerHTML = xhrSideCartElement.innerHTML;
				this.updatePageView();
				updateCabLines();

			} else if (sideCartLineContainer && xhrLineItems) {
				cl("sideCart => getCartFromShopify");
				this.getCartFromShopify(true);

			} else cl("pas de sideCart" + (!sideCartLineContainer? ' dans la page' : '') + (!xhrSideCartLineContainer? ' dans le xhrBody' : ''));
		}

		function updateCabLines() {
			// synchro cab avec cart
			if (xhrLineItems) that.synchronizeCabWithCart(xhrLineItems);
			else {
				cl((cartElement? "cart" : "") + (sideCartElement? "sideCart" : "") + " mais pas de line");
				that.setState({cart: []});
				localStorage.setItem('gustave-cart', JSON.stringify([]));
			}
		}
	}

	submitCartForm = (e) => {
		cl("submitCartForm");
		const btnGustaveTryBtn = document.querySelector("#gustave-try-btn");
		const formAddToCart = document.querySelector('form[action="/cart/add"]');

		btnGustaveTryBtn.style.cursor = "not-allowed";
		btnGustaveTryBtn.style.opacity = 0.7;

		let xhr = new XMLHttpRequest();
		xhr.onload = () => {
			cl("submitCartForm => xhrResponse status : " + xhr.status);
			this.getCartFromShopify(true);

			btnGustaveTryBtn.style.cursor = "pointer";
			btnGustaveTryBtn.style.opacity = 1;
		}
		xhr.open('POST', formAddToCart.getAttribute("action"));
		xhr.send(new FormData(formAddToCart));
	}

	updateCartQuantity = (index, quantity, cartQuantity, priceProduct, updateMode, updateCart) => {
		cl("updateCartQuantity => updateMode : " + updateMode + " - update cart : " + updateCart + "\nindexLine : " + index + " - newQuantity : " + quantity + " - cartQuantity : " + cartQuantity + " - priceProduct : " + priceProduct);

		const URL_QUANTITY = `https://${hostReturned}/cart/change?line=${index}&quantity=${quantity}`;

		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.onload = () => {
				cl("updateCartQuantity => xhrResponse status : " + xhr.status);
				domRoot.querySelector('#xhrResponse').innerHTML = xhr.responseText.indexOf('<body') !== -1? '<body class' + xhr.responseText.split('<body class')[1] : xhr.responseText;

				this.disableBtnsQuantity(false);
				if (!updateCart) resolve();
				else {
					resolve();
					this.updateXhrBody(domRoot.querySelector('#xhrResponse'));
				}
			}
			xhr.open('GET', URL_QUANTITY);
			xhr.send();
		});

	}

  	changeQuantity = (ope, product) => {
		cl("changeQuantity => opé : " + ope);
		this.disableBtnsQuantity(true);

		const cart = this.state.cart;

		// ajout ou suppression
		let newQuantity = 0;
    if (ope === "-") newQuantity = product.quantity - 1;
    else if (ope === "+") newQuantity = product.quantity + 1;

		// ajustement quantité si négatif
		if (newQuantity < 0) newQuantity = 0;

		this.updateCartQuantity(product.indexLine, newQuantity, product.quantity, product.priceProduct, (cart.length > 1? "line" : "cart"), true)
		.then(() => cl("updateCartQuantity => ok"))
		.catch(error => cl(["updateCartQuantity => error :\n", error]));
	}

	disableBtnsQuantity(statut) {
		btnsQuantityDisabled = statut;
		const btnsQuantity = Array.from(domRoot.querySelectorAll('.btns_quantity'))

		for (let i = 0; i < btnsQuantity.length; i++) {
			const btn = btnsQuantity[i];
			const setQuantity = +btn.getAttribute("setQuantity");
			btn.disabled = statut || setQuantity < 0? true : false;
			cl([btn, "setQuantity : " + setQuantity + " - statut : " + btn.disabled]);
		}
	}

	modifyPage = () => {
		const orderId = sessionStorage.getItem('orderId');
		const lang = sessionStorage.getItem('lang');
		const inventoryDeadlineDate = sessionStorage.getItem('inventoryDeadline');

		if (document.querySelector(hostSelect.mainContent)) document.querySelector(hostSelect.mainContent).innerHTML = `
			<div style="display: flex; flex-direction: column; align-items: center; margin: 100px 0 200px; width: 100%; padding: 0 50px;">
				<h1 style="font-weight: bold; text-align: center;">${lang === "FR"? `Votre demande d'essayage n°&nbsp;${orderId} a&nbsp;bien&nbsp;été&nbsp;enregistrée&nbsp;!` : `Your fitting request n°${orderId} has been registered!`}</h1>

				<p style="text-align: center;">
					<strong>${langSelect("msgval2", {appLang: lang})}</strong>
				</p>

				<p style="text-align: left;">1. ${langSelect("msgval2s1", {appLang: lang}).split("*")[0]}<strong>${inventoryDeadlineDate}</strong>${langSelect("msgval2s1", {appLang: lang}).split("*")[1]}</p>

				<p style="text-align: left;">2. ${langSelect("msgval2s2", {appLang: lang})}</p>

				<p style="text-align: center; font-style: italic">${langSelect("msgval3s1", {appLang: lang}).split("*")[0]}<strong>${langSelect("msgval3s1", {appLang: lang}).split("*")[1]}</strong>${langSelect("msgval3s1", {appLang: lang}).split("*")[2]}</p>

				<p style="text-align: center; font-style: italic">${langSelect("msgval3s3", {appLang: lang})}</p>

			</div>
		`;

		sessionStorage.removeItem('orderId');
		sessionStorage.removeItem('lang');
		sessionStorage.removeItem('inventoryDeadline');
	}

	cleanCart = async (cart) => {
		if (document.querySelector(hostSelect.cartElement) && !document.querySelector(hostSelect.cartElement).style.visibility !== "hidden") document.querySelector(hostSelect.cartElement).style.visibility = "hidden";

		const reverseCart = cart.reverse();
		for (let lineCart of reverseCart) {
			cl("cleanCart => delete cart line " + lineCart.indexLine);
			if (lineCart.indexLine === 1) await this.updateCartQuantity(lineCart.indexLine, 0, lineCart.quantity, 0, "cart", true);
			else await this.updateCartQuantity(lineCart.indexLine, 0, lineCart.quantity, lineCart.price, "line", false);
		}
	}
	/////////////////////////////////////////////////////////////////////////////

	/* Btns onClick */
	btnAideHandleClick = (e) => {//
		if(e && e.cancelable) e.preventDefault();
		window.open("https://www.mercigustave.co/index.php/contact/");
	}
	btnMailHandleClick = (e) => {//
		if(e && e.cancelable) e.preventDefault();
		window.open("mailto:hello@mercigustave.co");
	}

	btnFaqHandleClick = (e) => {//
		if(e && e.cancelable) e.preventDefault();
		window.open("https://www.mercigustave.co/faq/");
	}

	btnPlanHandleClick = (e) => {//
		if(e && e.cancelable) e.preventDefault();
		window.open("https://mercigustave-delivery.netlify.app?orderId=" + this.state.client.orderId + "&lang=" + this.state.appLang);
	}

	ftfTsHandleClick = (e) => {//
		if(e && e.cancelable) e.preventDefault();
		window.open("https://www.facetofaceparis.com/merci-gustave/");
	}

	ManouchBtnTryHandleClick = (e) => {
		if (e && e.cancelable) e.preventDefault();
		document.querySelector("#add_to_cart").classList.add("inactive");
		document.querySelector('#newBanner').classList.add("active", "product__size--active");
	}

	btnTryHandleClick = (e) => {//
		if(e && e.cancelable && e.target.id.indexOf("try-btn") !== -1) e.preventDefault();
		//cl("btnTryHandleClick => addToCabine");
		this.eventWidget('clic sur essayer gratuitement', 'ESSAYER GRATUITEMENT');
		this.addToCabine(e, "add", 'clic sur essayer gratuitement');
	}

	btnCartHandleClick = (e) => {//
		if(e.cancelable) e.preventDefault();

		let cart = this.state.cart;

		if(pageProduct) {
			if(cart.length === 0) this.eventWidget('clic sur le cintre / page produit / cabine vide', 'CLIC SUR CABINE');
			else this.eventWidget('clic sur le cintre / page produit / cabine avec article(s)', 'CLIC SUR CABINE');
		} else {
			if(cart.length === 0) this.eventWidget('clic sur le cintre / page non produit / cabine vide', 'CLIC SUR CABINE');
			else this.eventWidget('clic sur le cintre / page non produit / cabine avec article(s)', 'CLIC SUR CABINE');
		}

		saveInfos.workflowStep = '1'; saveInfos.orderStep = 0;
		this.pagesVues(saveInfos.workflowStep, saveInfos.orderStep);
		this.setState({orderStep: saveInfos.orderStep, workflowStep: saveInfos.workflowStep}, () => {
			this.showOverlay(null);
		});
	}

	btnArrowLeftHandleClick = (e) => {//
		if (e.cancelable) e.preventDefault();
		let {orderStep} = this.state;
		if (lastStep === 2) lastStep = null;

		if (this.state.duplicatedCartIcon) {
			saveInfos.workflowStep = '1'; saveInfos.orderStep = 0;

		} else {
			if (orderStep > 0) { // si orderstep
				saveInfos.workflowStep = '1'; saveInfos.orderStep = orderStep - 1;

			} else {
				saveInfos.workflowStep = '0'; saveInfos.orderStep = 0;
			}
		}
		this.pagesVues(saveInfos.workflowStep, saveInfos.orderStep);
		this.setState({workflowStep: saveInfos.workflowStep, orderStep: saveInfos.orderStep});
	}

	btnCloseWidgetHandleClick = (e) => {//
		if(e.cancelable) e.preventDefault();
		this.hideOverlay();
		this.eventWidget('clic sur la croix pour fermer', 'FERMER WIDGET')
	}

	btnCcmEssayerHandleClick = (e) => {//
		if(e.cancelable) e.preventDefault();
		let cart = this.state.cart;
		this.eventWidget('clic sur Essayer sur le SLIDE Comment ça marche', 'BOUTON ESSAYER SLIDE Comment ça marche');

		if (!this.state.client.orderId) {
			if(pageProduct && !urlsExcluded(hostSelect) && cart.length === 0) { // si page produit et page non exclue
				this.addToCabine(e, "add", 'clic sur Essayer sur le SLIDE Comment ça marche');

			} else if(cart.length > 0) { // si article(s) dans cabine, on l'affiche
				saveInfos.workflowStep = '1'; saveInfos.orderStep = 0;
				this.pagesVues(saveInfos.workflowStep, saveInfos.orderStep);
				this.setState({workflowStep: saveInfos.workflowStep, orderStep: saveInfos.orderStep});

			} else { // sinon rdv page produit et on ferme le widget
				if (urlsExcluded(hostSelect)) alert(langSelect("alnonprod", this.state));
				else alert(langSelect("alnonpage", this.state));
				this.hideOverlay();
			}
		} else {
			saveInfos.workflowStep = '1'; saveInfos.orderStep = 2;
			this.setState({workflowStep: saveInfos.workflowStep, orderStep: saveInfos.orderStep});
		}
	}

	btnCabDelArtHandleClick = (e) => {//
		if (e.cancelable) e.preventDefault();
		this.eventWidget('clic supprimer article sur le SLIDE Cabine', 'SUPPRIME ARTICLE CABINE');
		let cart = this.state.cart;
		const idProductToDelete = e.target.getAttribute("idproduct");
		cl("btnCabDelArtHandleClick => product : " + idProductToDelete);
		if (!ifIsShopify) {
			cart = cart.filter(obj => obj.id !== idProductToDelete);
			if (hostSelect && !hostSelect.saveCart) localStorage.setItem('gustave-cart', JSON.stringify(cart));
			this.setState({cart: cart});

		} else if (ifIsShopify) {
			this.disableBtnsQuantity(true);
			const product = cart.find(obj => obj.id === idProductToDelete);
			if (product) {
				this.updateCartQuantity(product.indexLine, 0, product.quantity, product.priceProduct, (cart.length > 1? "line" : "cart"), true)
				.then(() => cl("updateCartQuantity => ok"))
				.catch(error => cl(["updateCartQuantity => error :\n", error]));
			}
		}
	}

	btnCabPlanMonEssHandleClick = (e) => {//
		if (e.cancelable) e.preventDefault();

		if (this.state.desactivateDelivery && !hostSelect.reactivateDelivery) {
			alert(this.state.desactivateMsg[this.state.appLang]);

		} else {
			this.eventWidget('clic Planifier mon essayage sur le SLIDE Cabine', 'PLANIFIE ESSAYAGE');

			const {cart, maxProductNumber} = this.state;
			const productNumber = cart.reduce((total, nbr) => total + (nbr.quantity > 0? +nbr.quantity : 1), 0);

			if (productNumber > 0 && productNumber <= maxProductNumber) {
				saveInfos.workflowStep = '1'; saveInfos.orderStep = 1;
				this.pagesVues(saveInfos.workflowStep, saveInfos.orderStep);
				this.setState({ workflowStep: saveInfos.workflowStep, orderStep: saveInfos.orderStep, showSteps: true}, () => {
				});

			} else if (productNumber > maxProductNumber) {
				const tooNum = productNumber - maxProductNumber;
				alert(langSelect("msgmaxart", this.state).split("*")[0] + " ("+maxProductNumberRef+") " + langSelect("msgmaxart", this.state).split("*")[1] + " " + tooNum + " " + langSelect("msgmaxart", this.state).split("*")[2] + (tooNum > 1? "s " : " ") + langSelect("msgmaxart", this.state).split("*")[3]);
			}
		}
	}

	btnCabCcmHandleClick = (e) => {//
		if (e.cancelable) e.preventDefault();
		this.eventWidget('clic comment ça marche sur le SLIDE Cabine', 'COMMENT CA MARCHE');
		saveInfos.workflowStep = '0'; saveInfos.orderStep = 0;
		this.pagesVues(saveInfos.workflowStep, saveInfos.orderStep);
		this.setState({ workflowStep: saveInfos.workflowStep, orderStep: saveInfos.orderStep});
	}

	btnStepHandleClick = (e) => {//
		if (e.cancelable) e.preventDefault();
		if (e.target.classList.contains("order-step")) {
			const order = +(e.target.id.split("btn-order")[1]);
			const {cart, orderStep, client} = this.state;
			if(orderStep !== order) {
				if(orderStep === 1 && order === 2) {
					if(client.infos.firstName && client.infos.familyName && client.infos.email && client.infos.email.indexOf('@')!==-1 && client.infos.email.indexOf('.')!==-1 && client.infos.phoneNumber && this.isTelephoneValide(client.infos.phoneNumber) && client.address.main && client.infos.villeSelect) {
						// conditions suivant slide infos
						this.inputsInfosTest(null);
						this.infSuivantHandleClick(e, 'clic sur le Step ' + e.target.title, 'CLIC ORDERSTEP');
					} else {
						this.inputsInfosTest(null);
					}
				} else if (orderStep === 0 && order === 1) {
					if (cart.length > 0) {
						saveInfos.orderStep = order;
						this.pagesVues(saveInfos.workflowStep, saveInfos.orderStep);
						this.setState({orderStep: saveInfos.orderStep});
					}

				} else if (!client.orderId) {
					saveInfos.orderStep = order;
					this.pagesVues(saveInfos.workflowStep, saveInfos.orderStep);
					this.setState({orderStep: saveInfos.orderStep});
				}
			}
		}
	}

	inputsInfosTest = (e) => {
		const client = this.state.client;
		if(!e) {
			if( (!client.infos.firstName && !client.infos.familyName && !client.infos.email && !client.infos.phoneNumber) || (client.infos.firstName && client.infos.familyName && client.infos.email && client.infos.phoneNumber) )  infosManquantes = false
			else if(!client.infos.firstName || !client.infos.familyName || !client.infos.email || !client.infos.phoneNumber) {
				//cl("target btn suivant ou step")
				if(!client.infos.firstName) domRoot.querySelector("#prenomInput").style.borderColor = "red"
				else domRoot.querySelector("#prenomInput").style.borderColor = "#d9d9d9"

				if(!client.infos.familyName) domRoot.querySelector("#nomInput").style.borderColor = "red"
				else domRoot.querySelector("#nomInput").style.borderColor = "#d9d9d9"

				if(!client.infos.email) domRoot.querySelector("#emailInput").style.borderColor = "red"
				else domRoot.querySelector("#emailInput").style.borderColor = "#d9d9d9"

				if(!client.infos.phoneNumber) domRoot.querySelector("#telInput").style.borderColor = "red"
				else domRoot.querySelector("#telInput").style.borderColor = "#d9d9d9"
			}
		} else {
			if(e.target.value.length >= 1) {
				e.target.style.borderColor = "#d9d9d9"
			} else {
				e.target.style.borderColor = "red"
				infosManquantes = true
			}

			if(client.infos.firstName && client.infos.familyName && client.infos.email && client.infos.phoneNumber) infosManquantes = false
		}
	}

	infPrecedentHandleClick = (e, eventAction, eventLabel) => {//
		if (e.cancelable) e.preventDefault();
		this.eventWidget(eventAction, eventLabel);

		saveInfos.orderStep = 0;
		this.pagesVues(saveInfos.workflowStep, saveInfos.orderStep);
		this.setState({orderStep: saveInfos.orderStep});
	}

	infSuivantHandleClick = (e, eventAction, eventLabel) => {//
		if (e.cancelable) e.preventDefault();
		this.eventWidget(eventAction, eventLabel);
		saveInfos.orderStep = 2;
		this.pagesVues(saveInfos.workflowStep, saveInfos.orderStep);
		this.setState({orderStep: saveInfos.orderStep});
	}

	handleCloseClick  = (e) => {//
		if(e.cancelable) e.preventDefault();
		if(e.target.getAttribute("id") === "overlay") {
			this.hideOverlay();
			this.eventWidget("clic sur l'overlay pour fermer", 'FERMER WIDGET');
		}
	}

	// FX
	cabSubTitleDyn = (active, productsNumberToAdd) => {

		stopInterval();

		if (active) {
			//cl("affichage du texte dynamique");
			const phrases = {
				ph0: langSelect("resTxt1", this.state).indexOf("*") !== -1? langSelect("resTxt1", this.state).split("*")[0] + productsNumberToAdd + langSelect("resTxt1", this.state).split("*")[1] + (productsNumberToAdd > 1? 's.' : '.') : langSelect("resTxt1", this.state),
				ph1: langSelect("resTxt2", this.state)
			}

			let i = 0;
			if (domRoot.querySelector("p.restant-txt")) domRoot.querySelector("p.restant-txt").innerText = phrases["ph" + i];

			cabDynInterval = setInterval(() => {
				phrases.ph0 = langSelect("resTxt1", this.state).indexOf("*") !== -1? langSelect("resTxt1", this.state).split("*")[0] + productsNumberToAdd + langSelect("resTxt1", this.state).split("*")[1] + (productsNumberToAdd > 1? 's.' : '.') : langSelect("resTxt1", this.state);
				phrases.ph1 = langSelect("resTxt2", this.state);

				if (domRoot.querySelector("p.restant-txt")) domRoot.querySelector("p.restant-txt").innerText = phrases["ph" + i];

				setTimeout(() => { // vide l'innerText pour le clignotement
					if (domRoot.querySelector("p.restant-txt")) domRoot.querySelector("p.restant-txt").innerText = " ";
				}, 2800);

				i = i === 0? 1 : 0;

			}, 3000);
		}

		function stopInterval() {
			if (cabDynInterval) {
				clearInterval(cabDynInterval);
				cabDynInterval = null;
				//if (that.state.workflowStep === '1' && that.state.orderStep === 0) cl("arrêt du texte dynamique");
			}
		}
	}

	render() {

		const {cart, client, orderStep, workflowStep, prixTotalCart, reduc, promoCode, appLang, msgEmptyCab, msgsClosed, frais, cosmetsProduct, optionsProduct, noelsProduct, cartBadgeStyles, productsNumberToAdd, showSteps, desactivateDelivery, desactivateMsg, widgetSubTitle, inventoryDeadline} = this.state;

		return (
			<div>

				{!ifIsShopify && document.querySelector("#gustave-cart") && <div id="cartBadge" style={{display: cart && cart.length > 0? "flex" : "none", ...cartBadgeStyles}}>{cart.length}</div>}

				<div id="overlay" onClick={(e) => { if(!this.state.stripeLoading) this.handleCloseClick(e); }}>

					<div id="widget" onKeyDown={this.handleKeyDown} tabIndex="0">

						<div id="mgHeader">

							{workflowStep === '1' && <Button id="btn-ccm" title={langSelect("cabbtnhow", this.state)} style={{padding: 5, cursor:"pointer", width: 26, zIndex: 50}}
								onClick={(e) => {
									e.preventDefault();
									if(!iosLoad && !this.state.stripeLoading) this.btnCabCcmHandleClick(e);
								}}><span style={{width: 14}}>?</span></Button>
							}

							<div style={{display:'flex',justifyContent:'center', width:'100%', position: 'absolute', top: (desactivateDelivery? (window.innerWidth <= 408? '-24px' : '-10px') : '0px')}}>
								<div className="widget-title">

									<span className="strongFont" style={{textDecoration:'underline'}}>{langSelect("slidetitle", this.state)}</span>

									{!widgetSubTitle && !desactivateDelivery && (workflowStep !== '1' || orderStep > 0 || (workflowStep === '1' && (cart.length === 0 || productsNumberToAdd <= 0))) && <p className="txt-subtitle" style={{color: productsNumberToAdd < 0? 'red' : '#000'}}>
										{langSelect(workflowStep !== '1' || orderStep > 0 || cart.length === 0? "slidesubtitle" : (productsNumberToAdd === 0? "resTxtOk" : "resTxtNoMore"), this.state)}
									</p>}

									{!widgetSubTitle && !desactivateDelivery && workflowStep === '1' && orderStep === 0 && productsNumberToAdd > 0 && <p className="restant-txt"></p>}

									{!widgetSubTitle && desactivateDelivery && workflowStep !== '0' && <p className="txt-subtitle txt-desactiveDelivery">{desactivateMsg[appLang]}</p>}

									{widgetSubTitle && workflowStep !== '0' && <p className="txt-subtitle widget-sub-title">{widgetSubTitle[appLang]}</p>}
								</div>
							</div>

							<Button id="btn-close" style={{padding: 5, zIndex: 50}}
								onClick={(e) => {if(!this.state.stripeLoading) this.btnCloseWidgetHandleClick(e)}}>
								<Icon type="close" />
							</Button>

						</div>

						<div className="content">

							{/* slide comment ça marche */}
							{workflowStep === '0' && (<div style={{display: 'flex', justifyContent:'space-between', alignItems: 'center', flexDirection: 'column', flex: 1, width: '100%'}}>

								<div className="slide1">
									<div style={{ display:'flex',alignItems:'center', justifyContent:'flex-start'}} className="txts-slide">
										<div className="cercleNum" >1</div>
										<div className="txt-slide-1">
											<div>
											{langSelect("ccmp1", this.state).split("*")[0]} <span className="strongFont">{langSelect("ccmp1", this.state).split("*")[1]}</span></div>
										</div>
									</div>
									<div style={{ display:'flex',alignItems:'center', justifyContent:'flex-start'}} className="txts-slide">
										<div className="cercleNum" >2</div>
										<div className="txt-slide-1">
											<div>
												{langSelect("ccmp2", this.state).split("*")[0]} <span className="strongFont">{langSelect("ccmp2", this.state).split("*")[1]}</span>
											</div>
										</div>
									</div>
									<div style={{ display:'flex',alignItems:'center', justifyContent:'flex-start'}} className="txts-slide">
										<div className="cercleNum">3</div>
										<div className="txt-slide-1">
											<div>
												{langSelect("ccmp3", this.state).split("*")[0]} <span className="strongFont">{langSelect("ccmp3", this.state).split("*")[1]}</span> {langSelect("ccmp3", this.state).split("*")[2]}</div>
										</div>
									</div>
									<div style={{ display:'flex',alignItems:'center', justifyContent:'flex-start'}} className="txts-slide">
										<div className="cercleNum">4</div>
										<div className="txt-slide-1">
											<div>
												{langSelect("ccmp4", this.state).split("*")[0]} <span className="strongFont">{langSelect("ccmp4", this.state).split("*")[1]}</span> {langSelect("ccmp4", this.state).split("*")[2]}
											</div>
											{hostSelect && hostSelect.frais && <div className="fees-infos-txt">
												{langSelect("ccmp4fee", this.state)}
											</div>}
										</div>
									</div>

									<div className="servDispoVilles">{langSelect("ccmplaces", this.state)}</div>
								</div>

								{!ifIsShopify && <div style={{bottom: '8px'}}>
									<Button id="btn-essayer" className="widget-btns" type='primary' style={{cursor:'pointer'}}
									onClick={(e) => this.btnCcmEssayerHandleClick(e)}>{langSelect("ccmbtn", this.state)}</Button>
								</div>}

								{!client.orderId && ifIsShopify && <div className="slide1-btns" style={{bottom: '0'}}>
									<Button id="btn-shopping" type='primary' onClick={(e) => this.hideOverlay()}>{langSelect("ccmbtnshopping", this.state)}</Button>
									<Button id="btn-voirPanier" type='primary' onClick={(e) => {
										saveInfos.workflowStep = '1'; saveInfos.orderStep = 0;
										this.setState({ workflowStep: saveInfos.workflowStep, orderStep: saveInfos.orderStep, showSteps: false});
									}}>{langSelect("ccmbtncart", this.state)}</Button>
								</div>}

							</div>)}

							{/* slide panier, infos, et validation */}
							{workflowStep === '1' && (<div style={{flex: '1 1 100%', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>

								{!client.orderId && showSteps && orderStep > 0 && <div className="div-steps">
									<Steps className="order-steps" size='small' current={orderStep}>
										{steps.map(item => <Step id={"btn-order"+item.order} className="order-step" key={item.order} title={langSelect(item.title, this.state)}
										onClick={(e) => {if(!this.state.stripeLoading) this.btnStepHandleClick(e)}}/>)}
									</Steps>
								</div>}

								<div className="div-orders" style={{top: orderStep === 0? '6px' : (orderStep === 1? '72px' : (!client.orderId? '64px' : '32px'))}}>

									{/* slide panier */}
									{!client.orderId && orderStep === 0 && (<div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>

										<div className="cab-all-products" style={{height: hostSelect.frais? '276px' : '296px'}}>
											{msgsClosed && <p className="indispos-txt">
												{msgsClosed[appLang].split("*")[0]} {window.innerWidth>=400 && <br/>}{msgsClosed[appLang].split("*")[1]}
											</p>}

											{msgEmptyCab && <div id="div-msgCabEmpty">
												<img className="cintre-anime" src={URL_CONFIG + '/widget/assets/cintreanim.gif'} alt="" />
												<div>{langSelect("msgempt", this.state).split("*")[0]}</div>
												<div>{langSelect("msgempt", this.state).split("*")[1]}</div>
												<div>{langSelect("msgempt", this.state).split("*")[2]}</div>
											</div>}

											{cart.map(product => {
												return (
													<div className="cab-product" key={product.id}>
														<div style={{display:'flex', width: '100%'}}>
															<div className="cab-div-img">
																<img className="cab-img" src={product.image} alt={product.name} title={product.name}/>
															</div>
															<div className="cab-txts">
																<div className="cab-title">
																	<span className="strongFont">{product.name}</span>
																</div>
																<div>
																	{product.color && <div className="cab-color">{`${langSelect("cabcol", this.state)} ${product.color}`}</div>}
																</div>
																<div>
																	{product.size && <div className="cab-size">{`${langSelect("cabsiz", this.state)} ${product.size}`}</div>}
																</div>
																{product.options2 && product.options2.length >= 1 && <div>
																	{product.options2.map((option, index)=>{
																			return(
																				<div className="cab-options">{`${langSelect(option.nom, this.state)} ${option.value}`}</div>
																			)
																		})}
																</div>}

																{!ifIsShopify && <div className="cab-price">
																	<div>{formatNumAfterCom(product.price).replace(".", ",")} €</div>
																</div>}

																{ifIsShopify && <div className="cab-price">
																	<div style={{display: 'flex', alignItems: 'flex-start'}}>
																		<span style={{display: 'flex', alignItems: 'flex-start', margin: '0 5px'}}>
																			<button setQuantity={product.quantity - 1} className="btns_quantity" style={{lineHeight: '18px'}} onClick={e => {if (!btnsQuantityDisabled) this.changeQuantity("-", product)}}>-</button>
																			<span style={{margin: '0 1px', pointerEvents: 'none', border: '1px solid #AAA', padding: '0 6px', height: 20}}>{product.quantity}</span>
																			<button setQuantity={product.quantity + 1} className="btns_quantity" onClick={e => {if (!btnsQuantityDisabled) this.changeQuantity("+", product)}}>+</button>
																		</span>
																		<span> x {formatNumAfterCom(product.priceProduct).replace(".", ",")} €</span>
																	</div>
																</div>}

																{product.info && <div className={product.classInfo}>
																	{`${langSelect(product.info, this.state)}`}
																</div>}

															</div>
														</div>
														<div style={{display:'flex',alignItems:'center', width: 32}}>
															<div className="btn-delete" idProduct={product.id} style={{cursor:'pointer'}}
															onClick={(e) => {
																if (!btnsQuantityDisabled) this.btnCabDelArtHandleClick(e);
															}}><Icon type="close"/></div>
														</div>
													</div>
												)
											})}
										</div>

										{!msgEmptyCab && <div className="cab-infos">
											<div>{langSelect("cabval", this.state)} {formatNumAfterCom(prixTotalCart).replace(".", ",")} €</div>
											{frais && <div>
														{langSelect("ccmp4feecab", this.state)} €
													</div>}
											<div id="cabPayInf"><span className="strongFont">{langSelect("cabpay", this.state)} 0 €</span></div>
										</div>}

										<div className="cab-btns">
											<div style={{ flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>

												<div id="promo-div">
													<div>
														<Input id="inputPromo" placeholder={langSelect("promoinputLab", this.state)} value={promoCode}  onChange={e=>this.setState({promoCode: e.target.value})} onKeyDown={this.handleKeyDown} name="codepromo"/>
														<Button id="checkPromo" type='primary' disabled={!this.state.promoCode} style={{ display: this.state.reduc? "none" : "flex"}} onClick={(e) => {if(this.state.promoCode && this.state.promoCode.trim() !== "") this.promoValHandleClick(e)}}>{">"}</Button>
													</div>
													{promoCode && reduc && <FontAwesomeIcon className="checkStyle" icon="check" />}
												</div>

												<Button id="cab-btnPlanifier" className="widget-btns"  type='primary' disabled={!(cart.length > 0)} onClick={(e) => this.btnCabPlanMonEssHandleClick(e)}>{langSelect("tryBtnCab", this.state).replace("> ", "").replace("gratuitement chez vous", "gratuitement")}</Button>
											</div>
										</div>

										<div className="sub-btns">
											<div className="ccm-txt" onClick={(e) => this.hideOverlay()}>
												{langSelect("cabbtnshop", this.state)}
											</div>
										</div>

									</div>)}

									{/* slide infos */}
									{!client.orderId && orderStep === 1 && (<div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
										<div style={{display:'flex',justifyContent:'space-between'}}>
											<div style={{position:'relative',width:'47%'}}>
												<Input id="prenomInput" placeholder={langSelect("inffpo", this.state)+' *'} value={client.infos.firstName || ''}
												onBlur={e=>{
													this.inputsInfosTest(e);
													if (e.target.value.trim().length >= 1) this.setState({client:{...client,infos:{...client.infos, firstName: e.target.value}}});
												}} onKeyDown={this.handleKeyDown} name="firstName"/>
												{client.infos.firstName && client.infos.firstName.trim().length >= 1 && <FontAwesomeIcon className="checkStyle" icon="check" />}
											</div>

											<div style={{position:'relative',width:'47%'}}>
												<Input id="nomInput" placeholder={langSelect("inflpo", this.state)+' *'} value={client.infos.familyName || ''}
												onBlur={e=>{
													this.inputsInfosTest(e);
													if (e.target.value.trim().length >= 1) this.setState({client: {...client, infos: {...client.infos, familyName: e.target.value}}});
												}} onKeyDown={this.handleKeyDown} name="lastName"/>
												{client.infos.familyName && client.infos.familyName.trim().length >= 1 && <FontAwesomeIcon className="checkStyle" icon="check" />}
											</div>
										</div>

										<div style={{position:'relative',marginTop:16}}>
											<Input id="emailInput" placeholder={langSelect("infepo", this.state)+' *'} value={client.infos.email || ''}
											onBlur={e=>{
												this.inputsInfosTest(e);
												this.setState({client: {...client, infos: {...client.infos,email: e.target.value}}});
												if (this.validateEmail(e.target.value)) this.handleSaveCommand();
											}}
											onKeyDown={this.handleKeyDown} name="email"/>

											{client.infos.email && this.validateEmail(client.infos.email) && <FontAwesomeIcon className="checkStyle" icon="check" />}

											{client.infos.email && !this.validateEmail(client.infos.email) && <span className="input-sub-msg" style={{color:'red'}}>{langSelect("msginfe", this.state)}</span>}
										</div>

										<div style={{position:'relative',marginTop:16}}>
											<Input id="telInput" maxLength="14" placeholder={langSelect("infppo", this.state)+' *'} value={client.infos.phoneNumber || ''}
											onKeyDown={this.handleKeyDown}
											onBlur={e=>{
												this.inputsInfosTest(e);
												this.setState({client: {...client, infos: {...client.infos, phoneNumber: this.formatAutoSpace(e.target.value)}}});
											}}
											onChange={e=>{
												e.target.value = this.formatAutoSpace(e.target.value);
												if (e.target.value && e.target.value.length === 14) {
													this.setState({client:{...client,infos:{...client.infos, phoneNumber: e.target.value}}});
												}
											}} name="phoneNumber"/>

											{client.infos.phoneNumber && client.infos.phoneNumber.length >= 1 && this.isTelephoneValide(client.infos.phoneNumber) && <FontAwesomeIcon className="checkStyle" icon="check" />}

											{client.infos.phoneNumber && !this.isTelephoneValide(client.infos.phoneNumber) && <span className="input-sub-msg" style={{color:'red'}}>{langSelect("msginft", this.state)}</span>}
										</div>

										<div style={{ marginTop:28}}>
											<PlacesAutocomplete
												value={client.address.main || ''}
												onChange={value=>{
													autoSuggGoogleMaps = true;
													const testAdresse = this.valideAdresse(value);
													this.setState({client: {...client, address: {...client.address, main: value, villeTest: testAdresse.villeTest, villeSelect: testAdresse.villeSelect}}});
												}}
												onSelect={value=>{
													autoSuggGoogleMaps = false;
													const testAdresse = this.valideAdresse(value);
													this.setState({client: {...client, address: {...client.address, main: value, villeTest: testAdresse.villeTest, villeSelect: testAdresse.villeSelect}}});
												}}
												searchOptions={searchOptions}>
												{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
													<div style={{position:'relative'}}>
														<Input
															{...getInputProps({
																placeholder: langSelect("livadresspo", this.state)+' *',
																className: 'location-search-input',
															})}
															id="adressInput"
															onFocus={()=>{
																autoSuggGoogleMaps = true;
															}}
															onBlur={(evt) => {
																//cl(["onBlur", saveInfos, client.address.main, "villeSelect : " + villeSelect, "villeTest : " + villeTest, "infosManquantes", infosManquantes]);
																if (autoSuggGoogleMaps) autoSuggGoogleMaps = false;
																this.inputsInfosTest(null);
																if (client.address.villeTest && !client.address.villeSelect) this.eventWidget('adresse non desservie', 'ADRESSE NON DESSERVIE');
															}}
															onKeyDown={this.handleKeyDown} name="address"/>

														{client.address.main !== "" && client.address.villeTest && client.address.villeSelect && !autoSuggGoogleMaps && <FontAwesomeIcon className="checkStyle" icon="check" />}

														{client.address.main !== "" && client.address.villeTest && client.address.villeSelect && !autoSuggGoogleMaps && <span className="input-sub-msg2">{langSelect("elig", this.state)}</span>}

														{client.address.main !== "" && !client.address.villeSelect && client.address.villeTest && !autoSuggGoogleMaps && <span className="input-sub-msg2" style={{color:'red'}}>{langSelect("msgliv", this.state)}</span>}

														{autoSuggGoogleMaps && <div className="autocomplete-dropdown-container">
															{loading && <div>{langSelect("load", this.state)}...</div>}

															{suggestions.map(suggestion => {
																const className = suggestion.active? 'suggestion-item--active' : 'suggestion-item';
																const style = suggestion.active? { backgroundColor: '#fafafa', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer'};
																return (
																<div
																{...getSuggestionItemProps(suggestion, {
																className,
																style,
																})}>
																	<span onClick={()=>{
																		this.setState({
																			client:{...client,address:{...client.address, placeId: suggestion.placeId}}
																		});
																	}}>{suggestion.description}</span>
																</div>
																);
															})}
														</div>}
													</div>
												)}
											</PlacesAutocomplete>

										</div>

										{infosManquantes && client.address.villeTest && !autoSuggGoogleMaps && <span id="infos-erreur-msg" style={{marginTop:16,color:'red', display:'block', position:'absolute', left:'1px', width:'100%', textAlign:'center'}}>{langSelect("msgmiss", this.state)}</span>}

										<div className="div-navBtns" style={{display:'flex',justifyContent:'flex-end', bottom: '32px'}}>
											<Button id="btn-precInf" className="widget-btns" type='primary' onClick={(e)=>{
												e.preventDefault()
												this.infPrecedentHandleClick(e, 'clic Précédent sur le SLIDE Infos', 'PRECEDENT')
											}}>{langSelect("prevbtn", this.state)}</Button>

											<Button id="btn-suivInf" className="widget-btns" type='primary' disabled={!client.infos.firstName || !client.infos.familyName || !client.infos.email || !this.validateEmail(client.infos.email) || !client.infos.phoneNumber || !this.isTelephoneValide(client.infos.phoneNumber) || !client.address.main || !client.address.villeSelect || !client.address.villeTest || !client.address.main} style={{marginLeft:8}} onClick={(e) => { this.infSuivantHandleClick(e, 'clic Suivant sur le SLIDE Infos', 'SUIVANT')}}>{langSelect("nextbtn", this.state)}</Button>
										</div>

									</div>)}

									{/* slide Validation */}
									{(client.orderId || orderStep === 2) && (<div className="div-stripe" style={{display:'flex',flex:1, lineHeight:'20px'}}>

											{client.orderId || (!client.orderId && this.state.stripeLoading)?

												(<div style={{width:"100%"}}>
													{client.orderId && inventoryDeadline?

														/* Validé */
														(<div style={{textAlign:'center', width:"100%"}}>
															<div id="plan-ok-txt" style={{marginBottom:8}}>
																<span className="strongFont">{langSelect("msgval1", this.state)}</span>
															</div>

															<div style={{marginBottom:16}}>
																{langSelect("msgvalorderid", this.state) + client.orderId}
															</div>

															<div id="nextStepsTitle" style={{marginBottom:8}}>
																<span className="strongFont">{langSelect("msgval2", this.state)}</span>
															</div>

															<div className="txts-lastSlide">

																<div className="txts-slide">
																	<div className="stepsNum">1.</div>
																	<div className="txt-slide-1">
																		<span>
																			{langSelect("msgval2s1", this.state).split("*")[0]}<strong>{inventoryDeadline}</strong>{langSelect("msgval2s1", this.state).split("*")[1]}
																		</span>
																	</div>
																</div>

																<div className="txts-slide">
																	<div className="stepsNum">2.</div>
																	<div className="txt-slide-1">{langSelect("msgval2s2", this.state)}</div>
																</div>

																<div className="txts-slide">
																	<div className="stepsNum"></div>
																	<div className="txt-slide-1" style={{fontStyle: 'italic'}}>
																		<div style={{textAlign: 'center'}}>
																			{langSelect("msgval3s1", this.state).split("*")[0]}<strong>{langSelect("msgval3s1", this.state).split("*")[1]}</strong>{langSelect("msgval3s1", this.state).split("*")[2]}
																		</div>
																	</div>
																</div>

																<div className="txts-slide" style={{width: '100%'}}>
																	<div className="stepsNum"></div>
																	<div className="txt-slide-1" style={{fontStyle: 'italic', width: '100%'}}>
																		<div className="faq" dangerouslySetInnerHTML={{__html: langSelect("msgval3s3", this.state)}} style={{textAlign:'center', width:"100%", position:'absolute', left: '0', bottom: '-16px'}}>
																		</div>
																	</div>
																</div>

															</div>
														</div>)
													:
														/* En cours de validation */
														(<div style={{textAlign:'center', width:"100%", marginTop:'70px'}} className="loading-slide">
															<div style={{marginBottom:32}}>
																<span className="strongFont">{langSelect("msgval4", this.state)}</span>
															</div>
															<div style={{marginBottom:16}}>
																<Icon type="loading" />
															</div>
															<div>{langSelect("msgval5", this.state)}</div>
														</div>)
													}
												</div>)
											:
												/* Formulaire stripe */
												(<div style={{display: 'flex', width: "100%", justifyContent: 'center'}}>
													<StripeContainer hostSelect={hostSelect} URL_BACK={URL_BACK} URL_CONFIG={URL_CONFIG} TXTS_FILE={TXTS_FILE} IP_IS_ADMIN={IP_IS_ADMIN} initReactGAhost={initReactGAhost} slideView={slideView} lang={lang} domRoot={domRoot} loading={this.state.stripeLoading} setOrderStep={orderStep=>this.setState({orderStep})} createPM={card=>this.createPM(card)} handleStripeInit={stripeInit=>this.handleStripeJs(stripeInit)} handleToken={token=>this.setState({token: token, stripeLoading: true}, ()=>this.handleSaveOrder(null))}/>
												</div>)
											}
										</div>
									)}

								</div>

							</div>)}

						</div>

						{(workflowStep === '0' || (workflowStep === '1' && orderStep > 0)) && !client.orderId && <a id="btnAide" href="https://www.mercigustave.co/index.php/contact/" rel="noopener noreferrer" onClick={this.btnAideHandleClick} style={{bottom: '10px'}}>{langSelect("helpbtn", this.state)}</a>}

					</div>

				</div>

				{hostReturned === "www.facetofaceparis.com" && <div>
					<button id="ftf-clone-btn" style={{display: 'none'}} onClick={(e) => this.btnTryHandleClick(e)}>
						{langSelect("tryBtn", this.state)}
					</button>

					<span id="ftf-clone-service" style={{display: 'none'}}>
						<span style={{fontWeight: 'bold'}}>{langSelect("txtService", this.state).split("*")[0]}</span><br/>{langSelect("txtService", this.state).split("*")[1]}<br/>{langSelect("txtService", this.state).split("*")[2].split(",")[0]},<a id="ftfTsLink" href="https://www.facetofaceparis.com/merci-gustave/" rel="noopener noreferrer" onClick={this.ftfTsHandleClick}>{langSelect("txtService", this.state).split("*")[2].split(",")[1]}</a>
						{cosmetsProduct && <span style={{display: 'block', marginTop: 10, fontStyle: 'italic'}}>
							{langSelect("txtService", this.state).split("*")[3]}
						</span>}
					</span>
				</div>}

				{hostReturned === "www.nolenca.com" && <div>
					<button id="nol-clone-btn" style={{display: 'none'}} onClick={(e) => this.btnTryHandleClick(e)}>
						{langSelect("tryBtn", this.state)}
					</button>

					<span id="nol-clone-service" style={{display: 'none'}}>
						<span style={{fontWeight: 'bold'}}>{langSelect("txtService", this.state).split("*")[0]}</span><br/>{langSelect("txtService", this.state).split("*")[1]}<br/>{langSelect("txtService", this.state).split("*")[2]}
						{optionsProduct && <span style={{display: 'block', marginTop: 10, fontStyle: 'italic'}}>
							{langSelect("txtService", this.state).split("*")[5]}
						</span>}
						{noelsProduct && <span style={{display: 'block', marginTop: 10, fontStyle: 'italic'}}>
							{langSelect("txtService", this.state).split("*")[3]}
						</span>}
						{!noelsProduct && !optionsProduct && <span style={{display: 'block', marginTop: 10, fontStyle: 'italic'}}>
							{langSelect("txtService", this.state).split("*")[4]}
						</span>}
					</span>
				</div>}

				{ifIsShopify && <div id="xhrResponse" style={{visibility: 'hidden', position: 'fixed', zIndex: -1}}></div>}
			</div>
		)
	}
}

export default App;

function langSelect(txt, state) {
	if (hostSelect[txt] && hostSelect[txt][state.appLang]) return hostSelect[txt][state.appLang];
	else if (TXTS_FILE && TXTS_FILE[txt] && TXTS_FILE[txt][state.appLang]) {
		let msg = TXTS_FILE[txt][state.appLang];
		if (msg.indexOf("|*|") !== -1) {
			let buildedMsg = "";
			let msgSplit = msg.split("|*|");
			msgSplit.forEach(part => {
				if (part) {
					//cl("part : " + part);
					if (part.indexOf(":var:") !== -1) {
						const type = part.split(":var:")[0];
						part = part.split(":var:")[1];
						let vartToAdd = type === "state"? state : hostSelect;
						//cl(["vartToAdd", vartToAdd]);
						if (part.indexOf(".") !== -1) {
							var props = part.split(".");
							props.forEach(prop => {
								//cl("prop : " +  prop);
								vartToAdd = vartToAdd[prop];
							});
						} else vartToAdd = vartToAdd[part];

						//cl(["TXTS_FILE => vartToAdd :", vartToAdd]);
						buildedMsg += vartToAdd;
					} else buildedMsg += part;
				}
			});
			return buildedMsg;
		} else return msg;

  } else if (state && (state.appLang !== "FR")) {
		// WIDGET
		if(txt === "slidetitle") return "Try before you buy";
		if(txt === "slidesubtitle") return "Delivery and return by courier";
		if(txt === "load") return "Loading";
		if(txt === "txtService") return hostSelect.textService[state.appLang];

		let cnLang = state.appLang === "CN";

		// BTNS
		if(txt === "tryBtn") return hostSelect.tryBtnTextEN? (cnLang? hostSelect.tryBtnTextCN : hostSelect.tryBtnTextEN) : "Try for free";
		if(txt === "tryBtnSpan") return hostSelect.tryBtnSpanEN? hostSelect.tryBtnSpanEN : "Paris only";
		if(txt === "bannTxt") return "Try our clothes at home, then pay with our new «home&nbsp;fitting&nbsp;service»";
		if(txt === "tryBtnCab") return hostSelect.cabBtnTextEN? hostSelect.cabBtnTextEN : (hostSelect.tryBtnTextEN? (cnLang? '在家试穿' : (hostSelect.tryBtnTextEN.indexOf(" (") !== -1? hostSelect.tryBtnTextEN.split(" (")[0] : hostSelect.tryBtnTextEN)) : "Try for free");
		if(txt === "tryBtnTxtHoverEmr") return "Please select size";
		if(txt === "helpbtn") return "Need help?";
		if(txt === "ccmbtn") return state.txtCcmBtnEN;
		if(txt === "ccmbtnshopping") return "Continue my shopping";
		if(txt === "ccmbtncart") return "Go to cart";
		if(txt === "cabbtnshop") return "Continue shopping";
		if(txt === "cabbtncheck") return "Check out";
		if(txt === "cabbtnhow") return "How it works?";

		if(txt === "cartTitle") return "Cart (" + state.totalArticles + ")";
		if(txt === "infosTitle") return "Information";
		if(txt === "validTitle") return "Validation";

		if(txt === "livtodlabel") return "Today";
		if(txt === "livtomlabel") return "Tomorrow";
		if(txt === "slotbtn") return "Select this time slot";
		if(txt === "nextbtn") return "Next";
		if(txt === "prevbtn") return "Previous";
		if(txt === "paybtn") return "Validate";
		if(txt === "promoBtnVal") return "Ok";
		if(txt === "promoBtnCancel") return "Cancel";


		// slide Comment ça marche
		if(txt === "ccmp1") return state.txtCcmPh1EN;
		if(txt === "ccmp2") return state.txtCcmPh2EN;
		if(txt === "ccmp3") return state.txtCcmPh3EN;
		if(txt === "ccmp4") return state.txtCcmPh4EN;
		if(txt === "ccmp4fee") return state.txtCcmPh4feeEN.split("*")[0] + hostSelect.frais + state.txtCcmPh4feeEN.split("*")[1];
		if(txt === "ccmplaces") return state.txtCcmPlacesEN;

		// slide promo
		if(txt === "promoinputLab" && window.innerWidth >= 480) return hostSelect.promoTxtEN? hostSelect.promoTxtEN : "Enter my discount code";
		else if(txt === "promoinputLab") return hostSelect.promoTxtMobileEN? hostSelect.promoTxtMobileEN : (hostSelect.promoTxtEN? hostSelect.promoTxtEN : "My discount code");

		if(txt === "resultPromo") return "Invalid code";

		// slide Cabine
		if(txt === "resTxt1") return hostSelect.cabDynTxtEN? hostSelect.cabDynTxtEN : "You can still add  * item";
		if(txt === "resTxt2") return hostSelect.frais? "Free returns from home." : "It's free and returns are from home.";
		if(txt === "resTxtOk") return "Maximum number of articles reached.";
		if(txt === "resTxtNoMore") return "Maximum number of articles exceeded.";
		if(txt === "cabcol") return "Color:";
		if(txt === "cabsiz") return "Size:";
		if(txt === "cabquant") return "Quantity:";
		if(txt && txt.toLowerCase() === "pantalon") return "Pants:";
		if(txt && txt.toLowerCase() === "veste") return "Jacket:";
		if(txt && txt.toLowerCase() === "boutons") return "Boutons:";
		if(txt === "cabval") return "Value of my fitting" + (state.reduc? " (-" + state.reduc + ")" : "") + ":";
		if(txt === "cabpay") return "Pay now:";
		if(txt === "ccmp4feecab") return state.txtCcmPh4feeCabEN + hostSelect.frais;
		if(txt === "artsale") return "Item on sale";
		if(txt === "Article soldé") return "Item on sale";
		if(txt === "promopa") return "Enter your code";

		// slide Livraison
		if(txt === "livdayslots") return "Day and slot of your delivery";
		if(txt === "livadresstitle") return "Shipping address";
		if(txt === "livadresspo") return "Address";
		if(txt === "livadressadd") return "Additional information : code, intercom, etc";
		if(txt === "elig") return state.eligibilityEN? state.eligibilityEN : "You are eligible for delivery in 24h. You will receive an email to schedule your delivery!";

		// slide Infos
		if(txt === "inftitle") return "My info";
		if(txt === "inffpo") return "First Name";
		if(txt === "inflpo") return "Last Name";
		if(txt === "infepo") return "E-mail";
		if(txt === "infppo") return "Phone number";

		// slide Validation
		if(txt === "valpinf") return "Why am I being asked my credit card information*Just to be charged*after your fitting*And only for the items you’ll decide to keep.";
		if(txt === "valcblabel") return "Card number";
		if(txt === "valexplabel") return "Expiry date";
		if(txt === "valcvvlabel") return "CVV";
		if(txt === "valcond") return "I have read and agree to the";
		if(txt === "valsectxt") return "Secured transaction";
		if(txt === "msgvalorderid") return "Fitting n°";

		// alerts messages
		if(txt === "alnonpage") return "Let’s go to a product page to start adding items to your fitting room.";
		if(txt === "alnonprod") return "This product is not available for a fitting, let’s go to an another page to start adding items to your fitting room.";
		if(txt === "alsiz") return "Oops, that size is no longer available.";
		if(txt === "alcol") return "Oops, that color is no longer available.";
		if(txt === "alopt") return "Oops, that option is no longer available.";
		if(txt === "alcomb") return "Oops, this combination is no longer available.";
		if(txt === "aloptsize") return "Please select a size before adding it to your fitting room.";
		if(txt === "aloptcol") return "Please select a color before adding it to your fitting room.";
		if(txt === "aloptsel") return "Please select an option before adding it to your fitting room.";
		if(txt === "aloptlen") return "Please select a length before adding it to your fitting room.";
		if(txt === "alopts") return "Please select some product options before adding it to your fitting room.";
		if(txt === "msgempt") return "Oops, your fitting room is empty.*Go to a product page*to add a new article.";
		if(txt === "msgliv") return "Oops, this city is not served yet.";
		if(txt === "msgmiss") return "Please fill in the missing information.";
		if(txt === "msgval1") return "Your fitting request has been registered.";
		if(txt === "msgval2") return "What are the next steps?";
		if(txt === "msgval2s1") return "You will receive, at the latest *, an email and a text message to confirm the availability of your items. You can then plan your fitting.";
		if(txt === "msgval2s2") return "You can then schedule your delivery over a 2-hour slot.";
		if(txt === "msgval3s1") return "We remind you that your credit card *has not been charged*, it will be after your fitting and only for the amount of products you decide to keep!";
		if(txt === "msgval3s2") return "A question ? Any doubt?*Go to our FAQ or write to us at *hello@mercigustave.co*, we will get back to you quickly!";
		if(txt === "msgval3s3") return 'A question ? Any doubt?<br>Go to our <a id="btnFaq" href="https://www.mercigustave.co/faq/" rel="noopener noreferrer" target="_blank">FAQ</a> or write to us at <a id="btnMail" href="mailto:hello@mercigustave.co" rel="noopener noreferrer" target="_blank">hello@mercigustave.co</a>,<br>we will get back to you quickly!';

		if(txt === "msgval4") return "Saving your order";
		if(txt === "msgval5") return "Please wait";

		if(txt === "msginfe") return "Invalid e-mail";
		if(txt === "msginft") return "Invalid phone number";
		if(txt === "msgnonplan") return "We have encountered an error related to your credit card, please check the information entered. If the problem persists, contact us at 06.74.69.48.96.";
		if(txt === "msgmaxart") return "Oops! You have exceeded the maximum number of items allowed*for your fitting. Please remove*item*if you want to try before you buy.";
		if(txt === "msgnolong") return "Sorry, this delivery slot is no longer available.";
		if(txt === "msgchoix") return "Please choose a time slot available for delivery.";

		if(txt) return txt;
	} else if ((state && state.appLang === "FR") || !state) {
		// WIDGET
		if(txt === "slidetitle") return "Essayez d'abord, payez après";
		if(txt === "slidesubtitle") return "Livraison et retour par coursier";
		if(txt === "load") return "Chargement";
		if(txt === "txtService") return hostSelect.textService.FR;

		// BTNS
		if(txt === "tryBtn") return hostSelect.tryBtnText? hostSelect.tryBtnText : "Essayer gratuitement";
		if(txt === "tryBtnSpan") return hostSelect.tryBtnSpan? hostSelect.tryBtnSpan : "Paris uniquement";
		if(txt === "bannTxt") return "Essayez nos vêtements chez vous, payez ensuite avec notre nouveau service «&nbsp;essayage&nbsp;à&nbsp;domicile&nbsp;»";
		if(txt === "tryBtnCab") return hostSelect.cabBtnText? hostSelect.cabBtnText : (hostSelect.tryBtnText? (hostSelect.tryBtnText.indexOf(" (") !== -1? hostSelect.tryBtnText.split(" (")[0] : hostSelect.tryBtnText) : "Essayer gratuitement");
		if(txt === "tryBtnTxtHoverEmr") return "Veuillez sélectionner une taille";
		if(txt === "helpbtn") return "Besoin d'aide ?";
		if(txt === "ccmbtn") return state.txtCcmBtn;
		if(txt === "ccmbtnshopping") return "Continuer mon shopping";
		if(txt === "ccmbtncart") return "Voir mon panier";
		if(txt === "cabbtnshop") return "Continuer mon shopping";
		if(txt === "cabbtncheck") return "Planifier mon essayage";
		if(txt === "cabbtnhow") return "Comment ça marche ?";

		if(txt === "cartTitle") return "Panier (" + state.totalArticles + ")";
		if(txt === "infosTitle") return "Infos";
		if(txt === "validTitle") return "Validation";

		if(txt === "livtodlabel") return "aujourd'hui";
		if(txt === "livtomlabel") return "demain";
		if(txt === "slotbtn") return "Choisir ce créneau";
		if(txt === "nextbtn") return "Suivant";
		if(txt === "prevbtn") return "Précédent";
		if(txt === "paybtn") return "Valider";
		if(txt === "promoBtnVal") return "Ok";
		if(txt === "promoBtnCancel") return "Annuler";


		// slide Comment ça marche
		if(txt === "ccmp1") return state.txtCcmPh1;
		if(txt === "ccmp2") return state.txtCcmPh2;
		if(txt === "ccmp3") return state.txtCcmPh3;
		if(txt === "ccmp4") return state.txtCcmPh4;
		if(txt === "ccmp4fee") return state.txtCcmPh4fee.split("*")[0] + hostSelect.frais + state.txtCcmPh4fee.split("*")[1];
		if(txt === "ccmplaces") return state.txtCcmPlaces;

		// slide promo
		if(txt === "promoinputLab" && window.innerWidth >= 480) return hostSelect.promoTxt? hostSelect.promoTxt : "Entrer mon code promo";
		else if(txt === "promoinputLab") return hostSelect.promoTxtMobile? hostSelect.promoTxtMobile : (hostSelect.promoTxt? hostSelect.promoTxt : "Code promo");
		if(txt === "resultPromo") return "Code invalide";


		// slide Cabine
		if(txt === "resTxt1") return hostSelect.cabDynTxtFR? hostSelect.cabDynTxtFR : "Vous pouvez encore ajouter * article";
		if(txt === "resTxt2") return hostSelect.frais? (hostSelect.resTxt2? hostSelect.resTxt2 : "Retours gratuits depuis chez vous.") : "C'est gratuit et les retours se font depuis chez vous.";
		if(txt === "resTxtOk") return "Nombre maximum d'articles atteint.";
		if(txt === "resTxtNoMore") return "Nombre maximum d'articles dépassé.";
		if(txt === "cabcol") return "Couleur :";
		if(txt === "cabsiz") return "Taille :";
		if(txt === "cabquant") return "Quantité :";
		if(txt && (txt.toLowerCase() === "taille pantalon" || txt.toLowerCase() === "taille veste")) return txt.split(" ")[1] + " ";
		if(txt && txt.toLowerCase() === "pants") return "Pantalon :";
		if(txt && txt.toLowerCase() === "jacket") return "Veste :";
		if(txt && txt.toLowerCase() === "boutons") return "Boutons :";
		if(txt === "cabval") return "Valeur de mon essayage " + (state.reduc? "(-" + state.reduc + ") :" : ":");
		if(txt === "cabpay") return "A payer maintenant :";
		if(txt === "ccmp4feecab") return state.txtCcmPh4feeCab + hostSelect.frais;
		if(txt === "artsale") return "Article soldé";
		if(txt === "Item on sale") return "Article soldé";
		if(txt === "promopa") return "Entrer votre code";


		// slide Livraison
		if(txt === "livdayslots") return "Jour et heure de livraison";
		if(txt === "livadresstitle") return "Adresse de livraison";
		if(txt === "livadresspo") return "Adresse";
		if(txt === "livadressadd") return "Infos complémentaires: code, interphone, étage, etc";
		if(txt === "elig") return state.eligibility? state.eligibility : "Vous êtes éligible à la livraison en 24h. Vous recevrez un email pour programmer votre livraison !";

		// slide Infos
		if(txt === "inftitle") return "Mes infos";
		if(txt === "inffpo") return "Prénom";
		if(txt === "inflpo") return "Nom";
		if(txt === "infepo") return "Email";
		if(txt === "infppo") return "Téléphone";

		// slide Validation
		if(txt === "valpinf") return "Pourquoi me demande-t-on ma carte*Tout simplement pour pouvoir vous débiter*après votre essayage*Et uniquement pour les articles que vous déciderez de garder.";
		if(txt === "valcblabel") return "Numéro de la carte";
		if(txt === "valexplabel") return "Expiration";
		if(txt === "valcvvlabel") return "CVC";
		if(txt === "valcond") return "J'ai lu et j'accepte les";
		if(txt === "valsectxt") return "Transaction sécurisée";
		if(txt === "msgvalorderid") return "Essayage n° ";

		// alerts messages
		if(txt === "alnonpage") return "Rendez-vous sur une page produit pour commencer à ajouter des articles à votre essayage.";
		if(txt === "alnonprod") return "Ce produit n'est pas disponible pour un essayage, rendez-vous sur une autre page pour commencer à ajouter des articles à votre essayage.";
		if(txt === "alsiz") return "Oups, cette taille n'est plus disponible.";
		if(txt === "alcol") return "Oups, cette couleur n'est plus disponible.";
		if(txt === "alopt") return "Oups, cette option n'est plus disponible..";
		if(txt === "alcomb") return "Oups, cette combinaison n'est plus disponible.";
		if(txt === "aloptcol") return "Veuillez choisir une couleur pour pouvoir ajouter le produit à la cabine.";
		if(txt === "aloptsize") return "Veuillez choisir une taille pour pouvoir ajouter le produit à la cabine.";
		if(txt === "aloptsel") return "Veuillez choisir une option pour pouvoir ajouter le produit à la cabine.";
		if(txt === "aloptopt") return "Veuillez sélectionner*pour pouvoir ajouter le produit à la cabine.";
		if(txt === "alopts") return "Veuillez choisir une combinaison pour pouvoir ajouter le produit à la cabine.";
		if(txt === "msgempt") return "Oups, votre cabine est vide.*Rendez-vous sur une fiche produit*pour ajouter un nouvel article.";
		if(txt === "msgliv") return "Oups, cette ville n'est pas encore desservie.";
		if(txt === "msgmiss") return "Veuillez renseigner les informations manquantes.";

		if(txt === "msgval1") return "Votre demande d'essayage a bien été enregistrée.";
		if(txt === "msgval2") return "Quelles sont les prochaines étapes de mon essayage ?";
		if(txt === "msgval2s1") return "Vous recevrez, au plus tard le *, un email et un SMS confirmant la disponibilité de vos articles.";
		if(txt === "msgval2s2") return "Vous pourrez dès lors planifier votre livraison sur un créneau de 2h.";
		if(txt === "msgval3s1") return "Nous vous rappelons que votre carte bleue *n’a pas été débitée*, elle le sera après votre essayage et uniquement du montant des articles que vous déciderez de garder !";
		if(txt === "msgval3s2") return "Une question ? Un doute ?*Rendez-vous sur notre FAQ ou écrivez-nous à *hello@mercigustave.co*, nous vous répondrons rapidement !";
		if(txt === "msgval3s3") return 'Une question ? Un doute ?<br>Rendez-vous sur notre <a id="btnFaq" href="https://www.mercigustave.co/faq/" rel="noopener noreferrer" target="_blank">FAQ</a> ou écrivez-nous à <a id="btnMail" href="mailto:hello@mercigustave.co" rel="noopener noreferrer" target="_blank">hello@mercigustave.co</a>,<br>nous vous répondrons rapidement !';

		if(txt === "msgval4") return "Enregistrement de votre commande";
		if(txt === "msgval5") return "Veuillez patienter";

		if(txt === "msginfe") return "Email invalide";
		if(txt === "msginft") return "Téléphone invalide";
		if(txt === "msgnonplan") return "Nous avons rencontré une erreur liée à votre carte bancaire, merci de vérifier les informations saisies. Si le problème persiste, contactez nous au 06.74.69.48.96.";
		if(txt === "msgmaxart") return "Oups ! Vous avez dépassé le nombre d'articles maximum*pour l'essayage. Veuillez retirer*article*si vous souhaitez essayer avant d'acheter.";
		if(txt === "msgnolong") return "Désolé, ce créneau de livraison n'est plus disponible.";
		if(txt === "msgchoix") return "Merci de choisir une plage horaire disponible pour la livraison.";

		if(txt) return txt;
  }
}
